export const SearchIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5 21.75C5.85 21.75 1.25 17.15 1.25 11.5C1.25 5.85 5.85 1.25 11.5 1.25C17.15 1.25 21.75 5.85 21.75 11.5C21.75 17.15 17.15 21.75 11.5 21.75ZM11.5 2.75C6.67 2.75 2.75 6.68 2.75 11.5C2.75 16.32 6.67 20.25 11.5 20.25C16.33 20.25 20.25 16.32 20.25 11.5C20.25 6.68 16.33 2.75 11.5 2.75Z"
          fill="#6D77A0"
        />
        <path
          d="M22.0014 22.75C21.8114 22.75 21.6214 22.68 21.4714 22.53L19.4714 20.53C19.1814 20.24 19.1814 19.76 19.4714 19.47C19.7614 19.18 20.2414 19.18 20.5314 19.47L22.5314 21.47C22.8214 21.76 22.8214 22.24 22.5314 22.53C22.3814 22.68 22.1914 22.75 22.0014 22.75Z"
          fill="#6D77A0"
        />
      </svg>
    </>
  );
};
export const HubspotIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_44827)">
          <path
            d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
            fill="#FF7A59"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.6441 42.7205C40.0308 42.7205 37.9109 40.6239 37.9109 38.0372C37.9109 35.4505 40.0301 33.3532 42.6441 33.3532C45.2582 33.3532 47.3787 35.4498 47.3787 38.0372C47.3787 40.6246 45.2596 42.7205 42.6441 42.7205ZM44.0619 29.0199V24.85C44.6163 24.5961 45.0867 24.1892 45.4177 23.677C45.7486 23.1649 45.9264 22.5689 45.9302 21.9591V21.8627C45.9302 20.1004 44.4728 18.6594 42.6934 18.6594H42.5956C40.8183 18.6594 39.3588 20.1011 39.3588 21.8627V21.9591C39.3627 22.5688 39.5406 23.1648 39.8715 23.6769C40.2025 24.189 40.6728 24.596 41.2271 24.85V29.0199C39.6309 29.2607 38.1257 29.9157 36.8616 30.9196L25.3021 22.0213C25.383 21.7286 25.4264 21.4267 25.4313 21.1231C25.4313 19.1263 23.7981 17.5055 21.7809 17.5C19.7636 17.4945 18.1271 19.1126 18.125 21.1101C18.123 23.1075 19.7554 24.7249 21.7727 24.7283C22.4045 24.7256 23.0248 24.5586 23.5726 24.2437L34.9462 33.0005C33.923 34.5246 33.3884 36.3243 33.4137 38.1598C33.439 39.9953 34.0229 41.7796 35.0877 43.2749L31.6273 46.6997C31.2179 46.5714 30.7856 46.5334 30.3601 46.5882C29.9346 46.6431 29.526 46.7895 29.1625 47.0175C28.7991 47.2454 28.4893 47.5495 28.2547 47.9087C28.02 48.2678 27.866 48.6736 27.8033 49.0981C27.7406 49.5225 27.7706 49.9555 27.8913 50.3672C28.012 50.7789 28.2206 51.1595 28.5026 51.4829C28.7846 51.8062 29.1333 52.0646 29.5248 52.2402C29.9162 52.4158 30.3411 52.5044 30.7701 52.5C32.4272 52.5 33.7711 51.1697 33.7711 49.5298C33.7682 49.2416 33.7221 48.9554 33.6344 48.6808L37.0523 45.2956C38.6613 46.5152 40.6252 47.1747 42.6441 47.1735C47.7444 47.1735 51.8768 43.0835 51.8768 38.0372C51.8768 33.4694 48.4848 29.6974 44.0612 29.0199"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_44827">
            <rect width="70" height="70" rx="6" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const SalesforceIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.1358 15.764C31.3911 13.4141 34.531 11.9567 38.0036 11.9567C42.6197 11.9567 46.6472 14.5308 48.7919 18.352C50.6557 17.5192 52.7187 17.056 54.8894 17.056C63.2152 17.056 69.9651 23.8647 69.9651 32.2633C69.9651 40.6629 63.2152 47.4716 54.8894 47.4716C53.8733 47.4716 52.8801 47.37 51.9198 47.1757C50.0311 50.5447 46.432 52.8209 42.301 52.8209C40.5716 52.8209 38.936 52.4215 37.4796 51.7112C35.565 56.2148 31.1042 59.3726 25.9053 59.3726C20.4912 59.3726 15.877 55.9468 14.1058 51.1424C13.3318 51.3068 12.5299 51.3924 11.7071 51.3924C5.26098 51.3924 0.0351562 46.1128 0.0351562 39.599C0.0351562 35.2338 2.38309 31.4225 5.87162 29.3834C5.15339 27.7308 4.75394 25.9068 4.75394 23.9892C4.75394 16.4982 10.8355 10.4256 18.3365 10.4256C22.7405 10.4256 26.6544 12.5195 29.1358 15.764Z"
          fill="#00A1E0"
        />
        <path
          d="M10.1642 35.8083C10.1204 35.9228 10.1802 35.9467 10.1941 35.9667C10.3256 36.0623 10.4591 36.131 10.5936 36.2077C11.3068 36.5863 11.9802 36.6968 12.6845 36.6968C14.119 36.6968 15.0095 35.9338 15.0095 34.7055V34.6816C15.0095 33.546 14.0044 33.1336 13.0611 32.8357L12.9385 32.7959C12.2273 32.5648 11.6136 32.3656 11.6136 31.8974V31.8725C11.6136 31.472 11.9723 31.1771 12.5281 31.1771C13.1457 31.1771 13.8789 31.3824 14.3511 31.6433C14.3511 31.6433 14.4895 31.733 14.5403 31.5985C14.5682 31.5268 14.8073 30.8833 14.8322 30.8136C14.8591 30.7378 14.8113 30.6821 14.7625 30.6522C14.2236 30.3244 13.4784 30.1003 12.7074 30.1003L12.564 30.1013C11.251 30.1013 10.3346 30.8942 10.3346 32.0309V32.0548C10.3346 33.2531 11.3457 33.6416 12.293 33.9126L12.4454 33.9594C13.1358 34.1716 13.7305 34.3539 13.7305 34.84V34.8639C13.7305 35.3082 13.344 35.6389 12.7204 35.6389C12.4783 35.6389 11.7063 35.6339 10.8725 35.107C10.7719 35.0482 10.7131 35.0054 10.6354 34.9585C10.5946 34.9326 10.492 34.8878 10.4471 35.0233L10.1642 35.8083Z"
          fill="white"
        />
        <path
          d="M31.1642 35.8083C31.1204 35.9228 31.1802 35.9467 31.1941 35.9667C31.3256 36.0623 31.4591 36.131 31.5936 36.2077C32.3068 36.5863 32.9802 36.6968 33.6845 36.6968C35.119 36.6968 36.0095 35.9338 36.0095 34.7055V34.6816C36.0095 33.546 35.0044 33.1336 34.0611 32.8357L33.9385 32.7959C33.2273 32.5648 32.6136 32.3656 32.6136 31.8974V31.8725C32.6136 31.472 32.9723 31.1771 33.5281 31.1771C34.1457 31.1771 34.8789 31.3824 35.3511 31.6433C35.3511 31.6433 35.4895 31.733 35.5403 31.5985C35.5682 31.5268 35.8073 30.8833 35.8322 30.8136C35.8591 30.7378 35.8113 30.6821 35.7625 30.6522C35.2236 30.3244 34.4784 30.1003 33.7074 30.1003L33.564 30.1013C32.251 30.1013 31.3346 30.8942 31.3346 32.0309V32.0548C31.3346 33.2531 32.3457 33.6416 33.293 33.9126L33.4454 33.9594C34.1358 34.1716 34.7315 34.3539 34.7315 34.84V34.8639C34.7315 35.3082 34.344 35.6389 33.7204 35.6389C33.4783 35.6389 32.7063 35.6339 31.8725 35.107C31.7719 35.0482 31.7121 35.0074 31.6364 34.9585C31.6105 34.9416 31.489 34.8948 31.4471 35.0233L31.1642 35.8083Z"
          fill="white"
        />
        <path
          d="M45.4982 33.4024C45.4982 34.0967 45.3687 34.6436 45.1136 35.0301C44.8616 35.4126 44.4801 35.5989 43.9481 35.5989C43.4152 35.5989 43.0357 35.4136 42.7876 35.0301C42.5366 34.6446 42.4091 34.0967 42.4091 33.4024C42.4091 32.7091 42.5366 32.1632 42.7876 31.7807C43.0357 31.4021 43.4152 31.2178 43.9481 31.2178C44.4801 31.2178 44.8616 31.4021 45.1146 31.7807C45.3687 32.1632 45.4982 32.7091 45.4982 33.4024ZM46.6955 32.1154C46.578 31.7179 46.3947 31.3673 46.1506 31.0754C45.9066 30.7825 45.5978 30.5474 45.2312 30.3761C44.8656 30.2057 44.4333 30.1191 43.9481 30.1191C43.462 30.1191 43.0297 30.2057 42.6641 30.3761C42.2975 30.5474 41.9887 30.7825 41.7437 31.0754C41.5006 31.3683 41.3173 31.7189 41.1988 32.1154C41.0822 32.5108 41.0234 32.9432 41.0234 33.4024C41.0234 33.8616 41.0822 34.295 41.1988 34.6894C41.3173 35.0859 41.4996 35.4365 41.7447 35.7294C41.9887 36.0223 42.2985 36.2564 42.6641 36.4227C43.0307 36.5891 43.462 36.6738 43.9481 36.6738C44.4333 36.6738 44.8646 36.5891 45.2312 36.4227C45.5968 36.2564 45.9066 36.0223 46.1506 35.7294C46.3947 35.4375 46.578 35.0869 46.6955 34.6894C46.8131 34.294 46.8719 33.8606 46.8719 33.4024C46.8719 32.9442 46.8131 32.5108 46.6955 32.1154Z"
          fill="white"
        />
        <path
          d="M56.5331 35.4135C56.4932 35.297 56.3807 35.3408 56.3807 35.3408C56.2063 35.4075 56.0211 35.4693 55.8238 35.5002C55.6236 35.5311 55.4034 35.547 55.1673 35.547C54.5876 35.547 54.1274 35.3747 53.7976 35.034C53.4669 34.6933 53.2816 34.1424 53.2836 33.3973C53.2856 32.7189 53.449 32.2089 53.7428 31.8204C54.0347 31.4339 54.479 31.2356 55.0717 31.2356C55.5658 31.2356 55.9424 31.2924 56.3368 31.4169C56.3368 31.4169 56.4315 31.4578 56.4763 31.3343C56.5809 31.0434 56.6586 30.8352 56.7702 30.5154C56.802 30.4248 56.7243 30.3859 56.6964 30.375C56.541 30.3142 56.1745 30.2156 55.8975 30.1737C55.6385 30.1339 55.3357 30.113 54.999 30.113C54.4959 30.113 54.0477 30.1986 53.6642 30.37C53.2816 30.5403 52.9569 30.7754 52.6999 31.0683C52.4429 31.3612 52.2476 31.7118 52.1171 32.1083C51.9876 32.5037 51.9219 32.9381 51.9219 33.3973C51.9219 34.3905 52.1898 35.1934 52.7188 35.7811C53.2488 36.3708 54.0447 36.6707 55.0827 36.6707C55.6963 36.6707 56.3259 36.5461 56.7781 36.3678C56.7781 36.3678 56.8648 36.326 56.8269 36.2254L56.5331 35.4135Z"
          fill="white"
        />
        <path
          d="M58.6197 32.7372C58.6764 32.3517 58.783 32.031 58.9474 31.7809C59.1954 31.4014 59.574 31.1932 60.1059 31.1932C60.6379 31.1932 60.9895 31.4024 61.2415 31.7809C61.4089 32.031 61.4816 32.3657 61.5105 32.7372H58.6197ZM62.6511 31.8895C62.5495 31.506 62.2975 31.1185 62.1321 30.9412C61.8711 30.6603 61.6161 30.464 61.3631 30.3544C61.0323 30.213 60.6359 30.1194 60.2015 30.1194C59.6955 30.1194 59.2363 30.204 58.8637 30.3793C58.4902 30.5547 58.1764 30.7937 57.9303 31.0916C57.6843 31.3885 57.499 31.7421 57.3814 32.1435C57.2629 32.543 57.2031 32.9783 57.2031 33.4375C57.2031 33.9047 57.2649 34.3401 57.3874 34.7315C57.5109 35.126 57.7082 35.4737 57.9751 35.7616C58.2411 36.0514 58.5838 36.2786 58.9942 36.437C59.4016 36.5944 59.8967 36.676 60.4655 36.675C61.636 36.6711 62.2526 36.4101 62.5066 36.2696C62.5515 36.2447 62.5943 36.2009 62.5405 36.0754L62.2755 35.3332C62.2357 35.2226 62.1231 35.2635 62.1231 35.2635C61.8332 35.3711 61.4208 35.5643 60.4595 35.5623C59.831 35.5613 59.3648 35.3761 59.0729 35.0862C58.7731 34.7893 58.6266 34.353 58.6007 33.7374L62.6541 33.7414C62.6541 33.7414 62.7607 33.7394 62.7716 33.6358C62.7756 33.5919 62.9111 32.803 62.6511 31.8895Z"
          fill="white"
        />
        <path
          d="M26.1665 32.7372C26.2243 32.3517 26.3299 32.031 26.4943 31.7809C26.7423 31.4014 27.1208 31.1932 27.6528 31.1932C28.1847 31.1932 28.5364 31.4024 28.7894 31.7809C28.9558 32.031 29.0285 32.3657 29.0574 32.7372H26.1665ZM30.197 31.8895C30.0954 31.506 29.8443 31.1185 29.679 30.9412C29.418 30.6603 29.163 30.464 28.9099 30.3544C28.5792 30.213 28.1827 30.1194 27.7484 30.1194C27.2434 30.1194 26.7832 30.204 26.4106 30.3793C26.037 30.5547 25.7232 30.7937 25.4772 31.0916C25.2311 31.3885 25.0459 31.7421 24.9283 32.1435C24.8108 32.543 24.75 32.9783 24.75 33.4375C24.75 33.9047 24.8118 34.3401 24.9343 34.7315C25.0578 35.126 25.2551 35.4737 25.522 35.7616C25.788 36.0514 26.1307 36.2786 26.5411 36.437C26.9485 36.5944 27.4436 36.676 28.0124 36.675C29.1829 36.6711 29.7995 36.4101 30.0535 36.2696C30.0984 36.2447 30.1412 36.2009 30.0874 36.0754L29.8234 35.3332C29.7826 35.2226 29.67 35.2635 29.67 35.2635C29.3801 35.3711 28.9687 35.5643 28.0054 35.5623C27.3779 35.5613 26.9117 35.3761 26.6198 35.0862C26.3199 34.7893 26.1735 34.353 26.1476 33.7374L30.201 33.7414C30.201 33.7414 30.3075 33.7394 30.3185 33.6358C30.3225 33.5919 30.458 32.803 30.197 31.8895Z"
          fill="white"
        />
        <path
          d="M17.4029 35.3913C17.2445 35.2648 17.2226 35.2329 17.1688 35.1513C17.0891 35.0267 17.0483 34.8494 17.0483 34.6243C17.0483 34.2677 17.1658 34.0117 17.4099 33.8393C17.4069 33.8403 17.7586 33.5355 18.5854 33.5465C19.1661 33.5544 19.6851 33.6401 19.6851 33.6401V35.483H19.6861C19.6861 35.483 19.1711 35.5935 18.5913 35.6284C17.7665 35.6782 17.3999 35.3903 17.4029 35.3913ZM19.0157 32.5433C18.8513 32.5314 18.6382 32.5244 18.3831 32.5244C18.0355 32.5244 17.6998 32.5682 17.385 32.6529C17.0682 32.7376 16.7833 32.8701 16.5383 33.0454C16.2922 33.2217 16.094 33.4468 15.9505 33.7138C15.8071 33.9808 15.7344 34.2956 15.7344 34.6482C15.7344 35.0068 15.7961 35.3186 15.9197 35.5736C16.0432 35.8296 16.2215 36.0428 16.4486 36.2072C16.6737 36.3715 16.9517 36.4921 17.2744 36.5648C17.5922 36.6375 17.9528 36.6744 18.3473 36.6744C18.7627 36.6744 19.1771 36.6405 19.5785 36.5718C19.976 36.504 20.4641 36.4054 20.5996 36.3745C20.7341 36.3427 20.8835 36.3018 20.8835 36.3018C20.9841 36.2769 20.9761 36.1693 20.9761 36.1693L20.9741 32.4626C20.9741 31.6498 20.757 31.0471 20.3296 30.6735C19.9043 30.301 19.2777 30.1127 18.4678 30.1127C18.164 30.1127 17.6749 30.1546 17.382 30.2133C17.382 30.2133 16.4964 30.3847 16.1318 30.6696C16.1318 30.6696 16.0521 30.7194 16.096 30.8309L16.3829 31.602C16.4187 31.7016 16.5154 31.6677 16.5154 31.6677C16.5154 31.6677 16.5462 31.6558 16.5821 31.6348C17.3621 31.2105 18.3483 31.2234 18.3483 31.2234C18.7866 31.2234 19.1233 31.3111 19.3504 31.4854C19.5716 31.6548 19.6841 31.9108 19.6841 32.4507V32.622C19.3355 32.5722 19.0157 32.5433 19.0157 32.5433Z"
          fill="white"
        />
        <path
          d="M51.7113 30.4547C51.7422 30.3631 51.6774 30.3193 51.6505 30.3093C51.5818 30.2824 51.2371 30.2097 50.9712 30.1928C50.4621 30.1619 50.1792 30.2475 49.9262 30.3611C49.6752 30.4747 49.3962 30.658 49.2408 30.8662V30.3731C49.2408 30.3043 49.192 30.2495 49.1243 30.2495H48.0853C48.0176 30.2495 47.9688 30.3043 47.9688 30.3731V36.4187C47.9688 36.4865 48.0245 36.5422 48.0923 36.5422H49.1572C49.2249 36.5422 49.2797 36.4865 49.2797 36.4187V33.3984C49.2797 32.9929 49.3245 32.5885 49.4142 32.3345C49.5018 32.0835 49.6214 31.8822 49.7688 31.7378C49.9172 31.5943 50.0856 31.4937 50.2699 31.4369C50.4581 31.3792 50.6663 31.3602 50.8138 31.3602C51.0259 31.3602 51.259 31.415 51.259 31.415C51.3367 31.424 51.3806 31.3762 51.4065 31.3055C51.4762 31.1202 51.6734 30.5653 51.7113 30.4547Z"
          fill="white"
        />
        <path
          d="M41.713 27.6528C41.5835 27.613 41.4659 27.5861 41.3125 27.5572C41.1571 27.5293 40.9718 27.5153 40.7616 27.5153C40.0285 27.5153 39.4507 27.7225 39.0453 28.131C38.6418 28.5374 38.3679 29.156 38.2304 29.9699L38.1806 30.2438H37.2602C37.2602 30.2438 37.1486 30.2398 37.1247 30.3613L36.9743 31.2051C36.9633 31.2848 36.9982 31.3356 37.1058 31.3356H38.0013L37.0928 36.408C37.0221 36.8164 36.9404 37.1521 36.8497 37.4071C36.7611 37.6582 36.6744 37.8464 36.5668 37.9839C36.4632 38.1154 36.3656 38.213 36.1963 38.2698C36.0568 38.3166 35.8954 38.3385 35.7191 38.3385C35.6215 38.3385 35.491 38.3226 35.3944 38.3027C35.2987 38.2838 35.2479 38.2628 35.1752 38.232C35.1752 38.232 35.0706 38.1921 35.0288 38.2967C34.9959 38.3834 34.7568 39.0398 34.7279 39.1205C34.7 39.2012 34.7399 39.264 34.7907 39.2829C34.9102 39.3247 34.9989 39.3526 35.1613 39.3915C35.3864 39.4443 35.5767 39.4473 35.755 39.4473C36.1275 39.4473 36.4682 39.3945 36.7501 39.2929C37.033 39.1903 37.2801 39.0119 37.4992 38.7709C37.7353 38.5099 37.8838 38.2369 38.0252 37.8634C38.1657 37.4948 38.2862 37.0366 38.3818 36.5026L39.2953 31.3356H40.6301C40.6301 31.3356 40.7427 31.3396 40.7656 31.217L40.917 30.3743C40.927 30.2936 40.8931 30.2438 40.7846 30.2438H39.4886C39.4955 30.2149 39.5543 29.7587 39.7027 29.3293C39.7665 29.147 39.886 28.9986 39.9866 28.897C40.0862 28.7974 40.2008 28.7267 40.3263 28.6858C40.4548 28.644 40.6013 28.6241 40.7616 28.6241C40.8832 28.6241 41.0037 28.638 41.0944 28.6569C41.2199 28.6838 41.2687 28.6978 41.3016 28.7077C41.434 28.7476 41.452 28.7087 41.4779 28.645L41.7877 27.7943C41.8196 27.7026 41.7409 27.6638 41.713 27.6528Z"
          fill="white"
        />
        <path
          d="M23.6038 36.419C23.6038 36.4868 23.555 36.5416 23.4873 36.5416H22.4124C22.3447 36.5416 22.2969 36.4868 22.2969 36.419V27.7684C22.2969 27.7007 22.3447 27.6459 22.4124 27.6459H23.4873C23.555 27.6459 23.6038 27.7007 23.6038 27.7684V36.419Z"
          fill="white"
        />
      </svg>
    </>
  );
};
export const MailChipIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_44897)">
          <path
            d="M59.5 0H10.5C4.70101 0 0 4.70101 0 10.5V59.5C0 65.299 4.70101 70 10.5 70H59.5C65.299 70 70 65.299 70 59.5V10.5C70 4.70101 65.299 0 59.5 0Z"
            fill="#FFDD22"
          />
          <path
            d="M57.1489 41.836L56.3286 39.5117C56.3286 39.5117 59.7465 34.3164 51.27 32.5391C51.27 32.5391 51.8168 26.1133 48.809 23.1055C55.3715 16.6797 53.8676 6.97268 38.9653 13.2617C31.309 -1.36716 1.77778 32.9492 14.0825 38.418C12.852 40.0586 12.852 48.2617 21.3286 49.0821C27.0707 61.3867 41.0161 62.2071 49.0825 58.5156C57.1489 54.8242 61.7973 43.0664 57.1489 41.836ZM21.1918 47.3047C14.2192 46.6211 13.5356 37.0508 19.5512 36.0938C25.5668 35.1367 27.0707 47.8516 21.1918 47.3047ZM19.1411 34.3164C17.227 34.3164 14.9028 36.9141 14.9028 36.9141C5.60591 32.4024 31.7192 2.46096 37.3247 14.0821C37.3247 14.0821 23.6528 20.6446 19.1411 34.3164ZM46.4848 45.9375C46.4848 45.3906 43.6137 46.7578 38.4184 44.9805C38.8286 42.1094 44.9809 47.4414 55.2348 40.4688L56.0551 43.3399C59.8833 42.6563 56.0551 55.6446 43.7504 55.5078C33.77 55.3711 30.6254 45.1172 36.0942 39.5117C37.1879 38.418 32.1293 36.2305 33.0864 31.4453C33.4965 29.3946 35.2739 26.3867 39.7856 27.2071C44.2973 28.0274 45.2543 23.9258 48.2622 25.4297C51.27 26.9336 49.4926 32.6758 49.9028 33.4961C50.3129 34.3164 54.6879 34.4531 55.5083 36.7774C56.3286 39.1016 49.9028 44.1602 39.9223 42.793C37.5981 42.5196 36.2309 45.5274 37.7348 47.4414C40.7426 51.8164 53.0473 48.9453 55.0981 44.7071C49.9028 48.6719 39.2387 50.1758 38.4184 45.9375C41.4262 47.3047 46.4848 46.4844 46.4848 45.9375ZM28.5747 24.336C31.5825 20.6446 35.5473 18.4571 35.5473 18.4571L34.727 20.5078C34.727 20.5078 37.5981 18.3203 40.7426 18.3203L39.6489 19.4141C43.2036 19.5508 44.7075 20.918 44.7075 20.918C44.7075 20.918 36.3676 18.4571 28.5747 24.336ZM47.0317 29.668C48.809 29.5313 48.2622 33.6328 48.2622 33.6328H47.1684C47.1684 33.6328 45.2543 29.8047 47.0317 29.668ZM38.9653 34.1797C37.7348 34.3164 36.3676 35 36.5043 34.4531C37.0512 32.2656 42.1098 32.8125 41.9731 34.7266C41.8364 36.6406 40.7426 33.9063 38.9653 34.1797ZM41.8364 35.8203C41.9731 36.0938 40.8793 35.8203 40.059 35.9571C39.2387 36.0938 38.4184 36.5039 38.4184 36.2305C38.4184 35.9571 41.5629 34.7266 41.8364 35.8203ZM44.5708 36.2305C44.9809 35.4102 46.6215 36.2305 46.2114 37.0508C45.8012 37.8711 44.1606 37.0508 44.5708 36.2305ZM47.9887 36.5039C47.1684 36.5039 47.1684 34.7266 47.9887 34.7266C48.809 34.7266 48.809 36.6406 47.9887 36.6406V36.5039ZM23.3793 43.75C23.7895 44.1602 22.559 44.9805 21.602 44.2969C20.645 43.6133 22.6957 40.3321 20.2348 39.5117C17.7739 38.6914 18.4575 41.836 17.7739 41.4258C17.0903 41.0156 18.7309 36.6406 21.602 38.418C24.4731 40.1953 20.7817 42.9297 22.4223 43.75C24.0629 44.5703 23.1059 43.4766 23.3793 43.75Z"
            fill="#222222"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_44897">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const StripeIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_45556)">
          <path
            d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
            fill="#635BFF"
          />
          <path
            d="M53.4333 35.2563C53.4333 32.6347 52.1632 30.5655 49.7364 30.5655C47.3097 30.5655 45.8242 32.634 45.8242 35.2358C45.8242 38.3181 47.5653 39.8753 50.0625 39.8753C51.2813 39.8753 52.2028 39.6019 52.8994 39.2095V37.1587C52.2028 37.5067 51.4044 37.722 50.3906 37.722C49.3974 37.722 48.5162 37.3741 48.4041 36.1655H53.4121C53.4128 36.0342 53.4333 35.5017 53.4333 35.2563ZM48.3747 34.2835C48.3747 33.1262 49.0815 32.6429 49.7269 32.6429C50.3517 32.6429 51.0175 33.1214 51.0175 34.2835H48.3747ZM41.871 30.5655C41.1239 30.5627 40.4047 30.8491 39.864 31.3646L39.7307 30.7295H37.4748V42.6706L40.0349 42.1278L40.0451 39.2293C40.4136 39.4959 40.9564 39.8747 41.858 39.8747C43.6914 39.8747 45.3607 38.4001 45.3607 35.1538C45.3525 32.1835 43.6627 30.5655 41.871 30.5655ZM41.2558 37.6215C40.6515 37.6215 40.2933 37.4062 40.0472 37.143L40.0369 33.3436C40.3035 33.0469 40.672 32.8418 41.2558 32.8418C42.1875 32.8418 42.8328 33.8864 42.8328 35.2283C42.8335 36.5975 42.1984 37.6215 41.2564 37.6215H41.2558ZM33.9543 29.9612L36.5246 29.4082V27.3293L33.9543 27.8721V29.9612ZM33.9543 30.7398H36.5246V39.701H33.9543V30.7398ZM31.1994 31.4972L31.034 30.7398H28.8232V39.7003H31.3833V33.6273C31.9876 32.8384 33.0116 32.982 33.3288 33.0948V30.7398C33.0021 30.6167 31.8037 30.3912 31.1994 31.4972ZM26.0786 28.5174L23.5828 29.0527L23.5726 37.2558C23.5726 38.7713 24.7094 39.8876 26.2249 39.8876C27.0644 39.8876 27.6789 39.7338 28.0173 39.55V37.4684C27.6898 37.6017 26.0718 38.0727 26.0718 36.5572V32.9211H28.0173V30.7398H26.0684L26.0786 28.5174ZM19.1559 33.3409C19.1559 32.9417 19.4833 32.7878 20.0261 32.7878C20.912 32.8064 21.7814 33.0309 22.5656 33.4434V31.0351C21.7578 30.7169 20.8963 30.5575 20.0281 30.5655C17.9493 30.5655 16.5664 31.651 16.5664 33.4639C16.5664 36.2906 20.4581 35.8401 20.4581 37.0583C20.4581 37.5292 20.0479 37.6831 19.4751 37.6831C18.6254 37.6831 17.5392 37.3351 16.6792 36.8627V39.3004C17.562 39.6824 18.5132 39.8811 19.4751 39.8842C21.6052 39.8842 23.0694 38.8294 23.0694 36.996C23.0578 33.9452 19.1559 34.4879 19.1559 33.3409Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_45556">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ZapierIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_45562)">
          <path
            d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
            fill="#FF4A00"
          />
          <path
            d="M39.375 35.0075C39.3752 36.2684 39.1476 37.519 38.703 38.6989C37.522 39.1452 36.27 39.3743 35.0075 39.375H34.9925C33.7316 39.3751 32.4811 39.1474 31.3011 38.703C30.8547 37.522 30.6257 36.27 30.625 35.0075V34.9925C30.6251 33.7316 30.8528 32.4811 31.297 31.3011C32.478 30.8547 33.73 30.6257 34.9925 30.625H35.0075C36.2698 30.6245 37.5218 30.8524 38.703 31.2977C39.1476 32.4776 39.3752 33.7282 39.375 34.9891V35.0041V35.0075ZM52.2566 32.0831H42.041L49.2645 24.8603C48.6972 24.0645 48.0645 23.3175 47.373 22.627C46.6823 21.9365 45.9353 21.3047 45.1397 20.7382L37.9169 27.959V17.7434C36.9562 17.582 35.9837 17.5006 35.0096 17.5H34.9911C34.0169 17.5006 33.0445 17.582 32.0838 17.7434V27.959L24.8603 20.7354C24.0646 21.3028 23.3176 21.9355 22.627 22.627C21.9367 23.3172 21.3052 24.0638 20.7389 24.8589L27.959 32.0831H17.7434C17.7434 32.0831 17.5 34.002 17.5 34.9938V35.0062C17.5004 35.9815 17.5818 36.9551 17.7434 37.9169H27.959L20.7354 45.1397C21.8714 46.7346 23.2654 48.1286 24.8603 49.2645L32.0831 42.041V52.2566C33.0429 52.4178 34.0144 52.4992 34.9877 52.5H35.013C35.986 52.4992 36.9573 52.4178 37.9169 52.2566V42.041L45.1397 49.2645C45.9354 48.6972 46.6824 48.0645 47.373 47.373C48.0637 46.6823 48.6957 45.9353 49.2625 45.1397L42.041 37.9169H52.2566C52.4178 36.9571 52.4992 35.9856 52.5 35.0123V34.987C52.4992 34.014 52.4178 33.0427 52.2566 32.0831Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_45562">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const GoogleSheetIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M41.6332 5L56.6332 20L49.1332 21.3636L41.6332 20L40.2695 12.5L41.6332 5Z"
          fill="#188038"
        />
        <path
          d="M41.6364 20V5H17.0909C14.8307 5 13 6.83068 13 9.09091V60.9091C13 63.1693 14.8307 65 17.0909 65H52.5455C54.8057 65 56.6364 63.1693 56.6364 60.9091V20H41.6364Z"
          fill="#34A853"
        />
        <path
          d="M21.1836 28.1818V47.9545H48.4563V28.1818H21.1836ZM33.1154 44.5454H24.5927V39.7727H33.1154V44.5454ZM33.1154 36.3636H24.5927V31.5909H33.1154V36.3636ZM45.0472 44.5454H36.5245V39.7727H45.0472V44.5454ZM45.0472 36.3636H36.5245V31.5909H45.0472V36.3636Z"
          fill="white"
        />
      </svg>
    </>
  );
};
export const GmailIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_45581)">
          <path
            d="M59.5 0H10.5C4.70101 0 0 4.70101 0 10.5V59.5C0 65.299 4.70101 70 10.5 70H59.5C65.299 70 70 65.299 70 59.5V10.5C70 4.70101 65.299 0 59.5 0Z"
            fill="white"
          />
          <path
            d="M21.6016 53.457V34.043L10.3906 25.4297V49.3555C10.3906 52.0898 11.7578 53.457 14.4922 53.457"
            fill="#4285F4"
          />
          <path
            d="M21.0547 33.9062L35 44.4336L48.9453 33.9062V20.5078L35 31.0352L21.0547 20.5078"
            fill="#EA4335"
          />
          <path
            d="M48.3984 53.457V34.043L59.6094 25.4297V49.3555C59.6094 52.0898 58.2422 53.457 55.5078 53.457"
            fill="#34A853"
          />
          <path
            d="M10.3906 25.7031L21.6016 34.3164V20.9179L17.5 17.7734C13.8086 14.9023 10.3906 17.7734 10.3906 21.3281"
            fill="#C5221F"
          />
          <path
            d="M59.6094 25.7031L48.3984 34.3164V20.9179L52.5 17.7734C56.1914 14.9023 59.6094 17.7734 59.6094 21.3281"
            fill="#FBBC04"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_45581">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const PayPalIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_45593)">
          <path
            d="M59.5 0H10.5C4.70101 0 0 4.70101 0 10.5V59.5C0 65.299 4.70101 70 10.5 70H59.5C65.299 70 70 65.299 70 59.5V10.5C70 4.70101 65.299 0 59.5 0Z"
            fill="white"
          />
          <path
            d="M51.5426 25.2656L24.7047 54.5508H14.8609C14.1773 54.5508 13.6305 53.8672 13.7672 53.1836L20.3297 11.6211C20.4664 10.6641 21.2867 9.98047 22.2437 9.98047H38.9234C50.4078 10.3906 53.5523 16.2695 51.5016 25.293L51.5426 25.2656Z"
            fill="#002C8A"
          />
          <path
            d="M51.982 22.5586C56.0836 24.7461 57.0406 28.8477 55.6734 34.3164C53.8961 42.3828 48.5641 45.8008 40.7711 45.9375L38.5836 46.0742C37.7633 46.0742 37.2164 46.6211 37.0797 47.4414L35.3023 58.2422C35.1656 59.1992 34.3453 59.8828 33.3883 59.8828H25.1852C24.5016 59.8828 23.9547 59.1992 24.0914 58.5156L27.0992 38.9648C27.2359 38.2812 51.982 22.5586 51.982 22.5586Z"
            fill="#009BE1"
          />
          <path
            d="M26.9336 39.9219L29.668 22.5586C29.7577 22.1474 29.9804 21.7772 30.3017 21.5053C30.623 21.2335 31.0249 21.0751 31.4453 21.0547H44.5703C47.7148 21.0547 50.0391 21.6016 51.9531 22.5586C51.2695 28.5742 48.3984 38.2812 34.4531 38.5547H28.4375C27.7539 38.5547 27.0703 39.1016 26.9336 39.9219Z"
            fill="#001F6B"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_45593">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const CalendlyIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="69"
        height="70"
        viewBox="0 0 69 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M47.0278 45.3162C44.837 47.2933 42.0583 49.7513 37.0354 49.7513H33.9896C30.356 49.7513 27.0431 48.4155 24.6919 46.0643C22.3942 43.7132 21.1118 40.5071 21.1118 37.0338V32.9193C21.1118 29.446 22.3942 26.2399 24.6919 23.8887C27.0431 21.4842 30.356 20.2017 33.9896 20.2017H36.982C42.0049 20.2017 44.7835 22.6597 46.9744 24.6368C49.2721 26.6674 51.2492 28.4307 56.5392 28.4307C57.3408 28.4307 58.1423 28.3773 58.9438 28.217V28.1636C58.6232 27.362 58.2492 26.6139 57.8217 25.8658L54.295 19.7208C51.0354 14.1101 45.0507 10.6368 38.5316 10.6368H31.5316C25.0125 10.6368 19.0278 14.1101 15.7683 19.7208L12.2415 25.8658C8.98199 31.4765 8.98199 38.4231 12.2415 44.0338L15.7683 50.1788C19.0278 55.7895 25.0125 59.2628 31.5316 59.2628H38.585C45.1041 59.2628 51.0889 55.7895 54.3484 50.1788L57.8751 44.0338C58.3026 43.2857 58.6767 42.5376 58.9973 41.7361V41.6826C58.1957 41.5758 57.3942 41.4689 56.5927 41.4689C51.3026 41.5223 49.3255 43.2857 47.0278 45.3162Z"
          fill="#006BFF"
        />
        <path
          d="M37.0309 23.8887H33.9851C28.4812 23.8887 24.8477 27.8429 24.8477 32.8658V36.9803C24.8477 42.0566 28.4812 45.9574 33.9851 45.9574H36.9774C45.0461 45.9574 44.4049 37.7284 56.5881 37.7284C57.7637 37.7284 58.8858 37.8352 60.008 38.049C60.382 35.965 60.382 33.8276 60.008 31.7436C58.8858 31.9574 57.7103 32.0642 56.5881 32.0642C44.4049 32.1177 45.0461 23.8887 37.0309 23.8887Z"
          fill="#006BFF"
        />
        <path
          d="M67.0109 41.0949C64.9269 39.5987 62.5758 38.53 60.0109 38.1025V38.1559C59.7972 39.385 59.4766 40.5605 58.9957 41.6827C61.0796 42.0033 63.0567 42.8048 64.7666 44.0872V44.1407C59.6903 60.5987 42.2705 69.7895 25.8124 64.7132C9.35442 59.6369 0.163585 42.217 5.23992 25.759C10.3163 9.30098 27.7361 0.110144 44.1941 5.18648C54.0262 8.23228 61.7208 15.9269 64.7666 25.759V25.8124C63.0567 27.0414 61.0796 27.843 58.9957 28.1636C59.4766 29.2857 59.7972 30.5147 60.0109 31.6903V31.7437C62.5224 31.2628 64.9269 30.2476 67.0109 28.7514C68.988 27.2552 68.614 25.5987 68.2934 24.6369C62.6292 6.20174 43.072 -4.11122 24.6369 1.5529C6.20175 7.21702 -4.11123 26.7743 1.5529 45.2094C7.21702 63.6445 26.7743 73.9575 45.2094 68.2934C56.217 64.8735 64.8735 56.2704 68.2934 45.2094C68.614 44.2475 69.0415 42.5911 67.0109 41.0949Z"
          fill="#006BFF"
        />
        <path
          d="M58.9949 28.1636C58.1933 28.2705 57.3918 28.3773 56.5903 28.3773C51.3002 28.3773 49.3231 26.614 47.0254 24.5834C44.7811 22.6063 42.0559 20.1483 37.033 20.1483H33.9872C30.3536 20.1483 27.0407 21.4842 24.6895 23.8353C22.3918 26.1865 21.1094 29.3926 21.1094 32.8659V36.9804C21.1094 40.4537 22.3918 43.6598 24.6895 46.0109C27.0407 48.4155 30.3536 49.6979 33.9872 49.6979H36.9796C42.0025 49.6979 44.7811 47.2399 46.972 45.2628C49.2697 43.2323 51.2468 41.4689 56.5369 41.4689C57.3384 41.4689 58.1399 41.5224 58.9414 41.6827C59.4224 40.5605 59.743 39.3315 59.9567 38.156V38.1025C58.8346 37.8888 57.659 37.7819 56.5369 37.7819C44.3536 37.7819 44.9949 46.0109 36.9262 46.0109H33.9872C28.4834 46.0109 24.8498 42.0567 24.8498 36.9804V32.8659C24.8498 27.7895 28.4834 23.8888 33.9872 23.8888H36.9796C45.0483 23.8888 44.4071 32.1178 56.5903 32.1178C57.7659 32.1178 58.888 32.0109 60.0101 31.7972V31.7437C59.7964 30.5147 59.4758 29.3392 58.9949 28.1636Z"
          fill="#0AE8F0"
        />
        <path
          d="M58.9949 28.1636C58.1933 28.2705 57.3918 28.3773 56.5903 28.3773C51.3002 28.3773 49.3231 26.614 47.0254 24.5834C44.7811 22.6063 42.0559 20.1483 37.033 20.1483H33.9872C30.3536 20.1483 27.0407 21.4842 24.6895 23.8353C22.3918 26.1865 21.1094 29.3926 21.1094 32.8659V36.9804C21.1094 40.4537 22.3918 43.6598 24.6895 46.0109C27.0407 48.4155 30.3536 49.6979 33.9872 49.6979H36.9796C42.0025 49.6979 44.7811 47.2399 46.972 45.2628C49.2697 43.2323 51.2468 41.4689 56.5369 41.4689C57.3384 41.4689 58.1399 41.5224 58.9414 41.6827C59.4224 40.5605 59.743 39.3315 59.9567 38.156V38.1025C58.8346 37.8888 57.659 37.7819 56.5369 37.7819C44.3536 37.7819 44.9949 46.0109 36.9262 46.0109H33.9872C28.4834 46.0109 24.8498 42.0567 24.8498 36.9804V32.8659C24.8498 27.7895 28.4834 23.8888 33.9872 23.8888H36.9796C45.0483 23.8888 44.4071 32.1178 56.5903 32.1178C57.7659 32.1178 58.888 32.0109 60.0101 31.7972V31.7437C59.7964 30.5147 59.4758 29.3392 58.9949 28.1636Z"
          fill="#0AE8F0"
        />
      </svg>
    </>
  );
};
export const AsanaIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5736 55.5437C4.26684 55.5437 2.39685 53.6326 2.39685 51.2746C2.39685 48.9171 4.26684 47.0057 6.5736 47.0057C8.88045 47.0057 10.75 48.9171 10.75 51.2746C10.75 53.6326 8.88045 55.5437 6.5736 55.5437ZM10.7634 56.0852C10.7634 56.476 11.4332 57.5742 12.254 57.5742H12.7857C12.9918 57.5742 13.1605 57.4054 13.1605 57.1994V45.5171H13.1583C13.1476 45.3204 12.9847 45.1627 12.7857 45.1627H11.1384C10.9392 45.1627 10.7765 45.3204 10.7653 45.5171H10.7634V46.4664C9.7541 45.2232 8.1629 44.7074 6.5671 44.7074C2.94002 44.7074 0 47.6475 0 51.2746C0 54.9018 2.94002 57.8423 6.5671 57.8423C8.1629 57.8423 9.90189 57.2233 10.7632 56.0835L10.7634 56.0852ZM17.0961 54.4121C18.1957 55.1737 19.396 55.5437 20.5493 55.5437C21.6484 55.5437 22.7843 54.9739 22.7843 53.9826C22.7843 52.6587 20.3089 52.4527 18.7536 51.9242C17.198 51.3956 15.8581 50.3027 15.8581 48.5331C15.8581 45.8255 18.2709 44.707 20.5226 44.707C21.9496 44.707 23.4217 45.1776 24.3761 45.8517C24.705 46.1005 24.5046 46.3866 24.5046 46.3866L23.5936 47.6878C23.4912 47.8343 23.2789 47.9514 23.0552 47.8022C22.4414 47.3966 21.7578 47.0056 20.5226 47.0056C18.9937 47.0056 18.3212 47.6403 18.3212 48.4265C18.3212 49.3697 19.3968 49.6663 20.6567 49.9879C22.8525 50.5795 25.2474 51.291 25.2474 53.9826C25.2474 56.3682 23.0158 57.8427 20.5493 57.8427C18.6805 57.8427 17.0891 57.3098 15.7544 56.3304C15.4766 56.0522 15.6706 55.7938 15.6706 55.7938L16.5773 54.4994C16.7617 54.2571 16.9943 54.3417 17.0961 54.4121ZM37.6011 56.0852C37.6011 56.476 38.2709 57.5742 39.0917 57.5742H39.6232C39.8295 57.5742 39.9982 57.4054 39.9982 57.1994V45.5171H39.996C39.985 45.3204 39.8224 45.1627 39.6232 45.1627H37.976C37.7767 45.1627 37.614 45.3204 37.6031 45.5171H37.6011V46.4664C36.5919 45.2232 35.0005 44.7074 33.405 44.7074C29.7779 44.7074 26.8375 47.6475 26.8375 51.2746C26.8375 54.9018 29.7779 57.8423 33.405 57.8423C35.0005 57.8423 36.7395 57.2233 37.6009 56.0835L37.6011 56.0852ZM33.4112 55.5437C31.1044 55.5437 29.2345 53.6326 29.2345 51.2746C29.2345 48.9171 31.1044 47.0057 33.4112 47.0057C35.7179 47.0057 37.5878 48.9171 37.5878 51.2746C37.5878 53.6326 35.7179 55.5437 33.4112 55.5437ZM54.7567 56.4867L54.756 50.4419C54.756 47.0342 52.6064 44.7354 49.1781 44.7354C47.5418 44.7354 46.2029 45.6817 45.7291 46.4944V46.4831L45.7263 46.4924C45.7253 45.6698 45.0581 45.1908 44.2357 45.1908H43.7068C43.5004 45.1908 43.3318 45.3597 43.3318 45.5659V56.1144V56.1162V57.2489H43.334C43.3446 57.4455 43.5077 57.6034 43.7068 57.6034H45.354C45.3792 57.6034 45.404 57.6004 45.428 57.5959C45.439 57.5936 45.4489 57.5893 45.4595 57.5862C45.472 57.5826 45.4847 57.5796 45.4962 57.5747C45.5111 57.5687 45.5243 57.5604 45.538 57.5528C45.5446 57.5488 45.5517 57.5459 45.5582 57.5419C45.5743 57.5312 45.5896 57.5184 45.6042 57.5053C45.6066 57.5028 45.6095 57.5012 45.6118 57.4989C45.6283 57.4832 45.6431 57.466 45.6564 57.4476L45.6566 57.4474C45.6978 57.3908 45.7228 57.3227 45.7269 57.2489H45.7291V50.3481C45.7291 48.5179 47.2128 47.0342 49.0431 47.0342C50.8734 47.0342 52.3572 48.5179 52.3572 50.3481L52.3585 56.1164L52.359 56.1144C52.359 56.1194 52.3599 56.1248 52.3599 56.1301V57.2489H52.3621C52.373 57.4455 52.5357 57.6034 52.735 57.6034H54.3822C54.4076 57.6034 54.432 57.6004 54.456 57.5959C54.4658 57.5937 54.4748 57.5898 54.4841 57.5875C54.4979 57.5835 54.5117 57.58 54.5246 57.5747C54.5378 57.569 54.5502 57.5614 54.5628 57.5543C54.5706 57.55 54.5788 57.5467 54.5862 57.5419C54.6017 57.5316 54.6155 57.5196 54.6292 57.5078C54.6327 57.5047 54.6366 57.502 54.6399 57.4988C54.6556 57.4838 54.6692 57.4675 54.6821 57.4505C54.6829 57.449 54.684 57.4481 54.6851 57.4469C54.7257 57.3908 54.7504 57.3232 54.7548 57.2499C54.7548 57.2495 54.755 57.2489 54.755 57.2489H54.7569V56.487L54.7567 56.4867ZM67.6031 56.0852C67.6031 56.476 68.2721 57.5742 69.0931 57.5742H69.625C69.831 57.5742 70 57.4054 70 57.1994V45.5171H69.998C69.987 45.3204 69.824 45.1627 69.625 45.1627H67.9781C67.7781 45.1627 67.6161 45.3204 67.6051 45.5171H67.6031V46.4664C66.5932 45.2232 65.0023 44.7074 63.4064 44.7074C59.7796 44.7074 56.8392 47.6475 56.8392 51.2746C56.8392 54.9018 59.7796 57.8423 63.4064 57.8423C65.0023 57.8423 66.7412 57.2233 67.6021 56.0835L67.6031 56.0852ZM63.4134 55.5437C61.1065 55.5437 59.2367 53.6326 59.2367 51.2746C59.2367 48.9171 61.1065 47.0057 63.4134 47.0057C65.7193 47.0057 67.5891 48.9171 67.5891 51.2746C67.5891 53.6326 65.7193 55.5437 63.4134 55.5437Z"
          fill="#283343"
        />
        <path
          d="M42.5831 24.8439C39.4043 24.8439 36.8277 27.4206 36.8277 30.5991C36.8277 33.7779 39.4043 36.3547 42.5831 36.3547C45.7616 36.3547 48.3383 33.7779 48.3383 30.5991C48.3383 27.4206 45.7616 24.8439 42.5831 24.8439ZM27.6303 24.8443C24.4518 24.8443 21.875 27.4206 21.875 30.5994C21.875 33.7779 24.4518 36.3547 27.6303 36.3547C30.8089 36.3547 33.3859 33.7779 33.3859 30.5994C33.3859 27.4206 30.8089 24.8443 27.6303 24.8443ZM40.8618 17.6497C40.8618 20.8283 38.2853 23.4055 35.1068 23.4055C31.928 23.4055 29.3514 20.8283 29.3514 17.6497C29.3514 14.4714 31.928 11.8945 35.1068 11.8945C38.2853 11.8945 40.8618 14.4714 40.8618 17.6497Z"
          fill="url(#paint0_radial_1214_45624)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1214_45624"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(1345.04 1348.7) scale(1753.55 1620.81)"
          >
            <stop stop-color="#FFB900" />
            <stop offset="0.6" stop-color="#F95D8F" />
            <stop offset="0.9991" stop-color="#F95353" />
          </radialGradient>
        </defs>
      </svg>
    </>
  );
};
export const MondayIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_45638)">
          <path
            d="M8.70785 55.6414C5.55746 55.6482 2.64708 53.9594 1.08985 51.2208C-0.444921 48.499 -0.352887 45.1525 1.32916 42.5192L17.0172 17.8837C18.6519 15.1882 21.6104 13.5807 24.7615 13.6759C27.9102 13.7513 30.7743 15.5168 32.2565 18.2959C33.719 21.0612 33.5361 24.3883 31.7845 26.9841L16.1065 51.6196C14.4906 54.1376 11.6997 55.6547 8.70785 55.6414Z"
            fill="#F62B54"
          />
          <path
            d="M35.6178 55.6414C32.4536 55.6414 29.542 53.9496 28.0131 51.2308C26.4817 48.5164 26.5738 45.1784 28.2524 42.5525L43.9105 17.9735C45.5216 15.2393 48.4889 13.594 51.6615 13.6759C54.8522 13.7457 57.7439 15.5305 59.2063 18.3225C60.6588 21.1144 60.4461 24.4614 58.6413 27.0506L42.9865 51.6296C41.3758 54.1367 38.5977 55.6491 35.6178 55.6414Z"
            fill="#FFCC00"
          />
          <path
            d="M61.9243 55.8474C66.385 55.8474 70.001 52.3073 70.001 47.9402C70.001 43.5732 66.385 40.0331 61.9243 40.0331C57.4637 40.0331 53.8477 43.5732 53.8477 47.9402C53.8477 52.3073 57.4637 55.8474 61.9243 55.8474Z"
            fill="#00CA72"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_45638">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ChatGPTIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_45659)">
          <path
            d="M0.0273438 16.8279V10.0291C0.0273438 4.50621 4.5045 0.0290527 10.0273 0.0290527H59.9692C65.492 0.0290527 69.9692 4.50621 69.9692 10.0291V16.8279V60C69.9692 65.5228 65.492 70 59.9692 70H16.8262H10.0273C4.5045 70 0.0273438 65.5228 0.0273438 60L0.0273438 16.8279Z"
            fill="#74AA9C"
          />
          <path
            d="M32.2148 8.70205C26.4542 8.70205 21.3366 12.4057 19.5531 17.8754L18.9102 21.6314V34.0807C18.9102 34.7033 19.2302 35.2561 19.7655 35.5761L29.7884 41.3517V24.244H29.7913V23.4323L39.9363 17.5728C40.9172 17.0049 41.9857 16.6168 43.0922 16.414L42.1155 13.101C39.5959 10.2848 35.9912 8.68459 32.2148 8.70205ZM32.2148 12.1206L32.1974 12.138C34.5161 12.138 36.7447 12.9381 38.5282 14.419C38.4555 14.4539 38.3129 14.5441 38.2082 14.5965L27.7198 20.6364C27.1845 20.939 26.8644 21.5092 26.8644 22.1318V36.3093L22.352 33.7083V21.9892C22.3491 16.5458 26.7626 12.1293 32.2148 12.1206Z"
            fill="white"
          />
          <path
            d="M56.3827 19.4397C53.5024 14.4509 47.7361 11.8707 42.1075 13.061L38.5332 14.3822L27.7518 20.6069C27.2126 20.9182 26.8939 21.4717 26.8844 22.0954L26.894 33.6632L41.7097 25.1094L41.7112 25.1119L42.4141 24.706L52.5612 30.5621C53.5434 31.1277 54.4137 31.859 55.1426 32.7158L57.5234 30.2134C58.7026 26.6233 58.286 22.7014 56.3827 19.4397ZM53.4221 21.149L53.3983 21.1426C54.5577 23.1507 54.9791 25.4808 54.5883 27.7658C54.5217 27.7202 54.3723 27.6419 54.2746 27.5773L43.7997 21.5141C43.27 21.2018 42.6162 21.2097 42.077 21.521L29.7989 28.6098L29.7952 23.4014L39.9442 17.5418C44.6569 14.8176 50.6885 16.4316 53.4221 21.149Z"
            fill="white"
          />
          <path
            d="M59.1679 45.7378C62.0481 40.749 61.3995 34.4652 57.5544 30.1858L54.6231 27.751L43.8416 21.5263C43.3024 21.215 42.6637 21.2158 42.1189 21.5194L32.1057 27.3116L46.9213 35.8655L46.9199 35.868L47.6228 36.2738L47.6248 47.9895C47.6262 49.1229 47.428 50.2423 47.0504 51.3019L50.4079 52.1125C54.1066 51.3387 57.2948 49.017 59.1679 45.7378ZM56.2073 44.0285L56.2009 44.0047C55.0416 46.0128 53.2343 47.5428 51.0601 48.3469C51.0663 48.2664 51.0594 48.0979 51.0665 47.981L51.0799 35.8778C51.0856 35.2629 50.7517 34.7007 50.2125 34.3894L37.9345 27.3006L42.4433 24.6932L52.5922 30.5527C57.3078 33.2719 58.9259 39.3024 56.2073 44.0285Z"
            fill="white"
          />
          <path
            d="M37.7852 61.298C43.5458 61.298 48.6634 57.5943 50.4469 52.1246L51.0898 48.3686V35.9193C51.0898 35.2967 50.7698 34.7439 50.2345 34.4239L40.2116 28.6483V45.756H40.2087V46.5677L30.0637 52.4272C29.0828 52.9951 28.0143 53.3832 26.9078 53.586L27.8845 56.899C30.4041 59.7152 34.0088 61.3154 37.7852 61.298ZM37.7852 57.8794L37.8026 57.862C35.4839 57.862 33.2553 57.0619 31.4718 55.581C31.5445 55.5461 31.6871 55.4559 31.7918 55.4035L42.2802 49.3636C42.8155 49.061 43.1356 48.4908 43.1356 47.8682V33.6907L47.648 36.2917V48.0108C47.6509 53.4542 43.2374 57.8707 37.7852 57.8794Z"
            fill="white"
          />
          <path
            d="M13.6173 50.5603C16.4976 55.5491 22.2639 58.1293 27.8925 56.939L31.4668 55.6178L42.2482 49.3931C42.7874 49.0818 43.1061 48.5283 43.1156 47.9046L43.106 36.3368L28.2903 44.8906L28.2888 44.8881L27.5859 45.294L17.4388 39.4379C16.4566 38.8723 15.5863 38.141 14.8574 37.2842L12.4766 39.7866C11.2974 43.3767 11.714 47.2986 13.6173 50.5603ZM16.5779 48.851L16.6017 48.8574C15.4423 46.8493 15.0209 44.5192 15.4117 42.2342C15.4783 42.2798 15.6277 42.3581 15.7254 42.4227L26.2003 48.4859C26.73 48.7982 27.3838 48.7903 27.923 48.479L40.2011 41.3902L40.2048 46.5986L30.0558 52.4582C25.3431 55.1824 19.3115 53.5684 16.5779 48.851Z"
            fill="white"
          />
          <path
            d="M10.8321 24.2622C7.95185 29.251 8.60049 35.5348 12.4456 39.8142L15.3769 42.249L26.1584 48.4737C26.6976 48.785 27.3363 48.7842 27.8811 48.4806L37.8943 42.6884L23.0787 34.1345L23.0801 34.132L22.3772 33.7262L22.3752 22.0105C22.3738 20.8771 22.572 19.7577 22.9496 18.6981L19.5921 17.8875C15.8934 18.6613 12.7052 20.983 10.8321 24.2622ZM13.7927 25.9715L13.7991 25.9953C14.9584 23.9872 16.7657 22.4572 18.9399 21.6531C18.9337 21.7336 18.9406 21.9021 18.9335 22.019L18.9201 34.1222C18.9144 34.7371 19.2483 35.2993 19.7875 35.6106L32.0655 42.6994L27.5567 45.3068L17.4078 39.4473C12.6922 36.7281 11.0741 30.6976 13.7927 25.9715Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_45659">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const GoogleCalanderIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_45677)">
          <path
            d="M53.4202 16.5789H16.5781V53.421H53.4202V16.5789Z"
            fill="white"
          />
          <path
            d="M53.4193 70.0001L69.9982 53.4212L61.7087 52.0068L53.4193 53.4212L51.9062 61.0035L53.4193 70.0001Z"
            fill="#EA4335"
          />
          <path
            d="M0 53.4212V64.4738C0 67.5271 2.47303 70.0001 5.52632 70.0001H16.5789L18.2812 61.7106L16.5789 53.4212L7.54665 52.0068L0 53.4212Z"
            fill="#188038"
          />
          <path
            d="M69.9982 16.5789V5.52632C69.9982 2.47303 67.5252 0 64.4719 0H53.4193C52.4106 4.11137 51.9062 7.13702 51.9062 9.07695C51.9062 11.0169 52.4106 13.5176 53.4193 16.5789C57.0859 17.6289 59.8491 18.1539 61.7087 18.1539C63.5684 18.1539 66.3315 17.6289 69.9982 16.5789Z"
            fill="#1967D2"
          />
          <path
            d="M70.0008 16.5789H53.4219V53.421H70.0008V16.5789Z"
            fill="#FBBC04"
          />
          <path
            d="M53.4202 53.4211H16.5781V70.0001H53.4202V53.4211Z"
            fill="#34A853"
          />
          <path
            d="M53.4211 0H5.52632C2.47303 0 0 2.47303 0 5.52632V53.4211H16.5789V16.5789H53.4211V0Z"
            fill="#4285F4"
          />
          <path
            d="M24.1358 45.1592C22.7588 44.229 21.8056 42.8704 21.2852 41.0744L24.4812 39.7572C24.7713 40.8625 25.2779 41.7191 26.0009 42.327C26.7194 42.9349 27.5944 43.2342 28.6167 43.2342C29.6621 43.2342 30.5602 42.9165 31.3108 42.2809C32.0615 41.6454 32.4391 40.8349 32.4391 39.854C32.4391 38.85 32.0431 38.0303 31.2509 37.3947C30.4588 36.7592 29.4641 36.4415 28.2759 36.4415H26.4292V33.2776H28.0871C29.1095 33.2776 29.9707 33.0013 30.6707 32.4487C31.3707 31.8961 31.7207 31.1408 31.7207 30.1783C31.7207 29.3217 31.4075 28.6401 30.7812 28.129C30.1549 27.6178 29.3628 27.3599 28.4003 27.3599C27.4608 27.3599 26.7148 27.6086 26.1621 28.1105C25.6099 28.6138 25.1947 29.2493 24.9556 29.9572L21.7917 28.6401C22.2108 27.452 22.9799 26.402 24.1082 25.4947C25.2365 24.5875 26.6779 24.1316 28.4279 24.1316C29.722 24.1316 30.8871 24.3803 31.9187 24.8822C32.9503 25.3842 33.7608 26.0796 34.3457 26.9638C34.9306 27.8526 35.2207 28.8474 35.2207 29.9526C35.2207 31.0809 34.949 32.0342 34.4056 32.8171C33.8621 33.6 33.1944 34.1987 32.4023 34.6178V34.8066C33.4251 35.2283 34.3135 35.9209 34.972 36.8099C35.6398 37.7079 35.9759 38.7809 35.9759 40.0336C35.9759 41.2862 35.6582 42.4053 35.0227 43.3862C34.3871 44.3671 33.5075 45.1408 32.3931 45.7026C31.274 46.2645 30.0167 46.55 28.6213 46.55C27.0049 46.5546 25.5128 46.0895 24.1358 45.1592ZM43.7681 29.2987L40.2588 31.8362L38.5042 29.1744L44.7996 24.6336H47.2128V46.0526H43.7681V29.2987Z"
            fill="#4285F4"
          />
        </g>
        <defs>
          <clipPath id="clip0_1214_45677">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ClickUpIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1214_45693)">
          <rect
            x="-291"
            y="-291"
            width="651"
            height="651"
            rx="100"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4297 50.9221L19.5032 43.9546C24.3231 50.2599 29.4434 53.1674 35.1444 53.1674C40.8147 53.1674 45.7902 50.2943 50.393 44.0378L59.595 50.8371C52.9549 59.8581 44.701 64.6238 35.1444 64.6238C25.6186 64.6238 17.285 59.8907 10.4297 50.9221Z"
            fill="url(#paint0_linear_1214_45693)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.6324 20.6402L18.4846 34.5897L11.0195 25.9106L34.6668 5.48389L58.1277 25.9269L50.6282 34.5752L34.6324 20.6402Z"
            fill="url(#paint1_linear_1214_45693)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1214_45693"
            x1="10.4297"
            y1="58.0127"
            x2="59.595"
            y2="58.0127"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#8930FD" />
            <stop offset="1" stop-color="#49CCF9" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1214_45693"
            x1="11.0195"
            y1="25.2774"
            x2="58.1277"
            y2="25.2774"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FF02F0" />
            <stop offset="1" stop-color="#FFC800" />
          </linearGradient>
          <clipPath id="clip0_1214_45693">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const GoogleContactIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.4358 34.1025C15.0334 34.1025 5 44.1358 5 56.5384V65.9615C5 68.1916 6.80838 69.9999 9.03844 69.9999H19.8077L30.5769 34.1025H27.4358Z"
          fill="#86A9FF"
        />
        <path
          d="M64.2292 48.9102C64.2292 40.7255 57.6061 34.1025 49.4216 34.1025H38.6523V69.9999H49.4216C57.6062 69.9999 64.2292 63.3768 64.2292 55.1923"
          fill="#578CFF"
        />
        <path
          d="M15.7695 48.9102C15.7695 40.7255 22.3927 34.1025 30.5772 34.1025H38.6541C46.8388 34.1025 53.4617 40.7257 53.4617 48.9102V55.1923C53.4617 63.377 46.8386 69.9999 38.6541 69.9999H19.808C17.5779 69.9999 15.7695 68.1916 15.7695 65.9615V48.9102Z"
          fill="#0057CC"
        />
        <path
          d="M34.6134 27.8205C42.2958 27.8205 48.5236 21.5927 48.5236 13.9103C48.5236 6.22784 42.2958 0 34.6134 0C26.931 0 20.7031 6.22784 20.7031 13.9103C20.7031 21.5927 26.931 27.8205 34.6134 27.8205Z"
          fill="#0057CC"
        />
      </svg>
    </>
  );
};
export const TwilioIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
          fill="#F22F46"
        />
        <path
          d="M35 60.7031C49.1954 60.7031 60.7031 49.1954 60.7031 35C60.7031 20.8046 49.1954 9.29688 35 9.29688C20.8046 9.29688 9.29688 20.8046 9.29688 35C9.29688 49.1954 20.8046 60.7031 35 60.7031Z"
          fill="white"
        />
        <path
          d="M26.3867 33.6328C30.3886 33.6328 33.6328 30.3886 33.6328 26.3867C33.6328 22.3848 30.3886 19.1406 26.3867 19.1406C22.3848 19.1406 19.1406 22.3848 19.1406 26.3867C19.1406 30.3886 22.3848 33.6328 26.3867 33.6328Z"
          fill="#F22F46"
        />
        <path
          d="M43.6133 33.6328C47.6152 33.6328 50.8594 30.3886 50.8594 26.3867C50.8594 22.3848 47.6152 19.1406 43.6133 19.1406C39.6114 19.1406 36.3672 22.3848 36.3672 26.3867C36.3672 30.3886 39.6114 33.6328 43.6133 33.6328Z"
          fill="#F22F46"
        />
        <path
          d="M26.3867 50.8594C30.3886 50.8594 33.6328 47.6152 33.6328 43.6133C33.6328 39.6114 30.3886 36.3672 26.3867 36.3672C22.3848 36.3672 19.1406 39.6114 19.1406 43.6133C19.1406 47.6152 22.3848 50.8594 26.3867 50.8594Z"
          fill="#F22F46"
        />
        <path
          d="M43.6133 50.8594C47.6152 50.8594 50.8594 47.6152 50.8594 43.6133C50.8594 39.6114 47.6152 36.3672 43.6133 36.3672C39.6114 36.3672 36.3672 39.6114 36.3672 43.6133C36.3672 47.6152 39.6114 50.8594 43.6133 50.8594Z"
          fill="#F22F46"
        />
      </svg>
    </>
  );
};
export const ZOHOIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.1976 13.0283C27.8347 13.1072 32.9593 15.0388 37.1576 19.099C41.3952 23.179 45.5146 27.3772 49.6537 31.5558C52.5905 34.5123 52.5511 39.1836 49.6537 42.1007C46.7761 44.9783 42.1442 45.0375 39.1877 42.1598C35.5019 38.5529 31.8753 34.8868 28.2486 31.2207C27.5785 30.5506 26.8295 30.0775 25.844 30.0381C24.4249 29.979 23.3408 30.5703 22.7101 31.8317C22.0597 33.0735 22.2173 34.3152 23.0846 35.4387C23.3999 35.8526 23.7941 36.2074 24.1686 36.5818C27.8544 40.2676 31.5205 44.0125 35.2457 47.6589C40.2718 52.5667 46.2833 54.2223 53.0045 52.2513C59.7256 50.3 63.9238 45.6485 65.5006 38.8288C68.1418 27.4758 58.6612 16.4382 47.052 17.2069C45.7117 17.2857 44.3912 17.5025 43.0706 17.8573C41.6909 18.2318 40.6068 17.6405 40.2915 16.4185C39.9761 15.2753 40.6462 14.2898 42.0062 13.8759C54.5221 10.1309 68.0038 18.8231 69.7777 31.7923C71.4334 43.8943 63.6873 54.7151 51.6445 56.7847C44.5883 58.0067 38.2613 56.1145 33.0185 51.187C28.702 47.107 24.5628 42.8299 20.3843 38.612C17.4278 35.6161 17.4672 30.9842 20.3843 28.0868C23.3014 25.1894 27.9333 25.15 30.9292 28.1065C34.5755 31.6938 38.1825 35.3401 41.7894 38.9668C42.7355 39.9326 43.8393 40.3859 45.1796 40.0705C47.7222 39.4398 48.5697 36.3847 46.7169 34.4532C45.0416 32.699 43.2874 31.0039 41.5726 29.2891C39.2665 26.983 37.0196 24.6376 34.6741 22.4103C29.6283 17.6011 23.6365 16.0045 16.9745 17.9558C10.4307 19.8283 6.2719 24.3025 4.61626 30.9054C1.38381 43.8746 13.5449 55.7992 26.4747 52.4287C26.9478 52.3105 27.4011 52.1134 27.9135 52.1725C28.8596 52.2908 29.6283 53.0595 29.7269 53.9858C29.8451 55.0699 29.2538 55.9174 28.1304 56.2525C25.5089 57.0212 22.8481 57.2577 20.1478 57.0212C10.7855 56.2131 2.76351 49.2751 0.615117 40.1494C-2.69617 26.2932 7.76987 13.048 22.1976 13.0283Z"
          fill="#036FB9"
        />
      </svg>
    </>
  );
};
export const OpenAIIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46522)">
          <rect width="70" height="70" rx="35" fill="black" />
          <path
            d="M32.2148 8.70229C26.4542 8.70229 21.3366 12.4059 19.5531 17.8756L18.9102 21.6316V34.0809C18.9102 34.7035 19.2302 35.2563 19.7655 35.5764L29.7884 41.3519V24.2443H29.7913V23.4325L39.9363 17.573C40.9172 17.0051 41.9857 16.6171 43.0922 16.4143L42.1155 13.1013C39.5959 10.285 35.9912 8.68483 32.2148 8.70229ZM32.2148 12.1208L32.1974 12.1383C34.5161 12.1383 36.7447 12.9384 38.5282 14.4192C38.4555 14.4542 38.3129 14.5444 38.2082 14.5967L27.7198 20.6366C27.1845 20.9392 26.8644 21.5094 26.8644 22.132V36.3095L22.352 33.7085V21.9895C22.3491 16.546 26.7626 12.1296 32.2148 12.1208Z"
            fill="white"
          />
          <path
            d="M56.3827 19.4397C53.5024 14.4509 47.7361 11.8707 42.1075 13.061L38.5332 14.3822L27.7518 20.6069C27.2126 20.9182 26.8939 21.4717 26.8844 22.0954L26.894 33.6632L41.7097 25.1094L41.7112 25.1119L42.4141 24.706L52.5612 30.5621C53.5434 31.1277 54.4137 31.859 55.1426 32.7158L57.5234 30.2134C58.7026 26.6233 58.286 22.7014 56.3827 19.4397ZM53.4221 21.149L53.3983 21.1426C54.5577 23.1507 54.9791 25.4808 54.5883 27.7658C54.5217 27.7202 54.3723 27.6419 54.2746 27.5773L43.7997 21.5141C43.27 21.2018 42.6162 21.2097 42.077 21.521L29.7989 28.6098L29.7952 23.4014L39.9442 17.5418C44.6569 14.8176 50.6885 16.4316 53.4221 21.149Z"
            fill="white"
          />
          <path
            d="M59.1679 45.7379C62.0481 40.7491 61.3995 34.4653 57.5544 30.1859L54.6231 27.7511L43.8416 21.5264C43.3024 21.2151 42.6637 21.2159 42.1189 21.5195L32.1057 27.3117L46.9213 35.8656L46.9199 35.8681L47.6228 36.274L47.6248 47.9896C47.6262 49.123 47.428 50.2424 47.0504 51.302L50.4079 52.1126C54.1066 51.3388 57.2948 49.0171 59.1679 45.7379ZM56.2073 44.0287L56.2009 44.0048C55.0416 46.0129 53.2343 47.5429 51.0601 48.347C51.0663 48.2665 51.0594 48.098 51.0665 47.9811L51.0799 35.878C51.0856 35.2631 50.7517 34.7008 50.2125 34.3895L37.9345 27.3007L42.4433 24.6933L52.5922 30.5528C57.3078 33.2721 58.9259 39.3026 56.2073 44.0287Z"
            fill="white"
          />
          <path
            d="M37.7852 61.2977C43.5458 61.2977 48.6634 57.5941 50.4469 52.1244L51.0898 48.3684V35.9191C51.0898 35.2965 50.7698 34.7437 50.2345 34.4236L40.2116 28.6481V45.7557H40.2087V46.5675L30.0637 52.427C29.0828 52.9949 28.0143 53.3829 26.9078 53.5857L27.8845 56.8987C30.4041 59.715 34.0088 61.3152 37.7852 61.2977ZM37.7852 57.8792L37.8026 57.8617C35.4839 57.8617 33.2553 57.0616 31.4718 55.5808C31.5445 55.5458 31.6871 55.4556 31.7918 55.4033L42.2802 49.3634C42.8155 49.0608 43.1356 48.4906 43.1356 47.868V33.6905L47.648 36.2915V48.0105C47.6509 53.454 43.2374 57.8704 37.7852 57.8792Z"
            fill="white"
          />
          <path
            d="M13.6173 50.5603C16.4976 55.5491 22.2639 58.1293 27.8925 56.939L31.4668 55.6178L42.2482 49.3931C42.7874 49.0818 43.1061 48.5283 43.1156 47.9046L43.106 36.3368L28.2903 44.8906L28.2888 44.8881L27.5859 45.294L17.4388 39.4379C16.4566 38.8723 15.5863 38.141 14.8574 37.2842L12.4766 39.7866C11.2974 43.3767 11.714 47.2986 13.6173 50.5603ZM16.5779 48.851L16.6017 48.8574C15.4423 46.8493 15.0209 44.5192 15.4117 42.2342C15.4783 42.2798 15.6277 42.3581 15.7254 42.4227L26.2003 48.4859C26.73 48.7982 27.3838 48.7903 27.923 48.479L40.2011 41.3902L40.2048 46.5986L30.0558 52.4582C25.3431 55.1824 19.3115 53.5684 16.5779 48.851Z"
            fill="white"
          />
          <path
            d="M10.8321 24.2621C7.95185 29.2509 8.60049 35.5347 12.4456 39.8141L15.3769 42.2489L26.1584 48.4736C26.6976 48.7849 27.3363 48.7841 27.8811 48.4805L37.8943 42.6883L23.0787 34.1344L23.0801 34.1319L22.3772 33.726L22.3752 22.0104C22.3738 20.877 22.572 19.7576 22.9496 18.698L19.5921 17.8874C15.8934 18.6612 12.7052 20.9829 10.8321 24.2621ZM13.7927 25.9713L13.7991 25.9952C14.9584 23.9871 16.7657 22.4571 18.9399 21.653C18.9337 21.7335 18.9406 21.902 18.9335 22.0189L18.9201 34.122C18.9144 34.7369 19.2483 35.2992 19.7875 35.6105L32.0655 42.6993L27.5567 45.3067L17.4078 39.4472C12.6922 36.7279 11.0741 30.6974 13.7927 25.9713Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46522">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const XeroIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46540)">
          <path
            d="M35.0008 70C54.3302 70 70 54.329 70 35C70 15.6679 54.3317 0 35.0008 0C15.6699 0 0 15.6679 0 35C0 54.329 15.6699 70 35.0008 70Z"
            fill="#1FC0E7"
          />
          <path
            d="M17.0553 34.9912L23.0162 29.0024C23.2137 28.8032 23.3242 28.5357 23.3242 28.2526C23.3242 27.6615 22.845 27.1824 22.2555 27.1824C21.9677 27.1824 21.6986 27.2944 21.4964 27.5012L15.5386 33.4637L9.55749 27.4904C9.35526 27.2912 9.08771 27.1824 8.80304 27.1824C8.21193 27.1824 7.73438 27.6615 7.73438 28.251C7.73438 28.5388 7.84949 28.811 8.05482 29.0132L14.0157 34.9819L8.05793 40.9552C7.84949 41.1637 7.73438 41.4344 7.73438 41.7221C7.73438 42.3132 8.21349 42.7924 8.80304 42.7924C9.08771 42.7924 9.35526 42.6835 9.55749 42.4812L15.5308 36.5048L21.4808 42.4579C21.6924 42.6757 21.963 42.7924 22.2555 42.7924C22.8435 42.7924 23.3226 42.3132 23.3226 41.7221C23.3226 41.4375 23.2137 41.1699 23.0115 40.9677L17.0537 34.985L17.0553 34.9912ZM52.4924 34.9897C52.4924 36.063 53.3635 36.9341 54.4368 36.9341C55.5039 36.9341 56.375 36.063 56.375 34.9897C56.375 33.9164 55.5039 33.0452 54.4353 33.0452C53.3666 33.0452 52.497 33.9164 52.497 34.9897H52.4924ZM48.8135 34.9897C48.8135 31.8864 51.3335 29.3586 54.4353 29.3586C57.5308 29.3586 60.0555 31.8864 60.0555 34.9897C60.0555 38.093 57.5324 40.6208 54.4353 40.6208C51.335 40.6208 48.8135 38.0961 48.8135 34.9897ZM46.6015 34.9897C46.6015 39.3141 50.117 42.8359 54.4353 42.8359C58.7535 42.8359 62.269 39.3172 62.269 34.9912C62.269 30.6668 58.7535 27.145 54.4353 27.145C50.1155 27.145 46.6015 30.6652 46.6015 34.9912V34.9897ZM46.0462 27.2788H45.7195C44.7317 27.2788 43.7797 27.5899 42.9848 28.2044C42.8759 27.7284 42.4466 27.3644 41.9364 27.3644C41.3499 27.3644 40.8786 27.8388 40.8786 28.4284L40.8817 41.6428C40.8817 42.2292 41.3639 42.7068 41.9473 42.7068C42.5353 42.7068 43.0144 42.2292 43.0159 41.6397V33.5135C43.0159 30.8068 43.2648 29.7117 45.5795 29.4224C45.7973 29.3959 46.0275 29.4006 46.0306 29.4006C46.6622 29.3772 47.1133 28.9401 47.1133 28.3506C47.1133 27.7595 46.631 27.2804 46.0399 27.2804L46.0462 27.2788ZM25.5346 33.7001C25.5346 33.669 25.5377 33.6379 25.5393 33.6099C26.1584 31.1521 28.3797 29.3368 31.0226 29.3368C33.6982 29.3368 35.9382 31.1941 36.5293 33.6955H25.533L25.5346 33.7001ZM38.7148 33.4979C38.2544 31.3155 37.0613 29.5219 35.2459 28.3708C32.589 26.6815 29.0828 26.7748 26.5193 28.6041C24.4255 30.0928 23.2168 32.5319 23.2168 35.0441C23.2168 35.6741 23.2946 36.3104 23.4502 36.9372C24.2404 40.0484 26.9128 42.4066 30.0986 42.797C31.0444 42.9121 31.9653 42.8592 32.9142 42.6104C33.7355 42.4081 34.5273 42.0784 35.2568 41.6086C36.0144 41.1217 36.6475 40.4777 37.2635 39.7077C37.2728 39.6921 37.2853 39.6812 37.2977 39.6657C37.7239 39.1368 37.6446 38.3808 37.1779 38.023C36.7828 37.7197 36.1202 37.5968 35.6006 38.2657C35.4886 38.4275 35.3626 38.5924 35.2273 38.7557C34.8119 39.2146 34.297 39.6579 33.681 40.0032C32.8939 40.4232 32.001 40.6612 31.0522 40.6675C27.9442 40.6317 26.2828 38.4586 25.6902 36.9092C25.5875 36.6184 25.5082 36.3181 25.4522 36.007L25.4366 35.8437H36.5899C38.1175 35.8095 38.9388 34.7284 38.7117 33.4948L38.7148 33.4979Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46540">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ZendeskIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46551)">
          <path
            d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
            fill="#03363D"
          />
          <path
            d="M33.8438 29.5815V46.4868H19.8438L33.8438 29.5815ZM33.8438 23.5181C33.8438 27.3872 30.7129 30.5181 26.8438 30.5181C22.9746 30.5181 19.8438 27.3872 19.8438 23.5181H33.8438ZM36.1543 46.4868C36.1543 42.6177 39.2852 39.4868 43.1543 39.4868C47.0234 39.4868 50.1543 42.6177 50.1543 46.4868H36.1543ZM36.1543 40.4165V23.5181H50.1543L36.1543 40.4165Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46551">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const WaveIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46561)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.83619 52.8523C9.92251 54.1539 14.2862 52.0663 15.5345 48.2183L20.1579 33.2458C21.4062 29.3977 19.0874 25.1834 15.0011 23.8817L14.6596 23.775C10.5733 22.4734 6.20961 24.561 4.96131 28.409L0.337974 43.3815C-0.910327 47.2296 1.40845 51.4439 5.49477 52.7456L5.83619 52.8523Z"
            fill="#0A4F99"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M54.6273 10.2895C55.4986 8.18052 57.1097 6.58013 59.0017 5.71592C59.0977 5.67325 59.1902 5.62702 59.2862 5.58434C59.3396 5.563 59.3965 5.54166 59.4498 5.52032C61.0111 4.91929 62.7324 4.8126 64.3897 5.33895L64.7311 5.44919C68.8174 6.75084 70.9904 11.4097 69.5643 15.8055C69.5643 15.8055 58.3758 53.6066 58.3651 53.6386C55.4417 62.3411 46.1524 66.8471 38.1576 64.5852C38.1576 64.5852 36.0024 63.9451 35.1133 63.3049C43.0619 61.5978 53.0412 14.1268 54.6273 10.2895Z"
            fill="#6FB1E2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.13485 57.8527C8.85971 58.4003 10.6379 58.4359 12.3237 58.0447C12.5904 57.9878 12.8536 57.9131 13.1096 57.8278C16.4029 56.7822 19.2338 54.0864 20.4358 50.3878L29.1562 21.6092C30.5965 17.2349 35.0883 14.7205 39.1603 16.0186L39.5018 16.1288C43.5881 17.4305 45.761 22.0894 44.3349 26.4851C44.3349 26.4851 36.0378 53.7557 34.8784 56.0247C26.4142 71.3635 10.5099 63.8701 6.00391 57.4508C6.26352 57.5575 6.52314 57.6642 6.79343 57.7495L7.13485 57.8527Z"
            fill="#396DB4"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46561">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ClosePIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46573)">
          <path
            d="M53.1056 45.7015C53.2402 44.7351 53.3551 43.7505 53.451 42.7495C52.4119 44.0076 51.3077 45.2597 50.1419 46.4998C51.1693 46.258 52.1575 45.991 53.1056 45.7015ZM17.1093 24.6236C16.9712 25.5826 16.8511 26.5583 16.7522 27.5508C17.7758 26.2998 18.8653 25.0561 20.0166 23.8264C19.0096 24.0691 18.0416 24.3363 17.1093 24.6236ZM53.7637 32.4925C54.3218 31.5893 54.8344 30.6962 55.3012 29.8159C54.7047 29.0276 54.0807 28.2405 53.4311 27.4555C53.5964 29.0941 53.7081 30.7757 53.7637 32.4925ZM14.9434 40.3643C15.5151 41.13 16.1118 41.8945 16.7339 42.6564C16.5836 41.0627 16.4814 39.4287 16.4294 37.7613C15.8915 38.6391 15.3982 39.5072 14.9434 40.3643ZM45.5742 53.1912C45.1433 54.5637 44.6677 55.8531 44.1505 57.0459C43.329 58.9402 42.4065 60.593 41.4107 61.9783C39.5202 64.6089 37.3654 66.2657 35.126 66.7004C32.7672 66.193 30.5776 64.5258 28.6919 61.9189C26.8374 62.6151 25.0258 63.1092 23.2812 63.3845C23.8445 64.1643 24.4402 64.8875 25.0718 65.5415C27.7869 68.3521 30.1579 69.9542 35.0968 69.9542C40.036 69.9542 42.833 68.1405 45.636 64.9864C46.0579 64.5116 46.4619 64.0028 46.8516 63.4687C47.8927 62.042 48.819 60.4119 49.6279 58.6052C50.5262 56.5978 51.2802 54.3744 51.8897 51.9789C49.8957 52.4833 47.7826 52.8878 45.5742 53.1912ZM45.5328 5.3115C42.7094 2.08551 39.9777 0.226562 35.0968 0.226562C30.2159 0.226562 28.48 1.60014 25.8906 4.03462C25.007 4.86536 24.1828 5.82329 23.4158 6.88882C22.4165 8.27765 21.5176 9.85442 20.7234 11.5933C19.7793 13.6595 18.9829 15.9526 18.3407 18.4282C20.3186 17.9121 22.4124 17.4942 24.6001 17.1785C25.0419 15.7472 25.5327 14.4047 26.069 13.1662C26.867 11.3233 27.7629 9.70816 28.7301 8.34139C30.6411 5.64108 32.8337 3.92131 35.126 3.42259C37.3986 3.8445 39.5842 5.53785 41.4949 8.2368C43.2814 7.55968 45.0284 7.07785 46.7176 6.80466C46.3363 6.28034 45.9427 5.77999 45.5328 5.3115ZM45.6472 17.1516C44.7042 17.0208 43.7441 16.9086 42.7685 16.8149C44.0004 17.8249 45.225 18.8983 46.436 20.0322C46.1958 19.035 45.9313 18.0755 45.6472 17.1516ZM24.569 53.1477C25.5518 53.2901 26.5522 53.4132 27.5706 53.514C26.2932 52.461 25.0217 51.341 23.7625 50.1575C24.0069 51.1947 24.2765 52.1916 24.569 53.1477ZM63.6887 48.7777C63.6525 48.1608 63.5811 47.5332 63.4836 46.8983C63.215 45.1513 62.7209 43.3414 62.0174 41.4892C61.2256 39.405 60.1704 37.2683 58.8857 35.1113C57.8346 36.8793 56.6279 38.6612 55.2824 40.439C55.968 41.7486 56.5574 43.0292 57.0447 44.2694C57.8005 46.1918 58.3139 48.015 58.5841 49.6989C59.0929 52.8693 58.7372 55.5424 57.469 57.4215C55.4611 58.7182 52.7665 59.0938 49.6279 58.6052C48.819 60.4119 47.8927 62.042 46.8516 63.4687C47.7657 63.6117 48.6637 63.6961 49.54 63.7114C53.4474 63.7789 56.257 63.2353 59.7493 59.7429C63.2417 56.2505 63.9368 52.9899 63.6887 48.7777ZM21.4193 6.65431C17.1417 6.36967 13.8958 6.9866 10.4443 10.4381C6.99304 13.8894 6.73673 16.088 6.62724 19.6405C6.58938 20.8692 6.68662 22.1475 6.90397 23.4617C7.18316 25.1487 7.66553 26.8974 8.33557 28.6861C9.12137 30.7842 10.1643 32.9367 11.4384 35.1089C12.4743 33.3466 13.661 31.5721 14.9861 29.8039C14.3071 28.5147 13.7185 27.252 13.232 26.0288C12.4901 24.163 11.9783 22.3891 11.6907 20.7387C11.1179 17.4515 11.4485 14.6632 12.7249 12.6773C14.6481 11.3563 17.4239 11.0136 20.7234 11.5933C21.5176 9.85442 22.4165 8.27765 23.4158 6.88882C22.7403 6.77878 22.0735 6.69789 21.4193 6.65431ZM53.4311 27.4555C53.3355 26.5092 53.2222 25.5775 53.0909 24.6623C52.7736 22.4512 52.3517 20.3359 51.8295 18.3386C51.2034 15.9422 50.4331 13.7167 49.5231 11.7052C47.8758 11.9833 46.098 12.4905 44.226 13.2283C44.7435 14.442 45.2179 15.7554 45.6472 17.1516C45.9313 18.0755 46.1958 19.035 46.436 20.0322C46.6817 21.0514 46.9028 22.1077 47.0984 23.198C47.4718 25.2768 47.7491 27.4803 47.9185 29.7875C48.0435 31.4923 48.1127 33.2505 48.1127 35.0615C48.1127 36.8875 48.0425 38.659 47.9153 40.3758C49.4465 38.6086 50.828 36.845 52.045 35.1067C52.6603 34.2275 53.2304 33.3562 53.7637 32.4925C53.7081 30.7757 53.5964 29.0941 53.4311 27.4555ZM24.569 53.1477C24.2765 52.1916 24.0069 51.1947 23.7625 50.1575C23.5307 49.1732 23.3194 48.1564 23.1342 47.1034C22.7618 44.9876 22.49 42.7351 22.3247 40.3709C22.2048 38.6579 22.1392 36.888 22.1392 35.0615C22.1392 33.2385 22.2086 31.4716 22.3342 29.7608C20.7988 31.5337 19.4179 33.3096 18.1955 35.0648C17.5649 35.9707 16.9753 36.8703 16.4294 37.7613C16.4814 39.4287 16.5836 41.0627 16.7339 42.6564C16.8293 43.6663 16.9426 44.661 17.0771 45.6359C17.3789 47.8208 17.7804 49.9116 18.2788 51.8866C18.8922 54.3153 19.6541 56.567 20.5632 58.5987C22.25 58.3184 24.069 57.8012 25.9846 57.0412C25.467 55.8373 24.9939 54.5362 24.569 53.1477ZM29.8422 14.9296C29.04 15.5359 28.2387 16.1705 27.4398 16.8315C29.1125 16.6627 30.8298 16.5494 32.5839 16.4949C31.6586 15.9254 30.7443 15.4065 29.8422 14.9296ZM12.6614 57.5378C11.3407 55.6145 10.9977 52.8388 11.5776 49.5392C9.8388 48.745 8.26175 47.8462 6.87319 46.8466C6.76316 47.5223 6.68199 48.1891 6.63841 48.8433C6.35378 53.121 6.97098 56.3668 10.4222 59.8181C13.8735 63.2693 16.0721 63.5256 19.6246 63.6354C20.8021 63.6716 22.0248 63.5831 23.2812 63.3845C22.2637 61.9761 21.3567 60.3726 20.5632 58.5987C17.3457 59.1331 14.6151 58.7931 12.6614 57.5378ZM29.7923 55.2741C28.4918 55.9596 27.2181 56.5518 25.9846 57.0412C26.7883 58.9103 27.6978 60.5448 28.6919 61.9189C30.7718 61.1383 32.9048 60.1049 35.0576 58.8446C33.3098 57.8003 31.5491 56.6054 29.7923 55.2741ZM40.3912 55.2871C41.1427 54.725 41.8928 54.1394 42.6407 53.5287C41.0809 53.6758 39.4823 53.7763 37.8516 53.8294C38.7082 54.3562 39.5553 54.8424 40.3912 55.2871ZM25.9846 57.0412C24.069 57.8012 22.25 58.3184 20.5632 58.5987C21.3567 60.3726 22.2637 61.9761 23.2812 63.3845C25.0258 63.1092 26.8374 62.6151 28.6919 61.9189C27.6978 60.5448 26.7883 58.9103 25.9846 57.0412ZM59.727 10.5133C56.2346 7.02092 52.9743 6.32555 48.7618 6.57368C48.0915 6.61318 47.4089 6.69298 46.7176 6.80466C45.0284 7.07785 43.2814 7.55968 41.4949 8.2368C39.3919 9.03403 37.2355 10.0996 35.0587 11.3988C36.8414 12.4417 38.6371 13.6391 40.4269 14.978C41.7253 14.2985 42.9956 13.7131 44.226 13.2283C46.098 12.4905 47.8758 11.9833 49.5231 11.7052C52.7635 11.1583 55.4951 11.5042 57.4056 12.7936C58.7026 14.8013 59.0779 17.4961 58.5893 20.6347C60.396 21.4436 62.0261 22.3697 63.4531 23.411C63.5961 22.4966 63.6805 21.5986 63.6955 20.7224C63.7633 16.8152 63.2197 14.0057 59.727 10.5133ZM57.03 26.1121C56.55 27.3136 55.9721 28.5512 55.3012 29.8159C54.8344 30.6962 54.3218 31.5893 53.7637 32.4925C53.2304 33.3562 52.6603 34.2275 52.045 35.1067C50.828 36.845 49.4465 38.6086 47.9153 40.3758C46.7672 41.7009 45.5374 43.0282 44.2167 44.3486C42.9357 45.6296 41.6455 46.8231 40.355 47.938C42.7097 47.7732 44.9529 47.5027 47.0614 47.1326C48.1236 46.9463 49.1491 46.7338 50.1419 46.4998C51.3077 45.2597 52.4119 44.0076 53.451 42.7495C54.0859 41.9809 54.6984 41.2103 55.2824 40.439C56.6279 38.6612 57.8346 36.8793 58.8857 35.1113C60.1443 32.995 61.1788 30.8985 61.9624 28.8517C60.5774 27.8561 58.9243 26.9336 57.03 26.1121ZM23.156 23.1686C22.0749 23.3631 21.0276 23.5829 20.0166 23.8264C18.8653 25.0561 17.7758 26.2998 16.7522 27.5508C16.1396 28.2998 15.5499 29.051 14.9861 29.8039C13.661 31.5721 12.4743 33.3466 11.4384 35.1089C10.1618 37.2811 9.11456 39.4339 8.32576 41.5323C9.69253 42.4998 11.3074 43.3956 13.1506 44.1936C13.6479 42.9535 14.2493 41.6723 14.9434 40.3643C15.3982 39.5072 15.8915 38.6391 16.4294 37.7613C16.9753 36.8703 17.5649 35.9707 18.1955 35.0648C19.4179 33.3096 20.7988 31.5337 22.3342 29.7608C23.4294 28.4965 24.5993 27.234 25.8505 25.9827C27.1495 24.6835 28.4602 23.4739 29.7719 22.3441C27.4548 22.5141 25.2423 22.793 23.156 23.1686ZM64.9705 24.6263C64.4957 24.2044 63.9869 23.8005 63.4531 23.411C62.0261 22.3697 60.396 21.4436 58.5893 20.6347C56.5449 19.7195 54.2763 18.9542 51.8295 18.3386C52.3517 20.3359 52.7736 22.4512 53.0909 24.6623C54.495 25.1 55.8127 25.5843 57.03 26.1121C58.9243 26.9336 60.5774 27.8561 61.9624 28.8517C64.593 30.7425 66.2498 32.8972 66.6845 35.1367C66.1844 37.4614 64.5595 39.6221 62.0174 41.4892C62.7209 43.3414 63.215 45.1513 63.4836 46.8983C64.2195 46.3596 64.9037 45.7914 65.5256 45.1908C68.3365 42.4758 69.9386 40.1048 69.9386 35.1656C69.9386 30.2266 68.1246 27.4296 64.9705 24.6263ZM17.0771 45.6359C15.6782 45.2009 14.3643 44.7193 13.1506 44.1936C11.3074 43.3956 9.69253 42.4998 8.32576 41.5323C5.62545 39.6213 3.90541 37.429 3.4067 35.1367C3.8346 32.8316 5.56907 30.6158 8.33557 28.6861C7.66553 26.8974 7.18316 25.1487 6.90397 23.4617C6.33716 23.8683 5.79841 24.2899 5.29588 24.7298C2.06989 27.5533 0.210938 30.2849 0.210938 35.1656C0.210938 40.0468 1.58424 41.7823 4.01872 44.372C4.84946 45.2556 5.80767 46.0798 6.87319 46.8466C8.26175 47.8462 9.8388 48.745 11.5776 49.5392C13.6063 50.4661 15.8544 51.2506 18.2788 51.8866C17.7804 49.9116 17.3789 47.8208 17.0771 45.6359ZM35.1488 18.1768C34.2876 17.5787 33.4318 17.0165 32.5839 16.4949C30.8298 16.5494 29.1125 16.6627 27.4398 16.8315C26.4776 16.9288 25.5305 17.0443 24.6001 17.1785C22.4124 17.4942 20.3186 17.9121 18.3407 18.4282C15.9381 19.0552 13.7068 19.8268 11.6907 20.7387C11.9783 22.3891 12.4901 24.163 13.232 26.0288C14.4329 25.5175 15.7305 25.0482 17.1093 24.6236C18.0416 24.3363 19.0096 24.0691 20.0166 23.8264C21.0276 23.5829 22.0749 23.3631 23.156 23.1686C25.2423 22.793 27.4548 22.5141 29.7719 22.3441C31.4764 22.2188 33.2346 22.1499 35.0456 22.1499C36.9258 22.1499 38.7483 22.2245 40.5124 22.3591C38.7197 20.8057 36.9233 19.4098 35.1488 18.1768ZM57.0447 44.2694C55.828 44.7937 54.5113 45.2722 53.1056 45.7015C52.1575 45.991 51.1693 46.258 50.1419 46.4998C49.1491 46.7338 48.1236 46.9463 47.0614 47.1326C44.9529 47.5027 42.7097 47.7732 40.355 47.938C38.642 48.0578 36.8724 48.1234 35.0456 48.1234C33.2768 48.1234 31.5606 48.0586 29.8972 47.9401C31.6445 49.4534 33.3879 50.8197 35.1074 52.0257C36.0305 52.6735 36.9457 53.2721 37.8516 53.8294C39.4823 53.7763 41.0809 53.6758 42.6407 53.5287C43.6346 53.4347 44.6141 53.3233 45.5742 53.1912C47.7826 52.8878 49.8957 52.4833 51.8897 51.9789C54.312 51.3663 56.5574 50.6056 58.5841 49.6989C58.3139 48.015 57.8005 46.1918 57.0447 44.2694ZM40.3912 55.2871C39.5553 54.8424 38.7082 54.3562 37.8516 53.8294C36.9457 53.2721 36.0305 52.6735 35.1074 52.0257C33.3879 50.8197 31.6445 49.4534 29.8972 47.9401C28.5686 46.7894 27.238 45.5566 25.9137 44.2323C24.633 42.9516 23.4395 41.6614 22.3247 40.3709C22.49 42.7351 22.7618 44.9876 23.1342 47.1034C23.3194 48.1564 23.5307 49.1732 23.7625 50.1575C25.0217 51.341 26.2932 52.461 27.5706 53.514C28.3095 54.1233 29.0507 54.7119 29.7923 55.2741C31.5491 56.6054 33.3098 57.8003 35.0576 58.8446C37.2058 60.1283 39.3339 61.1829 41.4107 61.9783C42.4065 60.593 43.329 58.9402 44.1505 57.0459C42.9314 56.5589 41.6749 55.9705 40.3912 55.2871ZM47.0984 23.198C46.9028 22.1077 46.6817 21.0514 46.436 20.0322C45.225 18.8983 44.0004 17.8249 42.7685 16.8149C41.9903 16.1768 41.2091 15.5636 40.4269 14.978C38.6371 13.6391 36.8414 12.4417 35.0587 11.3988C32.9186 10.1475 30.7979 9.11874 28.7301 8.34139C27.7629 9.70816 26.867 11.3233 26.069 13.1662C27.2911 13.6565 28.5536 14.2484 29.8422 14.9296C30.7443 15.4065 31.6586 15.9254 32.5839 16.4949C33.4318 17.0165 34.2876 17.5787 35.1488 18.1768C36.9233 19.4098 38.7197 20.8057 40.5124 22.3591C41.773 23.4516 43.0319 24.6184 44.2799 25.8664C45.5788 27.1654 46.7887 28.4758 47.9185 29.7875C47.7491 27.4803 47.4718 25.2768 47.0984 23.198Z"
            fill="#49BC82"
          />
          <path
            d="M53.1043 45.7015C53.2389 44.7351 53.3538 43.7505 53.4497 42.7495C52.4106 44.0076 51.3064 45.2597 50.1406 46.4998C51.168 46.258 52.1562 45.991 53.1043 45.7015Z"
            fill="#49BC82"
          />
          <path
            d="M17.111 24.6234C16.9729 25.5824 16.8528 26.5581 16.7539 27.5506C17.7775 26.2996 18.867 25.0559 20.0183 23.8262C19.0113 24.0689 18.0433 24.3361 17.111 24.6234Z"
            fill="#49BC82"
          />
          <path
            d="M53.7623 32.4926C54.3203 31.5894 54.833 30.6963 55.2998 29.816C54.7033 29.0277 54.0793 28.2405 53.4297 27.4556C53.595 29.0942 53.7067 30.7758 53.7623 32.4926Z"
            fill="#57B6DF"
          />
          <path
            d="M14.9414 40.3643C15.5131 41.1299 16.1099 41.8945 16.732 42.6563C16.5816 41.0627 16.4795 39.4287 16.4275 37.7612C15.8895 38.6391 15.3963 39.5071 14.9414 40.3643Z"
            fill="#57B6DF"
          />
          <path
            d="M45.5742 53.1913C45.1433 54.5638 44.6677 55.8532 44.1505 57.046C43.329 58.9403 42.4065 60.5931 41.4107 61.9784C39.5202 64.609 37.3654 66.2658 35.126 66.7005C32.7672 66.1931 30.5776 64.5259 28.692 61.919C26.8374 62.6152 25.0258 63.1093 23.2812 63.3846C23.8445 64.1644 24.4402 64.8876 25.0718 65.5416C27.7869 68.3522 30.1579 69.9543 35.0968 69.9543C40.036 69.9543 42.833 68.1406 45.636 64.9865C46.0579 64.5117 46.4619 64.0029 46.8516 63.4688C47.8927 62.0421 48.819 60.412 49.6279 58.6053C50.5262 56.5979 51.2802 54.3745 51.8897 51.979C49.8957 52.4834 47.7826 52.8879 45.5742 53.1913Z"
            fill="#49BC82"
          />
          <path
            d="M45.532 5.3115C42.7086 2.08551 39.9769 0.226562 35.096 0.226562C30.2151 0.226562 28.4792 1.60014 25.8898 4.03462C25.0062 4.86536 24.182 5.82329 23.415 6.88882C22.4156 8.27765 21.5168 9.85442 20.7226 11.5933C19.7785 13.6595 18.9821 15.9526 18.3398 18.4282C20.3178 17.9121 22.4116 17.4942 24.5993 17.1785C25.041 15.7472 25.5319 14.4047 26.0682 13.1662C26.8662 11.3233 27.7621 9.70816 28.7293 8.34139C30.6402 5.64108 32.8328 3.92131 35.1251 3.42259C37.3978 3.8445 39.5833 5.53785 41.494 8.2368C43.2805 7.55968 45.0275 7.07785 46.7168 6.80466C46.3355 6.28034 45.9419 5.77999 45.532 5.3115Z"
            fill="#49BC82"
          />
          <path
            d="M45.6482 17.1516C44.7053 17.0209 43.7452 16.9086 42.7695 16.8149C44.0015 17.8249 45.2261 18.8983 46.437 20.0322C46.1968 19.0351 45.9323 18.0755 45.6482 17.1516Z"
            fill="#276392"
          />
          <path
            d="M24.5682 53.1473C25.5509 53.2898 26.5514 53.4129 27.5698 53.5137C26.2923 52.4607 25.0209 51.3407 23.7617 50.1572C24.006 51.1944 24.2757 52.1913 24.5682 53.1473Z"
            fill="#276392"
          />
          <path
            d="M63.6886 48.7777C63.6524 48.1607 63.581 47.5332 63.4835 46.8983C63.2149 45.1513 62.7209 43.3414 62.0173 41.4892C61.2255 39.405 60.1704 37.2683 58.8856 35.1113C57.8345 36.8793 56.6279 38.6612 55.2823 40.439C55.9679 41.7485 56.5573 43.0292 57.0446 44.2693C57.8004 46.1918 58.3139 48.015 58.584 49.6988C59.0928 52.8693 58.7371 55.5423 57.469 57.4214C55.461 58.7182 52.7664 59.0938 49.6279 58.6052C48.8189 60.4118 47.8926 62.042 46.8516 63.4687C47.7656 63.6117 48.6637 63.6961 49.5399 63.7114C53.4474 63.7789 56.2569 63.2353 59.7493 59.7429C63.2416 56.2505 63.9367 52.9899 63.6886 48.7777Z"
            fill="#57B6DF"
          />
          <path
            d="M21.4212 6.65402C17.1435 6.36939 13.8977 6.98632 10.4461 10.4378C6.99489 13.8891 6.73859 16.0877 6.62909 19.6402C6.59123 20.8689 6.68847 22.1472 6.90582 23.4614C7.18501 25.1485 7.66738 26.8971 8.33742 28.6858C9.12322 30.7839 10.1661 32.9364 11.4403 35.1086C12.4761 33.3464 13.6629 31.5718 14.988 29.8036C14.3089 28.5145 13.7203 27.2517 13.2339 26.0285C12.4919 24.1627 11.9801 22.3888 11.6925 20.7385C11.1197 17.4512 11.4504 14.6629 12.7267 12.677C14.65 11.356 17.4257 11.0134 20.7252 11.593C21.5195 9.85414 22.4183 8.27737 23.4177 6.88854C22.7422 6.7785 22.0754 6.6976 21.4212 6.65402Z"
            fill="#57B6DF"
          />
          <path
            d="M53.4317 27.4554C53.3361 26.5091 53.2228 25.5773 53.0915 24.6622C52.7742 22.451 52.3523 20.3358 51.8301 18.3385C51.204 15.9421 50.4337 13.7166 49.5237 11.7051C47.8764 11.9832 46.0986 12.4903 44.2266 13.2282C44.7441 14.4419 45.2185 15.7553 45.6478 17.1515C45.9319 18.0754 46.1964 19.0349 46.4366 20.0321C46.6823 21.0513 46.9034 22.1076 47.099 23.1979C47.4724 25.2766 47.7497 27.4801 47.9191 29.7874C48.0441 31.4922 48.1133 33.2504 48.1133 35.0614C48.1133 36.8874 48.0431 38.6589 47.9159 40.3757C49.4471 38.6085 50.8286 36.8449 52.0456 35.1066C52.6609 34.2274 53.231 33.3561 53.7643 32.4924C53.7087 30.7756 53.597 29.094 53.4317 27.4554Z"
            fill="#49BC82"
          />
          <path
            d="M24.5693 53.1475C24.2768 52.1915 24.0071 51.1946 23.7628 50.1574C23.531 49.1731 23.3196 48.1563 23.1344 47.1033C22.7621 44.9875 22.4903 42.735 22.3249 40.3708C22.2051 38.6578 22.1395 36.8879 22.1395 35.0614C22.1395 33.2384 22.2089 31.4715 22.3345 29.7607C20.7991 31.5336 19.4182 33.3095 18.1958 35.0647C17.5652 35.9706 16.9755 36.8702 16.4297 37.7612C16.4817 39.4286 16.5839 41.0626 16.7342 42.6563C16.8295 43.6662 16.9428 44.6609 17.0774 45.6358C17.3792 47.8207 17.7807 49.9115 18.2791 51.8865C18.8925 54.3152 19.6543 56.5669 20.5635 58.5986C22.2503 58.3183 24.0692 57.8011 25.9848 57.0411C25.4673 55.8372 24.9942 54.5361 24.5693 53.1475Z"
            fill="#49BC82"
          />
          <path
            d="M29.8437 14.9297C29.0416 15.536 28.2403 16.1706 27.4414 16.8317C29.1141 16.6628 30.8314 16.5495 32.5855 16.495C31.6602 15.9255 30.7458 15.4066 29.8437 14.9297Z"
            fill="#FABB66"
          />
          <path
            d="M12.6624 57.5379C11.3416 55.6147 10.9987 52.8389 11.5786 49.5394C9.83975 48.7451 8.26271 47.8463 6.87415 46.8467C6.76411 47.5224 6.68294 48.1892 6.63936 48.8435C6.35473 53.1211 6.97193 56.367 10.4232 59.8182C13.8744 63.2694 16.073 63.5257 19.6256 63.6355C20.8031 63.6717 22.0257 63.5832 23.2822 63.3847C22.2646 61.9762 21.3576 60.3727 20.5642 58.5988C17.3466 59.1332 14.6161 58.7933 12.6624 57.5379Z"
            fill="#FABB66"
          />
          <path
            d="M29.7922 55.2739C28.4916 55.9595 27.218 56.5516 25.9844 57.0411C26.7881 58.9101 27.6976 60.5446 28.6918 61.9187C30.7716 61.1381 32.9046 60.1047 35.0574 58.8445C33.3096 57.8002 31.549 56.6053 29.7922 55.2739Z"
            fill="#FABB66"
          />
          <path
            d="M40.3912 55.2873C41.1427 54.7251 41.8928 54.1395 42.6407 53.5288C41.0808 53.6759 39.4823 53.7764 37.8516 53.8295C38.7082 54.3563 39.5553 54.8425 40.3912 55.2873Z"
            fill="#FABB66"
          />
          <path
            d="M25.9838 57.041C24.0682 57.8009 22.2493 58.3182 20.5625 58.5984C21.3559 60.3724 22.2629 61.9759 23.2805 63.3843C25.0251 63.109 26.8366 62.6149 28.6912 61.9187C27.6971 60.5446 26.7876 58.91 25.9838 57.041Z"
            fill="#FABB66"
          />
          <path
            d="M59.7269 10.5133C56.2346 7.02094 52.9742 6.32557 48.7617 6.5737C48.0914 6.6132 47.4088 6.693 46.7175 6.80467C45.0283 7.07787 43.2813 7.55969 41.4948 8.23681C39.3918 9.03405 37.2354 10.0996 35.0586 11.3988C36.8413 12.4417 38.637 13.6391 40.4268 14.9781C41.7252 14.2985 42.9956 13.7132 44.2259 13.2283C46.0979 12.4905 47.8757 11.9833 49.523 11.7052C52.7634 11.1583 55.4951 11.5042 57.4055 12.7936C58.7025 14.8013 59.0779 17.4962 58.5892 20.6347C60.3959 21.4437 62.026 22.3697 63.453 23.411C63.596 22.4967 63.6804 21.5986 63.6954 20.7224C63.7632 16.8152 63.2196 14.0057 59.7269 10.5133Z"
            fill="#FABB66"
          />
          <path
            d="M57.0304 26.1123C56.5505 27.3137 55.9726 28.5514 55.3017 29.816C54.8348 30.6964 54.3222 31.5895 53.7641 32.4927C53.2308 33.3564 52.6608 34.2277 52.0455 35.1069C50.8285 36.8452 49.447 38.6088 47.9157 40.376C46.7677 41.7011 45.5379 43.0283 44.2172 44.3488C42.9362 45.6298 41.646 46.8233 40.3555 47.9381C42.7101 47.7734 44.9534 47.5029 47.0619 47.1327C48.1241 46.9464 49.1496 46.734 50.1424 46.5C51.3082 45.2599 52.4124 44.0078 53.4515 42.7497C54.0864 41.9811 54.6989 41.2105 55.2829 40.4392C56.6284 38.6614 57.835 36.8795 58.8861 35.1115C60.1448 32.9952 61.1792 30.8987 61.9629 28.8518C60.5778 27.8563 58.9248 26.9338 57.0304 26.1123Z"
            fill="#FABB66"
          />
          <path
            d="M23.1544 23.1682C22.0734 23.3627 21.0261 23.5825 20.015 23.826C18.8637 25.0558 17.7742 26.2994 16.7506 27.5504C16.1381 28.2995 15.5484 29.0507 14.9846 29.8035C13.6595 31.5718 12.4727 33.3463 11.4369 35.1085C10.1603 37.2807 9.11301 39.4336 8.32422 41.5319C9.69099 42.4994 11.3059 43.3952 13.149 44.1933C13.6464 42.9532 14.2478 41.6719 14.9418 40.364C15.3967 39.5068 15.8899 38.6388 16.4279 37.7609C16.9737 36.87 17.5634 35.9703 18.1939 35.0644C19.4164 33.3092 20.7973 31.5334 22.3327 29.7605C23.4279 28.4961 24.5977 27.2337 25.849 25.9824C27.148 24.6832 28.4586 23.4736 29.7704 22.3438C27.4533 22.5137 25.2408 22.7926 23.1544 23.1682Z"
            fill="#FABB66"
          />
          <path
            d="M64.9691 24.6266C64.4943 24.2047 63.9855 23.8008 63.4517 23.4113C62.0247 22.37 60.3945 21.4439 58.5879 20.635C56.5435 19.7198 54.2749 18.9544 51.8281 18.3389C52.3503 20.3362 52.7722 22.4514 53.0895 24.6626C54.4936 25.1003 55.8113 25.5845 57.0286 26.1124C58.9229 26.9339 60.5759 27.8564 61.961 28.8519C64.5916 30.7428 66.2484 32.8975 66.6831 35.137C66.183 37.4617 64.558 39.6224 62.016 41.4895C62.7195 43.3417 63.2136 45.1516 63.4822 46.8986C64.2181 46.3598 64.9023 45.7917 65.5242 45.1911C68.3351 42.4761 69.9372 40.1051 69.9372 35.1658C69.9372 30.2269 68.1231 27.4299 64.9691 24.6266Z"
            fill="#276392"
          />
          <path
            d="M17.0771 45.6356C15.6782 45.2006 14.3643 44.7191 13.1506 44.1934C11.3074 43.3954 9.69253 42.4995 8.32576 41.532C5.62545 39.6211 3.90541 37.4287 3.4067 35.1364C3.8346 32.8313 5.56907 30.6156 8.33557 28.6858C7.66553 26.8971 7.18316 25.1485 6.90397 23.4614C6.33716 23.8681 5.79841 24.2897 5.29588 24.7296C2.06989 27.553 0.210938 30.2847 0.210938 35.1653C0.210938 40.0465 1.58424 41.7821 4.01872 44.3718C4.84946 45.2554 5.80767 46.0796 6.87319 46.8463C8.26175 47.8459 9.8388 48.7448 11.5776 49.539C13.6063 50.4659 15.8544 51.2503 18.2788 51.8863C17.7804 49.9113 17.3789 47.8206 17.0771 45.6356Z"
            fill="#276392"
          />
          <path
            d="M35.1496 18.177C34.2883 17.5789 33.4325 17.0167 32.5846 16.4951C30.8305 16.5496 29.1132 16.6629 27.4406 16.8318C26.4783 16.929 25.5312 17.0445 24.6008 17.1788C22.4131 17.4945 20.3194 17.9123 18.3414 18.4284C15.9388 19.0554 13.7075 19.8271 11.6914 20.739C11.979 22.3893 12.4908 24.1632 13.2328 26.029C14.4337 25.5178 15.7313 25.0485 17.11 24.6238C18.0423 24.3365 19.0104 24.0693 20.0173 23.8266C21.0284 23.5831 22.0756 23.3633 23.1567 23.1688C25.2431 22.7932 27.4556 22.5143 29.7727 22.3443C31.4772 22.219 33.2353 22.1501 35.0463 22.1501C36.9265 22.1501 38.749 22.2248 40.5132 22.3593C38.7204 20.806 36.9241 19.4101 35.1496 18.177Z"
            fill="#276392"
          />
          <path
            d="M57.0459 44.2695C55.8292 44.7939 54.5126 45.2724 53.1068 45.7017C52.1587 45.9912 51.1705 46.2581 50.1431 46.5C49.1503 46.734 48.1249 46.9464 47.0626 47.1327C44.9542 47.5029 42.7109 47.7733 40.3562 47.9381C38.6433 48.058 36.8737 48.1236 35.0468 48.1236C33.278 48.1236 31.5618 48.0588 29.8984 47.9403C31.6457 49.4536 33.3892 50.8198 35.1087 52.0259C36.0317 52.6736 36.9469 53.2723 37.8528 53.8296C39.4835 53.7765 41.0821 53.676 42.642 53.5289C43.6359 53.4349 44.6153 53.3235 45.5754 53.1914C47.7838 52.888 49.8969 52.4835 51.891 51.9791C54.3132 51.3665 56.5586 50.6058 58.5854 49.699C58.3152 48.0152 57.8017 46.1919 57.0459 44.2695Z"
            fill="#276392"
          />
          <path
            d="M40.3908 55.2874C39.5548 54.8426 38.7078 54.3564 37.8511 53.8296C36.9452 53.2723 36.0301 52.6737 35.107 52.026C33.3875 50.8199 31.644 49.4537 29.8967 47.9404C28.5681 46.7896 27.2376 45.5568 25.9133 44.2325C24.6326 42.9518 23.439 41.6616 22.3242 40.3711C22.4895 42.7353 22.7614 44.9878 23.1337 47.1036C23.3189 48.1566 23.5303 49.1734 23.7621 50.1577C25.0213 51.3412 26.2927 52.4612 27.5701 53.5142C28.3091 54.1235 29.0502 54.7121 29.7919 55.2743C31.5487 56.6056 33.3093 57.8006 35.0571 58.8448C37.2053 60.1285 39.3334 61.1832 41.4102 61.9785C42.406 60.5932 43.3286 58.9404 44.1501 57.0461C42.9309 56.5591 41.6745 55.9707 40.3908 55.2874Z"
            fill="#57B6DF"
          />
          <path
            d="M47.0997 23.1979C46.9042 22.1076 46.683 21.0513 46.4373 20.0321C45.2263 18.8982 44.0018 17.8248 42.7698 16.8148C41.9916 16.1767 41.2105 15.5636 40.4282 14.978C38.6384 13.639 36.8427 12.4416 35.06 11.3987C32.92 10.1474 30.7993 9.11866 28.7314 8.34131C27.7642 9.70808 26.8684 11.3233 26.0703 13.1661C27.2925 13.6564 28.5549 14.2483 29.8435 14.9295C30.7456 15.4064 31.66 15.9253 32.5852 16.4948C33.4331 17.0164 34.2889 17.5786 35.1502 18.1767C36.9247 19.4098 38.721 20.8057 40.5137 22.359C41.7743 23.4515 43.0332 24.6184 44.2812 25.8664C45.5802 27.1653 46.79 28.4757 47.9198 29.7875C47.7504 27.4802 47.4732 25.2767 47.0997 23.1979Z"
            fill="#57B6DF"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46573">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const AWeberIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M39.5626 1C38.0017 1 36.3808 1.78044 35.4202 2.98112C28.3362 12.0463 23.9537 22.7324 22.2127 33.4185C20.4117 42.7238 21.2521 54.5506 24.3739 65.5969C24.9743 67.7582 26.175 69.5592 35.06 69.5592C59.1338 69.5592 70 60.0738 70 35.3997C70 11.0858 59.6741 1 39.5626 1ZM38.9623 66.3774C37.5815 67.1578 35.6003 66.5575 35 65.1767C30.0772 55.8714 28.4563 45.4254 30.4374 34.9794C32.4185 24.5335 37.5214 15.2281 45.446 8.08404C46.6467 7.12349 48.6278 7.1235 49.5883 8.26416C50.789 9.46484 50.5489 11.2058 49.4082 12.4065C42.6844 18.3499 37.9417 26.4546 36.3808 35.94C34.5798 45.2453 36.3808 54.4906 40.3431 62.4151C40.3431 62.4151 40.3431 62.4151 40.3431 62.5952C40.9434 63.7959 40.3431 65.5969 38.9623 66.3774ZM57.1527 22.4923C52.2298 26.4545 48.6278 31.5575 47.4871 37.681C46.2864 43.8045 47.4871 49.928 50.669 55.0909C50.669 55.0909 50.669 55.0909 50.669 55.271C51.2693 56.0515 50.8491 57.2521 49.8885 57.6123C48.928 58.0326 47.7273 57.7925 47.1269 56.8319C43.5849 51.1287 42.2041 44.1647 43.5849 37.2607C44.9657 30.3568 48.928 24.4134 54.4511 19.8508C54.4511 19.8508 54.4511 19.8508 54.6312 19.6707C55.4117 19.0703 56.7924 19.0703 57.3928 19.8508C58.1132 20.7513 57.9331 21.952 57.1527 22.4923ZM10.6861 61.2144C10.8662 62.4151 9.48542 63.1955 8.52487 62.4151C3.18182 57.6724 0 51.5489 0 35.1595C0 14.0274 8.28473 4.96227 19.5712 1.96055C20.7719 1.54031 21.5523 2.9211 20.952 3.76158C15.789 12.2865 12.247 21.5317 10.506 31.4374C8.70498 41.283 8.94511 51.5489 10.6861 61.2144Z"
          fill="#246BE8"
        />
      </svg>
    </>
  );
};
export const KeapIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46621)">
          <path
            d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
            fill="#36A635"
          />
          <path
            d="M21.7346 39.2434L20.116 40.9198C19.8848 41.2088 19.5379 41.151 19.2489 40.9198L13.5262 35.0814V40.5151C13.5262 40.862 13.2949 41.0932 12.8903 41.0932H10.5781C10.2312 41.0932 10 40.862 10 40.5151V23.5781C10 23.2312 10.2312 23 10.5781 23H12.8903C13.2949 23 13.5262 23.2312 13.5262 23.5781V29.1274H21.3299C21.6768 29.1274 21.908 29.3586 21.908 29.7055V32.0755C21.908 32.4223 21.6768 32.6536 21.3299 32.6536H16.0118L21.7346 38.4341C21.9658 38.6654 21.9658 38.9544 21.7346 39.2434Z"
            fill="white"
          />
          <path
            d="M34.5674 35.0814C34.5674 35.3126 34.5095 35.6016 34.5095 35.8329C34.4517 36.1797 34.2205 36.3531 33.8737 36.3531H26.1277C26.5324 37.3936 27.515 38.0873 28.8446 38.0873C29.7117 38.0873 30.4631 37.7405 30.9834 37.1624C31.2146 36.8734 31.4458 36.8156 31.7927 36.989L33.5847 38.0873C33.8737 38.3185 33.9893 38.6075 33.7581 38.8966C32.6598 40.3995 30.8678 41.3244 28.7868 41.3244C25.2028 41.3244 22.6016 38.6654 22.6016 35.1392C22.6016 31.5552 25.0872 28.8384 28.5556 28.8384C32.1395 28.8384 34.5674 31.4974 34.5674 35.0814ZM31.099 33.8097C30.7522 32.7114 29.8273 32.0755 28.6134 32.0755C27.2838 32.0755 26.3589 32.7114 26.0699 33.8097H31.099Z"
            fill="white"
          />
          <path
            d="M46.244 33.5784V40.5151C46.244 40.862 46.0706 41.0932 45.666 41.0932H43.4115C43.0647 41.0932 42.8335 40.862 42.8335 40.5151V39.8215C41.9086 40.862 40.8681 41.3244 39.5386 41.3244C36.9373 41.3244 35.2031 39.8793 35.2031 37.6249C35.2031 35.2548 36.9373 33.7519 39.4807 33.7519H42.8335V33.4628C42.8335 32.6536 42.0242 32.0755 40.8681 32.0755C40.1166 32.0755 39.3651 32.3645 39.0183 32.7692C38.7871 33.0004 38.6715 33.1738 38.3246 33.1738H36.128C35.7234 33.1738 35.4922 32.9426 35.55 32.5958C36.0124 30.3413 37.92 28.8384 40.8103 28.8384C44.1052 28.8384 46.244 30.746 46.244 33.5784ZM42.8335 36.6422V36.2375H40.001C39.0761 36.2375 38.6715 36.7578 38.6715 37.3936C38.6715 38.0295 39.1917 38.5497 40.4056 38.5497C41.8508 38.5497 42.8335 37.7405 42.8335 36.6422Z"
            fill="white"
          />
          <path
            d="M59.9993 35.1392C59.9993 38.6076 57.5715 41.3244 54.3344 41.3244C53.0048 41.3244 51.8487 40.862 51.1551 39.9949V45.5442C51.1551 45.8911 50.9238 46.1223 50.5192 46.1223H48.207C47.8601 46.1223 47.6289 45.8911 47.6289 45.5442V29.7055C47.6289 29.3586 47.8601 29.1274 48.207 29.1274H50.4614C50.866 29.1274 51.0394 29.3586 51.0394 29.7055V30.3991C51.7909 29.4164 52.947 28.8384 54.2766 28.8384C57.5137 28.8384 59.9993 31.6131 59.9993 35.1392ZM56.4732 35.1392C56.4732 33.5206 55.3749 32.3067 53.8141 32.3067C52.1378 32.3067 50.9816 33.5206 50.9816 35.1392C50.9816 36.7 52.1378 37.9139 53.8141 37.9139C55.3749 37.9139 56.4732 36.7 56.4732 35.1392Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46621">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const MotionIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46635)">
          <path
            d="M70 0V35L52.5 52.5L35 70L17.5 52.5L35 35L70 0Z"
            fill="#59529D"
          />
          <path d="M70 35V70L52.5 52.5L70 35Z" fill="#5271B4" />
          <path d="M35 35L17.5 52.5L0 70V0L17.5 17.5L35 35Z" fill="#BB4B96" />
        </g>
        <defs>
          <clipPath id="clip0_1225_46635">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const CHatWorkIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46646)">
          <path
            d="M55.125 4.15625C49.5469 -1.42188 40.5781 -1.42188 35.1094 4.15625C32.5937 6.67187 31.0625 10.0625 30.9531 13.6719V27.125C30.9531 27.7812 31.5 28.4375 32.2656 28.4375H44.5156C48.4531 28.6562 52.3906 27.125 55.125 24.2812C60.7031 18.7031 60.7031 9.73438 55.125 4.15625Z"
            fill="#34362F"
          />
          <path
            d="M4.15625 14.9844C-1.42188 20.5625 -1.42188 29.5312 4.15625 35C6.67187 37.5156 10.0625 39.0469 13.6719 39.1562H27.125C27.7812 39.1562 28.3281 38.6094 28.3281 37.9531V25.5938C28.5469 21.6562 27.0156 17.7188 24.1719 14.9844C18.5938 9.51562 9.73438 9.51562 4.15625 14.9844ZM14.9844 65.8438C20.5625 71.3125 29.5313 71.3125 35 65.7344C37.5156 63.2187 38.9375 59.8281 39.0469 56.3281V42.9844C39.0469 42.3281 38.5 41.7812 37.8438 41.7812H25.5938C21.6562 41.5625 17.7188 43.0938 14.9844 45.9375C9.51562 51.4062 9.51562 60.2656 14.9844 65.8438ZM65.8438 55.0156C71.4219 49.5469 71.4219 40.5781 65.8438 35C63.3281 32.4844 59.9375 30.9531 56.3281 30.8438H42.9844C42.3281 30.8438 41.6719 31.3906 41.6719 32.0469V44.2969C41.4531 48.2344 42.9844 52.1719 45.8281 54.9062C51.4063 60.5938 60.2656 60.5938 65.8438 55.0156Z"
            fill="#F03748"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46646">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const SlackIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.8106 49.5163C12.5156 49.5116 14.1494 48.832 15.3546 47.6259C16.5599 46.4199 17.2384 44.7857 17.2419 43.0806V36.6494H10.8106C9.10637 36.6529 7.47277 37.3308 6.26686 38.5351C5.06095 39.7393 4.38078 41.372 4.375 43.0763C4.37938 46.6244 7.25813 49.5031 10.8063 49.5075L10.8106 49.5163ZM26.9194 36.645C25.2144 36.6496 23.5806 37.3293 22.3754 38.5353C21.1701 39.7414 20.4916 41.3756 20.4881 43.0806V59.1938C20.4969 62.7419 23.3756 65.6163 26.9194 65.625C28.6236 65.6204 30.2568 64.9413 31.4619 63.7362C32.6669 62.5312 33.346 60.898 33.3506 59.1938V43.0763C33.346 41.372 32.6669 39.7389 31.4619 38.5338C30.2568 37.3287 28.6236 36.6496 26.9194 36.645Z"
          fill="#E01E5A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4881 10.8106C20.4925 14.3587 23.3713 17.2375 26.9194 17.2419H33.3506V10.8106C33.3472 9.10637 32.6692 7.47277 31.4649 6.26686C30.2607 5.06095 28.628 4.38078 26.9237 4.375C25.2195 4.37962 23.5864 5.05868 22.3813 6.26377C21.1762 7.46886 20.4971 9.102 20.4925 10.8063L20.4881 10.8106ZM33.3506 26.9194C33.346 25.2151 32.6669 23.582 31.4619 22.3769C30.2568 21.1718 28.6236 20.4927 26.9194 20.4881H10.8063C9.102 20.4927 7.46886 21.1718 6.26377 22.3769C5.05868 23.582 4.37962 25.2151 4.375 26.9194C4.38375 30.4719 7.2625 33.3463 10.8063 33.3506H26.9237C28.628 33.346 30.2611 32.6669 31.4662 31.4619C32.6713 30.2568 33.346 28.6236 33.3506 26.9194Z"
          fill="#36C5F0"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.0792 33.355C44.7835 33.3504 46.4166 32.6713 47.6217 31.4662C48.8268 30.2611 49.5059 28.628 49.5105 26.9237V10.8063C49.5059 9.10275 48.8274 7.47028 47.6232 6.26531C46.4191 5.06034 44.7871 4.38077 43.0836 4.375C41.3793 4.37962 39.7462 5.05868 38.5411 6.26377C37.336 7.46886 36.657 9.102 36.6523 10.8063V26.9237C36.6611 30.4675 39.5311 33.3463 43.0792 33.355ZM59.188 20.4881C57.4837 20.4927 55.8506 21.1718 54.6455 22.3769C53.4404 23.582 52.7613 25.2151 52.7567 26.9194V33.3506H59.188C60.8922 33.3472 62.5258 32.6692 63.7317 31.4649C64.9376 30.2607 65.6178 28.628 65.6236 26.9237C65.619 25.2195 64.9399 23.5864 63.7348 22.3813C62.5297 21.1762 60.8966 20.4971 59.1923 20.4925L59.188 20.4881Z"
          fill="#2EB67D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.6484 43.0807C36.6572 46.6288 39.5316 49.5076 43.0797 49.5119H59.1928C60.8963 49.5073 62.5288 48.8289 63.7338 47.6247C64.9387 46.4206 65.6183 44.7886 65.6241 43.0851C65.6194 41.3808 64.9404 39.7477 63.7353 38.5426C62.5302 37.3375 60.8971 36.6584 59.1928 36.6538H43.0797C41.3754 36.6584 39.7423 37.3375 38.5372 38.5426C37.3321 39.7477 36.6531 41.3764 36.6484 43.0807ZM49.5109 59.1894C49.5063 57.4852 48.8273 55.852 47.6222 54.647C46.4171 53.4419 44.7839 52.7628 43.0797 52.7582H36.6484V59.1894C36.6572 62.7419 39.5316 65.6163 43.0797 65.6207C44.7839 65.6161 46.4171 64.937 47.6222 63.7319C48.8273 62.5268 49.5063 60.8937 49.5109 59.1894Z"
          fill="#ECB22E"
        />
      </svg>
    </>
  );
};
export const KommoIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46670)">
          <path
            d="M55.4167 70H14.5833C6.53333 70 0 63.4667 0 55.4167V14.5833C0 6.53333 6.53333 0 14.5833 0H55.4167C63.4667 0 70 6.53333 70 14.5833V55.4167C70 63.4667 63.4667 70 55.4167 70Z"
            fill="#0006A0"
          />
          <path
            d="M28.9049 44.2167C28.9049 45.8209 28.9341 47.3959 28.9049 49.0001C28.8757 50.4584 28.2049 51.1001 26.7174 51.1001C25.1716 51.1292 23.6257 51.1292 22.0507 51.1001C20.6507 51.0709 20.0091 50.4584 20.0091 49.0584C19.9799 46.6376 20.0091 44.2167 20.0091 41.7959C20.0091 37.7126 22.8966 34.6792 26.9507 34.6501C28.2341 34.6501 28.9632 34.2126 29.6341 33.2209C32.0841 29.5751 34.6507 26.0167 37.1007 22.3709C38.7341 19.9792 40.8924 18.7542 43.8382 18.8709C45.4424 18.9292 47.0466 18.8709 48.6507 18.9001C49.0299 18.9001 49.4674 18.7542 49.7007 19.1626C49.9924 19.6584 49.5841 19.9792 49.3507 20.3292C46.6382 24.2667 43.8966 28.1751 41.1841 32.1126C39.7549 34.1834 39.7549 35.6417 41.1841 37.6834C43.9257 41.6501 46.6674 45.6167 49.4382 49.5834C49.6716 49.9334 50.1091 50.2542 49.9341 50.7209C49.7007 51.3042 49.1174 51.1001 48.6507 51.1001C47.1049 51.1001 45.5299 51.0709 43.9841 51.1292C41.0382 51.2459 38.8799 49.9917 37.2466 47.6292C35.3216 44.8001 33.3674 42.0001 31.3841 39.1709C30.9466 38.5584 30.6257 37.7126 29.6049 38.0334C28.6424 38.3251 28.8757 39.1709 28.8757 39.8709C28.8757 41.3001 28.9049 42.7584 28.9049 44.2167Z"
            fill="#FBFBFD"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46670">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ClokifyIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M37.4389 59.5066C40.5386 59.5066 43.6033 58.9028 46.4623 57.7172L54.2105 65.5791C49.0939 68.4731 43.3189 70 37.4389 70C18.3661 70 2.91797 54.3353 2.91797 35C2.91797 15.6647 18.3792 0 37.4389 0C43.4655 0 49.1398 1.57281 54.0617 4.32906L46.4514 12.0641C43.5923 10.8784 40.5277 10.2747 37.4389 10.2747C24.0864 10.2747 13.2627 21.3041 13.2627 34.895C13.2627 48.4859 24.0864 59.5066 37.4389 59.5066Z"
          fill="#03A9F4"
        />
        <path
          d="M59.5522 7.97559L43.6928 24.0515H43.6819L48.2275 28.654L64.0869 12.5781L59.5522 7.97559Z"
          fill="#222222"
        />
        <path
          d="M33.2781 38.804C34.3259 39.8868 35.7609 40.4906 37.2659 40.4906C38.76 40.4906 40.195 39.8759 41.2428 38.804C42.3016 37.7212 42.8834 36.2753 42.8834 34.7703C42.8834 31.6137 40.3656 29.05 37.255 29.05C34.1553 29.05 31.6484 31.6137 31.6484 34.7703C31.6484 36.2753 32.2303 37.7212 33.2781 38.804Z"
          fill="#222222"
        />
        <path
          d="M59.62 61.705L64.1547 57.1025L48.3063 41.0265L43.7606 45.6181L59.62 61.705Z"
          fill="#222222"
        />
      </svg>
    </>
  );
};
export const ZohoCampaignsIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="71"
        viewBox="0 0 70 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M69.906 45.7943L63.0751 7.0922C62.6334 4.58672 60.7362 2.63641 58.2428 2.12711C55.7494 1.61781 53.2415 2.66538 51.8487 4.79672C51.2284 5.74774 51.4963 7.01737 52.4474 7.63771C53.3984 8.25804 54.668 7.99012 55.2883 7.0391C55.9956 5.95532 57.0987 6.08325 57.4197 6.14842C57.7407 6.21359 58.8052 6.52738 59.0297 7.80426L65.8582 46.5064C66.003 47.3271 65.6385 47.9088 65.4092 48.1839C65.1799 48.4591 64.6682 48.9177 63.8354 48.9177H24.1437C23.0092 48.9177 22.0896 49.8374 22.0896 50.9718C22.0896 52.1063 23.0092 53.0259 24.1437 53.0259H29.4322L25.6933 63.3568C25.4012 64.1678 24.624 64.7109 23.7623 64.7109H22.092C21.0951 64.7109 20.2455 63.9989 20.0693 63.0165L12.8908 22.5451L44.7475 7.50495C45.7733 7.0222 46.2102 5.79843 45.7275 4.77258C45.2447 3.74674 44.0209 3.30985 42.9951 3.7926L3.53022 22.4244C1.02716 23.6071 -0.3873 26.3371 0.0930372 29.0646L3.4216 47.945C3.94056 50.8946 6.4919 53.0356 9.48737 53.0356H14.129L16.0262 63.7358C16.55 66.6805 19.0989 68.8191 22.092 68.8191H23.7623C26.3474 68.8191 28.6743 67.185 29.5553 64.7568L33.8011 53.0283H63.8403C65.6651 53.0283 67.3861 52.227 68.5592 50.827C69.7322 49.4246 70.2222 47.5902 69.906 45.7943ZM9.48737 48.9274C8.48807 48.9274 7.63843 48.2129 7.46464 47.2305L4.13608 28.3501C3.97677 27.4401 4.44745 26.5302 5.28261 26.1367L9.04082 24.3626L13.4001 48.9274H9.48737Z"
          fill="#E42527"
        />
        <path
          d="M33.9471 34.6469C33.0154 34.6469 32.0692 34.4345 31.1834 33.9904L21.7263 29.2425C20.7125 28.7332 20.3046 27.4998 20.8115 26.486C21.3208 25.4722 22.5542 25.0643 23.568 25.5712L33.0251 30.319C33.9592 30.7873 35.0937 30.4808 35.6657 29.607L51.8548 4.79359C52.4751 3.84257 53.7471 3.57706 54.6958 4.19498C55.6468 4.81531 55.9123 6.08736 55.2944 7.03597L39.1077 31.8469C37.9346 33.65 35.9699 34.6469 33.9471 34.6469Z"
          fill="#226DB4"
        />
        <path
          d="M33.9471 34.6469C33.0154 34.6469 32.0692 34.4345 31.1834 33.9904L21.7263 29.2425C20.7125 28.7332 20.3046 27.4998 20.8115 26.486C21.3208 25.4722 22.5542 25.0643 23.568 25.5712L33.0251 30.319C33.9592 30.7873 35.0937 30.4808 35.6657 29.607L51.8548 4.79359C52.4751 3.84257 53.7471 3.57706 54.6958 4.19498C55.6468 4.81531 55.9123 6.08736 55.2944 7.03597L39.1077 31.8469C37.9346 33.65 35.9699 34.6469 33.9471 34.6469Z"
          fill="#226DB4"
        />
      </svg>
    </>
  );
};
export const Bitrix24Icon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46756)">
          <path
            d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
            fill="#2FC7F7"
          />
          <path
            d="M59.9512 34.1162H58.4473V32.6123H58.0433V34.5216H59.9512V34.1162ZM58.247 37.1193C57.653 37.1193 57.0724 36.9431 56.5786 36.6132C56.0847 36.2832 55.6998 35.8142 55.4725 35.2655C55.2452 34.7167 55.1858 34.1129 55.3017 33.5304C55.4175 32.9479 55.7035 32.4128 56.1235 31.9928C56.5435 31.5728 57.0786 31.2868 57.6611 31.1709C58.2436 31.055 58.8475 31.1145 59.3962 31.3418C59.9449 31.5691 60.4139 31.954 60.7439 32.4479C61.0739 32.9417 61.25 33.5223 61.25 34.1162C61.2457 34.9114 60.9279 35.6727 60.3657 36.2349C59.8034 36.7972 59.0421 37.115 58.247 37.1193ZM58.247 31.6621C57.7616 31.6621 57.2871 31.8061 56.8835 32.0757C56.48 32.3454 56.1654 32.7287 55.9797 33.1771C55.7939 33.6255 55.7453 34.119 55.84 34.595C55.9347 35.0711 56.1684 35.5083 56.5117 35.8516C56.8549 36.1948 57.2922 36.4285 57.7682 36.5232C58.2443 36.6179 58.7377 36.5693 59.1861 36.3835C59.6345 36.1978 60.0178 35.8832 60.2875 35.4797C60.5571 35.0761 60.7011 34.6016 60.7011 34.1162C60.7013 33.7939 60.6381 33.4746 60.5148 33.1768C60.3916 32.8789 60.2108 32.6083 59.9829 32.3803C59.7549 32.1524 59.4843 31.9716 59.1864 31.8484C58.8886 31.7252 58.5693 31.6619 58.247 31.6621ZM52.472 35.7336V30.9403H51.4616L47.6212 35.9353V36.8882H51.0863V38.7941H52.472V36.8882H53.6272V35.7329L52.472 35.7336ZM51.0863 34.6078V35.7042H50.1621C49.8736 35.7042 49.3534 35.7329 49.1805 35.7329L51.1437 33.0765C51.1437 33.3076 51.0863 34.0007 51.0863 34.6071V34.6078ZM42.0485 38.7654H47.4489V37.5814H43.8676C44.3584 35.6181 47.3614 35.1847 47.3614 32.9904C47.3614 31.8064 46.5527 30.9396 44.8779 30.9396C43.9745 30.9469 43.0852 31.1643 42.2803 31.5746L42.6562 32.6759C43.2339 32.4161 43.8689 32.1564 44.6482 32.1564C45.2833 32.1564 45.8609 32.4161 45.8609 33.138C45.889 34.7513 42.3664 34.8668 42.0485 38.7654ZM36.8225 35.56L34.5126 32.384H36.1874L37.6913 34.4628L39.2219 32.384H40.8967L38.5547 35.56L40.9227 38.7654H39.2479L37.7173 36.6285L36.158 38.7654H34.4832L36.8225 35.56ZM31.7693 30.3913C31.7693 30.131 31.8728 29.8813 32.0569 29.6972C32.2409 29.5131 32.4906 29.4097 32.751 29.4097C33.0113 29.4097 33.261 29.5131 33.4451 29.6972C33.6292 29.8813 33.7326 30.131 33.7326 30.3913C33.7326 30.9109 33.2992 31.3443 32.7223 31.3443C32.1453 31.3443 31.7693 30.9403 31.7693 30.3913ZM31.9423 32.3833H33.559V38.7647H31.943L31.9423 32.3833ZM26.9179 32.3833H28.3035L28.4765 33.1052C29.0541 32.5276 29.5736 32.2391 30.2381 32.2391C30.5548 32.2403 30.8648 32.3303 31.1329 32.4989L30.5566 33.8565C30.3397 33.7224 30.0898 33.6514 29.8348 33.6514C29.4014 33.6514 29.0555 33.8244 28.5359 34.2865V38.7941H26.9186L26.9179 32.3833ZM18.4003 30.3913C18.3992 30.2621 18.4238 30.134 18.4728 30.0144C18.5217 29.8948 18.594 29.7862 18.6854 29.6948C18.7767 29.6034 18.8854 29.5311 19.005 29.4822C19.1246 29.4333 19.2527 29.4086 19.3819 29.4097C19.9288 29.4097 20.3923 29.8137 20.3923 30.3913C20.3923 30.9109 19.9589 31.3443 19.3819 31.3443C18.805 31.3443 18.4003 30.9403 18.4003 30.3913ZM18.5732 32.3833H20.1899V38.7647H18.5739L18.5732 32.3833ZM22.3535 37.2061V33.6514H21.1982V32.384H22.3535V30.9116L23.9702 30.4494V32.384H25.9082L25.5042 33.6548H23.9736V36.7994C23.9736 37.4057 24.1787 37.608 24.6087 37.608C24.9599 37.5998 25.301 37.4893 25.5903 37.2902L26.0812 38.3873C25.619 38.7052 24.8397 38.8782 24.204 38.8782C23.0494 38.9096 22.3535 38.2739 22.3535 37.2061ZM11.2109 29.8732H13.8086C15.7145 29.8732 16.5806 30.9703 16.5806 32.1256C16.5806 32.9049 16.2053 33.5981 15.5121 33.9713V34C16.5519 34.2598 17.1869 35.0972 17.1869 36.1369C17.1869 37.5226 16.1472 38.7647 14.0684 38.7647H11.2109V29.8732ZM13.6076 33.5981C14.5024 33.5981 14.9933 33.1073 14.9933 32.4141C14.9933 31.7503 14.5599 31.2301 13.6076 31.2301H12.8557V33.5981H13.6076ZM13.8674 37.4385C14.9358 37.4385 15.5422 37.0345 15.5422 36.1397C15.5422 35.3877 14.9646 34.927 14.0697 34.927H12.857V37.4392L13.8674 37.4385Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46756">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const PardotIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M29.5491 5.96183C31.6454 3.77757 34.5639 2.42294 37.7917 2.42294C42.0824 2.42294 45.8259 4.81553 47.8194 8.36739C49.5519 7.59331 51.4694 7.16275 53.487 7.16275C61.2259 7.16275 67.5 13.4915 67.5 21.2979C67.5 29.1054 61.2259 35.4341 53.487 35.4341C52.5426 35.4341 51.6194 35.3396 50.7269 35.1591C48.9713 38.2905 45.6259 40.4063 41.7861 40.4063C40.1787 40.4063 38.6583 40.035 37.3046 39.3748C35.525 43.5609 31.3787 46.4961 26.5463 46.4961C21.5139 46.4961 17.225 43.3118 15.5787 38.8461C14.8593 38.9989 14.1139 39.0785 13.3491 39.0785C7.35741 39.0785 2.5 34.1711 2.5 28.1165C2.5 24.0591 4.68241 20.5165 7.925 18.6211C7.25741 17.085 6.88611 15.3896 6.88611 13.6072C6.88611 6.64423 12.5389 0.99979 19.5111 0.99979C23.6046 0.99979 27.2426 2.94609 29.5491 5.96183Z"
          fill="#00A1E0"
        />
        <path
          d="M11.9131 24.5935C11.8724 24.7 11.9279 24.7222 11.9409 24.7407C12.0631 24.8296 12.1872 24.8935 12.3122 24.9648C12.9752 25.3167 13.6011 25.4194 14.2557 25.4194C15.5891 25.4194 16.4168 24.7102 16.4168 23.5685V23.5463C16.4168 22.4907 15.4826 22.1074 14.6057 21.8305L14.4918 21.7935C13.8307 21.5787 13.2604 21.3935 13.2604 20.9583V20.9352C13.2604 20.563 13.5937 20.2889 14.1103 20.2889C14.6844 20.2889 15.3659 20.4796 15.8048 20.7222C15.8048 20.7222 15.9335 20.8055 15.9807 20.6805C16.0066 20.6139 16.2289 20.0157 16.252 19.9509C16.277 19.8805 16.2326 19.8287 16.1872 19.8009C15.6863 19.4963 14.9937 19.288 14.277 19.288L14.1437 19.2889C12.9233 19.2889 12.0715 20.0259 12.0715 21.0824V21.1046C12.0715 22.2185 13.0113 22.5796 13.8918 22.8315L14.0335 22.875C14.6752 23.0722 15.2279 23.2417 15.2279 23.6935V23.7157C15.2279 24.1287 14.8687 24.4361 14.2891 24.4361C14.0641 24.4361 13.3465 24.4315 12.5715 23.9417C12.4779 23.887 12.4233 23.8472 12.3511 23.8037C12.3131 23.7796 12.2178 23.738 12.1761 23.8639L11.9131 24.5935Z"
          fill="white"
        />
        <path
          d="M31.4327 24.5935C31.3919 24.7 31.4475 24.7222 31.4604 24.7407C31.5827 24.8296 31.7067 24.8935 31.8317 24.9648C32.4947 25.3167 33.1206 25.4194 33.7753 25.4194C35.1086 25.4194 35.9364 24.7102 35.9364 23.5685V23.5463C35.9364 22.4907 35.0021 22.1074 34.1253 21.8305L34.0114 21.7935C33.3503 21.5787 32.7799 21.3935 32.7799 20.9583V20.9352C32.7799 20.563 33.1132 20.2889 33.6299 20.2889C34.204 20.2889 34.8854 20.4796 35.3243 20.7222C35.3243 20.7222 35.453 20.8055 35.5003 20.6805C35.5262 20.6139 35.7484 20.0157 35.7715 19.9509C35.7965 19.8805 35.7521 19.8287 35.7067 19.8009C35.2058 19.4963 34.5132 19.288 33.7965 19.288L33.6632 19.2889C32.4428 19.2889 31.591 20.0259 31.591 21.0824V21.1046C31.591 22.2185 32.5308 22.5796 33.4114 22.8315L33.553 22.875C34.1947 23.0722 34.7484 23.2417 34.7484 23.6935V23.7157C34.7484 24.1287 34.3882 24.4361 33.8086 24.4361C33.5836 24.4361 32.866 24.4315 32.091 23.9417C31.9975 23.887 31.9419 23.8491 31.8715 23.8037C31.8475 23.788 31.7345 23.7444 31.6956 23.8639L31.4327 24.5935Z"
          fill="white"
        />
        <path
          d="M44.7569 22.3567C44.7569 23.0021 44.6365 23.5104 44.3995 23.8697C44.1652 24.2252 43.8106 24.3984 43.3162 24.3984C42.8208 24.3984 42.468 24.2262 42.2375 23.8697C42.0041 23.5113 41.8856 23.0021 41.8856 22.3567C41.8856 21.7123 42.0041 21.2049 42.2375 20.8493C42.468 20.4975 42.8208 20.3262 43.3162 20.3262C43.8106 20.3262 44.1652 20.4975 44.4004 20.8493C44.6365 21.2049 44.7569 21.7123 44.7569 22.3567ZM45.8699 21.1604C45.7606 20.791 45.5902 20.4651 45.3634 20.1938C45.1365 19.9215 44.8495 19.703 44.5088 19.5438C44.169 19.3854 43.7671 19.3049 43.3162 19.3049C42.8643 19.3049 42.4625 19.3854 42.1227 19.5438C41.7819 19.703 41.4949 19.9215 41.2671 20.1938C41.0412 20.466 40.8708 20.7919 40.7606 21.1604C40.6523 21.528 40.5977 21.9299 40.5977 22.3567C40.5977 22.7836 40.6523 23.1863 40.7606 23.553C40.8708 23.9215 41.0402 24.2475 41.268 24.5197C41.4949 24.7919 41.7828 25.0095 42.1227 25.1641C42.4634 25.3188 42.8643 25.3975 43.3162 25.3975C43.7671 25.3975 44.168 25.3188 44.5088 25.1641C44.8486 25.0095 45.1365 24.7919 45.3634 24.5197C45.5902 24.2484 45.7606 23.9225 45.8699 23.553C45.9791 23.1854 46.0338 22.7826 46.0338 22.3567C46.0338 21.9308 45.9791 21.528 45.8699 21.1604Z"
          fill="white"
        />
        <path
          d="M55.0127 24.2265C54.9756 24.1182 54.871 24.1589 54.871 24.1589C54.709 24.2209 54.5368 24.2784 54.3534 24.3071C54.1673 24.3358 53.9627 24.3506 53.7432 24.3506C53.2043 24.3506 52.7766 24.1904 52.4701 23.8737C52.1627 23.5571 51.9905 23.045 51.9923 22.3524C51.9942 21.7219 52.146 21.2478 52.4192 20.8867C52.6905 20.5274 53.1034 20.3432 53.6543 20.3432C54.1136 20.3432 54.4636 20.3959 54.8303 20.5117C54.8303 20.5117 54.9182 20.5496 54.9599 20.4348C55.0571 20.1645 55.1293 19.9709 55.233 19.6737C55.2627 19.5895 55.1905 19.5534 55.1645 19.5432C55.0201 19.4867 54.6793 19.395 54.4219 19.3561C54.1812 19.3191 53.8997 19.2996 53.5868 19.2996C53.1192 19.2996 52.7025 19.3793 52.346 19.5385C51.9905 19.6969 51.6886 19.9154 51.4497 20.1876C51.2108 20.4598 51.0293 20.7858 50.908 21.1543C50.7877 21.5219 50.7266 21.9256 50.7266 22.3524C50.7266 23.2756 50.9756 24.0219 51.4673 24.5682C51.9599 25.1163 52.6997 25.395 53.6645 25.395C54.2349 25.395 54.8201 25.2793 55.2405 25.1135C55.2405 25.1135 55.321 25.0746 55.2858 24.9811L55.0127 24.2265Z"
          fill="white"
        />
        <path
          d="M56.9573 21.7387C57.0101 21.3804 57.1091 21.0823 57.2619 20.8498C57.4925 20.4971 57.8443 20.3035 58.3388 20.3035C58.8332 20.3035 59.1601 20.498 59.3943 20.8498C59.5499 21.0823 59.6175 21.3934 59.6443 21.7387H56.9573ZM60.7045 20.9508C60.6101 20.5943 60.3758 20.2341 60.2221 20.0693C59.9795 19.8082 59.7425 19.6258 59.5073 19.5239C59.1999 19.3924 58.8314 19.3054 58.4277 19.3054C57.9573 19.3054 57.5304 19.3841 57.1841 19.5471C56.8369 19.71 56.5453 19.9323 56.3165 20.2091C56.0878 20.485 55.9156 20.8137 55.8064 21.1869C55.6962 21.5582 55.6406 21.9628 55.6406 22.3897C55.6406 22.8239 55.698 23.2285 55.8119 23.5924C55.9267 23.9591 56.1101 24.2823 56.3582 24.5498C56.6054 24.8193 56.924 25.0304 57.3054 25.1776C57.6841 25.3239 58.1443 25.3998 58.673 25.3989C59.761 25.3952 60.3341 25.1526 60.5703 25.0221C60.6119 24.9989 60.6517 24.9582 60.6017 24.8415L60.3554 24.1517C60.3184 24.0489 60.2138 24.0869 60.2138 24.0869C59.9443 24.1869 59.561 24.3665 58.6675 24.3647C58.0832 24.3637 57.6499 24.1915 57.3786 23.9221C57.0999 23.6461 56.9638 23.2406 56.9397 22.6684L60.7073 22.6721C60.7073 22.6721 60.8064 22.6702 60.8165 22.5739C60.8203 22.5332 60.9462 21.7998 60.7045 20.9508Z"
          fill="white"
        />
        <path
          d="M26.7854 21.7387C26.8391 21.3804 26.9373 21.0823 27.09 20.8498C27.3206 20.4971 27.6725 20.3035 28.1669 20.3035C28.6613 20.3035 28.9882 20.498 29.2234 20.8498C29.378 21.0823 29.4456 21.3934 29.4725 21.7387H26.7854ZM30.5317 20.9508C30.4373 20.5943 30.2039 20.2341 30.0502 20.0693C29.8076 19.8082 29.5706 19.6258 29.3354 19.5239C29.028 19.3924 28.6595 19.3054 28.2558 19.3054C27.7863 19.3054 27.3586 19.3841 27.0123 19.5471C26.665 19.71 26.3734 19.9323 26.1447 20.2091C25.916 20.485 25.7438 20.8137 25.6345 21.1869C25.5252 21.5582 25.4688 21.9628 25.4688 22.3897C25.4688 22.8239 25.5262 23.2285 25.64 23.5924C25.7549 23.9591 25.9382 24.2823 26.1863 24.5498C26.4336 24.8193 26.7521 25.0304 27.1336 25.1776C27.5123 25.3239 27.9725 25.3998 28.5012 25.3989C29.5891 25.3952 30.1623 25.1526 30.3984 25.0221C30.44 24.9989 30.4799 24.9582 30.4299 24.8415L30.1845 24.1517C30.1465 24.0489 30.0419 24.0869 30.0419 24.0869C29.7725 24.1869 29.39 24.3665 28.4947 24.3647C27.9113 24.3637 27.478 24.1915 27.2067 23.9221C26.928 23.6461 26.7919 23.2406 26.7678 22.6684L30.5354 22.6721C30.5354 22.6721 30.6345 22.6702 30.6447 22.5739C30.6484 22.5332 30.7743 21.7998 30.5317 20.9508Z"
          fill="white"
        />
        <path
          d="M18.6447 24.2058C18.4975 24.0883 18.4771 24.0586 18.4271 23.9827C18.353 23.867 18.315 23.7021 18.315 23.4929C18.315 23.1614 18.4243 22.9234 18.6512 22.7633C18.6484 22.7642 18.9752 22.4808 19.7437 22.491C20.2836 22.4984 20.766 22.5781 20.766 22.5781V24.291H20.7669C20.7669 24.291 20.2882 24.3938 19.7493 24.4262C18.9826 24.4725 18.6419 24.2049 18.6447 24.2058ZM20.1437 21.5586C19.991 21.5475 19.7928 21.541 19.5558 21.541C19.2326 21.541 18.9206 21.5818 18.628 21.6605C18.3336 21.7392 18.0687 21.8623 17.841 22.0253C17.6123 22.1892 17.428 22.3984 17.2947 22.6466C17.1613 22.8947 17.0938 23.1873 17.0938 23.5151C17.0938 23.8484 17.1512 24.1383 17.266 24.3753C17.3808 24.6133 17.5465 24.8114 17.7576 24.9642C17.9669 25.117 18.2252 25.229 18.5252 25.2966C18.8206 25.3642 19.1558 25.3984 19.5225 25.3984C19.9086 25.3984 20.2937 25.367 20.6669 25.3031C21.0363 25.2401 21.49 25.1484 21.616 25.1197C21.741 25.0901 21.8799 25.0521 21.8799 25.0521C21.9734 25.029 21.966 24.929 21.966 24.929L21.9641 21.4836C21.9641 20.7281 21.7623 20.1679 21.365 19.8207C20.9697 19.4744 20.3873 19.2994 19.6345 19.2994C19.3521 19.2994 18.8975 19.3383 18.6252 19.3929C18.6252 19.3929 17.8021 19.5521 17.4632 19.817C17.4632 19.817 17.3891 19.8633 17.4299 19.967L17.6965 20.6836C17.7299 20.7762 17.8197 20.7447 17.8197 20.7447C17.8197 20.7447 17.8484 20.7336 17.8817 20.7142C18.6067 20.3197 19.5234 20.3318 19.5234 20.3318C19.9308 20.3318 20.2437 20.4133 20.4549 20.5753C20.6604 20.7327 20.765 20.9707 20.765 21.4725V21.6318C20.441 21.5855 20.1437 21.5586 20.1437 21.5586Z"
          fill="white"
        />
        <path
          d="M50.5295 19.6171C50.5582 19.5319 50.498 19.4911 50.473 19.4819C50.4091 19.4569 50.0887 19.3893 49.8415 19.3735C49.3684 19.3448 49.1054 19.4245 48.8702 19.53C48.6369 19.6356 48.3776 19.8059 48.2332 19.9995V19.5411C48.2332 19.4772 48.1878 19.4263 48.1249 19.4263H47.1591C47.0962 19.4263 47.0508 19.4772 47.0508 19.5411V25.1606C47.0508 25.2235 47.1026 25.2754 47.1656 25.2754H48.1554C48.2184 25.2754 48.2693 25.2235 48.2693 25.1606V22.3532C48.2693 21.9763 48.311 21.6004 48.3943 21.3643C48.4758 21.1309 48.5869 20.9439 48.7239 20.8097C48.8619 20.6763 49.0184 20.5828 49.1897 20.53C49.3647 20.4763 49.5582 20.4587 49.6952 20.4587C49.8924 20.4587 50.1091 20.5096 50.1091 20.5096C50.1813 20.518 50.2221 20.4735 50.2461 20.4078C50.311 20.2356 50.4943 19.7198 50.5295 19.6171Z"
          fill="white"
        />
        <path
          d="M41.2394 17.0126C41.119 16.9756 41.0098 16.9506 40.8672 16.9237C40.7227 16.8978 40.5505 16.8848 40.3552 16.8848C39.6737 16.8848 39.1366 17.0774 38.7598 17.4571C38.3848 17.8348 38.1302 18.4098 38.0024 19.1663L37.9561 19.421H37.1005C37.1005 19.421 36.9968 19.4173 36.9746 19.5302L36.8348 20.3145C36.8246 20.3885 36.857 20.4358 36.957 20.4358H37.7894L36.945 25.1506C36.8792 25.5302 36.8033 25.8423 36.719 26.0793C36.6366 26.3126 36.5561 26.4876 36.4561 26.6154C36.3598 26.7376 36.269 26.8284 36.1116 26.8811C35.982 26.9247 35.832 26.945 35.6681 26.945C35.5774 26.945 35.4561 26.9302 35.3663 26.9117C35.2774 26.8941 35.2302 26.8747 35.1626 26.846C35.1626 26.846 35.0653 26.8089 35.0265 26.9061C34.9959 26.9867 34.7737 27.5969 34.7468 27.6719C34.7209 27.7469 34.7579 27.8052 34.8052 27.8228C34.9163 27.8617 34.9987 27.8876 35.1496 27.9237C35.3589 27.9728 35.5357 27.9756 35.7014 27.9756C36.0477 27.9756 36.3644 27.9265 36.6264 27.8321C36.8894 27.7367 37.119 27.571 37.3227 27.3469C37.5422 27.1043 37.6802 26.8506 37.8116 26.5034C37.9422 26.1608 38.0542 25.7348 38.1431 25.2385L38.9922 20.4358H40.2329C40.2329 20.4358 40.3376 20.4395 40.3589 20.3256L40.4996 19.5423C40.5089 19.4673 40.4774 19.421 40.3765 19.421H39.1718C39.1783 19.3941 39.2329 18.97 39.3709 18.571C39.4302 18.4015 39.5413 18.2635 39.6348 18.1691C39.7274 18.0765 39.8339 18.0108 39.9505 17.9728C40.07 17.9339 40.2061 17.9154 40.3552 17.9154C40.4681 17.9154 40.5802 17.9284 40.6644 17.946C40.7811 17.971 40.8264 17.9839 40.857 17.9932C40.9802 18.0302 40.9968 17.9941 41.0209 17.9348L41.3089 17.1441C41.3385 17.0589 41.2653 17.0228 41.2394 17.0126Z"
          fill="white"
        />
        <path
          d="M24.4062 25.1605C24.4062 25.2235 24.3609 25.2744 24.2979 25.2744H23.2988C23.2359 25.2744 23.1914 25.2235 23.1914 25.1605V17.1198C23.1914 17.0568 23.2359 17.0059 23.2988 17.0059H24.2979C24.3609 17.0059 24.4062 17.0568 24.4062 17.1198V25.1605Z"
          fill="white"
        />
        <path
          d="M56.9595 64.2554C56.4489 64.2554 56.0063 64.176 55.6319 64.0171C55.2574 63.8583 54.9681 63.5916 54.7638 63.2171C54.5709 62.8313 54.4744 62.315 54.4744 61.6682V56.8852H52.9766V55.6767H54.4744L54.6617 53.6001H55.9042V55.6767H58.3893V56.8852H55.9042V61.6682C55.9042 62.2015 56.012 62.5646 56.2276 62.7575C56.4432 62.9391 56.8234 63.0299 57.3681 63.0299H58.2872V64.2554H56.9595Z"
          fill="#5F6583"
        />
        <path
          d="M48.5115 64.4594C47.7171 64.4594 47.0022 64.2778 46.3668 63.9147C45.7313 63.5403 45.232 63.0183 44.8689 62.3488C44.5058 61.6679 44.3242 60.8793 44.3242 59.9828C44.3242 59.0637 44.5058 58.2693 44.8689 57.5998C45.2434 56.919 45.7483 56.397 46.3838 56.0339C47.0306 55.6594 47.7512 55.4722 48.5455 55.4722C49.3625 55.4722 50.0831 55.6594 50.7072 56.0339C51.3427 56.397 51.8419 56.919 52.2051 57.5998C52.5795 58.2693 52.7668 59.058 52.7668 59.9658C52.7668 60.8736 52.5795 61.6679 52.2051 62.3488C51.8306 63.0183 51.3256 63.5403 50.6902 63.9147C50.0547 64.2778 49.3285 64.4594 48.5115 64.4594ZM48.5285 63.2339C49.0164 63.2339 49.4703 63.1147 49.8902 62.8764C50.31 62.6268 50.6505 62.258 50.9115 61.77C51.1724 61.2821 51.3029 60.6807 51.3029 59.9658C51.3029 59.2395 51.1724 58.6381 50.9115 58.1615C50.6618 57.6736 50.3271 57.3105 49.9072 57.0722C49.4987 56.8225 49.0448 56.6977 48.5455 56.6977C48.0689 56.6977 47.615 56.8225 47.1838 57.0722C46.7639 57.3105 46.4235 57.6736 46.1625 58.1615C45.9129 58.6381 45.788 59.2395 45.788 59.9658C45.788 60.6807 45.9129 61.2821 46.1625 61.77C46.4235 62.258 46.7583 62.6268 47.1668 62.8764C47.5866 63.1147 48.0405 63.2339 48.5285 63.2339Z"
          fill="#5F6583"
        />
        <path
          d="M38.6571 64.4596C37.8287 64.4596 37.0968 64.2667 36.4614 63.8808C35.8372 63.4837 35.355 62.9447 35.0145 62.2638C34.6741 61.583 34.5039 60.8113 34.5039 59.9489C34.5039 59.0865 34.6741 58.3206 35.0145 57.6511C35.355 56.9702 35.8372 56.4369 36.4614 56.0511C37.0968 55.6652 37.8344 55.4723 38.6741 55.4723C39.3663 55.4723 39.9734 55.6142 40.4954 55.8979C41.0287 56.1816 41.4429 56.5787 41.7379 57.0894V52H43.1677V64.2553H41.8741L41.7379 62.8426C41.5564 63.1262 41.3238 63.3929 41.0401 63.6426C40.7564 63.8808 40.416 64.0794 40.0188 64.2383C39.633 64.3858 39.1791 64.4596 38.6571 64.4596ZM38.8103 63.217C39.3777 63.217 39.877 63.0808 40.3082 62.8085C40.7394 62.5362 41.0741 62.1617 41.3124 61.6851C41.5621 61.1972 41.6869 60.6241 41.6869 59.966C41.6869 59.3191 41.5621 58.7518 41.3124 58.2638C41.0741 57.7759 40.7394 57.3957 40.3082 57.1234C39.877 56.8511 39.3777 56.7149 38.8103 56.7149C38.2656 56.7149 37.772 56.8511 37.3294 57.1234C36.8982 57.3957 36.5635 57.7759 36.3252 58.2638C36.0869 58.7518 35.9677 59.3191 35.9677 59.966C35.9677 60.6241 36.0869 61.1972 36.3252 61.6851C36.5635 62.1617 36.8982 62.5362 37.3294 62.8085C37.772 63.0808 38.2656 63.217 38.8103 63.217Z"
          fill="#5F6583"
        />
        <path
          d="M29.7266 64.2551V55.6764H31.0202L31.1223 57.3105C31.3152 56.9246 31.5592 56.5956 31.8542 56.3232C32.1606 56.0509 32.5237 55.841 32.9436 55.6934C33.3748 55.5459 33.8627 55.4722 34.4074 55.4722V56.97H33.8798C33.5166 56.97 33.1705 57.0211 32.8415 57.1232C32.5124 57.214 32.2173 57.3672 31.9564 57.5828C31.7067 57.7984 31.5081 58.0934 31.3606 58.4679C31.2244 58.831 31.1563 59.2849 31.1563 59.8296V64.2551H29.7266Z"
          fill="#5F6583"
        />
        <path
          d="M24.111 64.4594C23.4188 64.4594 22.8401 64.3403 22.3748 64.102C21.9096 63.8523 21.5635 63.5289 21.3365 63.1317C21.1096 62.7232 20.9961 62.2807 20.9961 61.8041C20.9961 61.2254 21.1436 60.7374 21.4386 60.3403C21.745 59.9317 22.1706 59.6254 22.7152 59.4211C23.2713 59.2055 23.9238 59.0977 24.6727 59.0977H26.9365C26.9365 58.5644 26.8514 58.1218 26.6812 57.77C26.5223 57.4069 26.284 57.1346 25.9663 56.953C25.6599 56.7715 25.2741 56.6807 24.8089 56.6807C24.2642 56.6807 23.7933 56.8168 23.3961 57.0892C22.9989 57.3615 22.755 57.7644 22.6642 58.2977H21.2003C21.2684 57.6849 21.4727 57.1743 21.8131 56.7658C22.1649 56.3459 22.6074 56.0282 23.1408 55.8126C23.6741 55.5856 24.2301 55.4722 24.8089 55.4722C25.6032 55.4722 26.2613 55.6197 26.7833 55.9147C27.3167 56.1984 27.7138 56.6012 27.9748 57.1232C28.2358 57.6339 28.3663 58.241 28.3663 58.9445V64.2551H27.0897L27.0046 62.7403C26.8911 62.9785 26.7436 63.2055 26.5621 63.4211C26.3918 63.6254 26.1876 63.8069 25.9493 63.9658C25.7223 64.1133 25.4557 64.2325 25.1493 64.3232C24.8429 64.414 24.4968 64.4594 24.111 64.4594ZM24.3323 63.2509C24.7294 63.2509 25.0869 63.1715 25.4046 63.0126C25.7337 62.8424 26.0117 62.6154 26.2386 62.3317C26.4656 62.0367 26.6358 61.7133 26.7493 61.3615C26.8741 61.0098 26.9365 60.641 26.9365 60.2551V60.2041H24.7918C24.2358 60.2041 23.7876 60.2722 23.4472 60.4083C23.1067 60.5332 22.8628 60.7147 22.7152 60.953C22.5677 61.18 22.494 61.441 22.494 61.736C22.494 62.0424 22.5621 62.309 22.6982 62.536C22.8457 62.7629 23.0557 62.9388 23.328 63.0637C23.6117 63.1885 23.9464 63.2509 24.3323 63.2509Z"
          fill="#5F6583"
        />
        <path
          d="M11.5 67.9998V55.6764H12.7936L12.9128 57.0722C13.0943 56.7998 13.327 56.5445 13.6106 56.3062C13.8943 56.0566 14.2348 55.858 14.6319 55.7105C15.0291 55.5516 15.4887 55.4722 16.0106 55.4722C16.839 55.4722 17.5596 55.6707 18.1723 56.0679C18.7965 56.4651 19.2787 57.0041 19.6191 57.6849C19.9709 58.3544 20.1468 59.1204 20.1468 59.9828C20.1468 60.8452 19.9709 61.6168 19.6191 62.2977C19.2787 62.9672 18.7965 63.4949 18.1723 63.8807C17.5482 64.2665 16.822 64.4594 15.9936 64.4594C15.3014 64.4594 14.6887 64.3176 14.1553 64.0339C13.622 63.7502 13.2135 63.353 12.9298 62.8424V67.9998H11.5ZM15.8234 63.2168C16.3794 63.2168 16.873 63.0807 17.3043 62.8083C17.7468 62.536 18.0872 62.1615 18.3255 61.6849C18.5752 61.197 18.7 60.6239 18.7 59.9658C18.7 59.319 18.5752 58.7516 18.3255 58.2637C18.0872 57.7757 17.7468 57.3956 17.3043 57.1232C16.873 56.8509 16.3794 56.7147 15.8234 56.7147C15.256 56.7147 14.7567 56.8509 14.3255 57.1232C13.8943 57.3956 13.5596 57.7757 13.3213 58.2637C13.083 58.7516 12.9638 59.319 12.9638 59.9658C12.9638 60.6239 13.083 61.197 13.3213 61.6849C13.5596 62.1615 13.8943 62.536 14.3255 62.8083C14.7567 63.0807 15.256 63.2168 15.8234 63.2168Z"
          fill="#5F6583"
        />
      </svg>
    </>
  );
};
export const CloudConvertIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46942)">
          <path
            d="M10.8187 57.9373H60.1584C60.1584 57.9373 70.7687 56.0114 69.9633 44.7708C69.1579 33.5301 64.3605 30.3786 62.1544 29.4331C62.1544 29.4331 59.423 17.0369 48.1824 19.4881C48.1824 19.4881 45.8362 12.5547 36.8717 12.0294C27.9072 11.5041 25.8062 18.1925 25.8062 18.1925C25.8062 18.1925 12.1143 13.5351 8.75267 29.9934C8.75267 29.9934 -1.54248 34.3355 0.173376 45.9964C1.88923 57.6572 10.8187 57.9373 10.8187 57.9373Z"
            fill="url(#paint0_linear_1225_46942)"
          />
          <path
            d="M10.4671 54.0156H60.332C60.332 54.0156 66.9853 51.2142 66.355 43.1252C65.7247 35.0361 61.8728 32.6549 58.4411 32.725C58.4411 32.725 56.7952 17.8425 46.325 24.2857C46.325 24.2857 43.8037 16.4768 36.8002 15.7765C29.7967 15.0761 27.1354 23.5504 27.1354 23.5504C27.1354 23.5504 14.1789 14.726 12.393 33.6704C12.393 33.6704 6.72021 32.0596 4.40905 40.9191C3.84877 43.0201 3.74372 45.2612 4.19895 47.3973C4.79424 50.0236 6.37003 53.2102 10.4671 54.0156Z"
            fill="url(#paint1_linear_1225_46942)"
          />
          <path
            d="M23.5312 35.6115L28.2936 37.1172C28.2936 37.1172 30.7449 27.7676 39.7093 33.6155L37.3281 36.0317L47.1331 38.3078L45.2771 28.2578L42.8959 30.3238C42.8959 30.2888 31.095 20.0637 23.5312 35.6115Z"
            fill="url(#paint2_linear_1225_46942)"
          />
          <path
            d="M47.1331 42.0547L42.3707 40.549C42.3707 40.549 39.9194 49.8987 30.955 44.0507L33.3362 41.6345L23.5312 39.3584L25.3872 49.4084L27.7684 47.3424C27.7684 47.3424 39.5343 57.5675 47.1331 42.0547Z"
            fill="url(#paint3_linear_1225_46942)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1225_46942"
            x1="3.62519"
            y1="4.15953"
            x2="45.0067"
            y2="55.6809"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#717171" />
            <stop offset="1" stop-color="#282828" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1225_46942"
            x1="17.7636"
            y1="21.9716"
            x2="50.2833"
            y2="62.4598"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#F2F2F2" />
            <stop offset="1" stop-color="#C5C5C5" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1225_46942"
            x1="30.6708"
            y1="27.2934"
            x2="42.4968"
            y2="42.017"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#EB5D59" />
            <stop offset="1" stop-color="#C94542" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1225_46942"
            x1="28.1535"
            y1="35.6215"
            x2="39.9794"
            y2="50.3452"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#B73937" />
            <stop offset="1" stop-color="#A82E2D" />
          </linearGradient>
          <clipPath id="clip0_1225_46942">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ProcessStreetIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46776)">
          <path
            d="M48.9035 16.2864C49.5629 16.0666 50.1124 15.7369 50.5519 15.2974L38.2436 3.42864C37.2546 2.43959 35.9358 2 34.5072 2C33.0785 2 31.7598 2.54948 30.7707 3.42864L1.53854 31.3421C0.549479 32.3312 0 33.54 0 34.9686C0 36.2874 0.549479 37.6061 1.53854 38.5952L11.2093 47.9363C11.6489 47.3868 12.4182 46.6176 12.8578 45.9582C13.2974 45.2988 13.8468 44.7493 14.2864 44.3098C20.2208 36.8369 27.2541 30.2431 35.0567 24.5286C39.4525 21.4515 44.0681 18.7041 48.9035 16.2864Z"
            fill="#3A94D1"
          />
          <path
            d="M68.3535 32.441L54.0671 18.7041C53.7374 19.1437 53.2978 19.4734 52.8582 19.6932L53.2978 19.2536C52.089 20.2426 51.0999 21.2317 50.1109 22.2208C42.9676 28.9244 36.9234 36.6171 32.3078 45.079C29.6703 49.4748 27.5823 54.0905 26.0437 58.816C25.824 59.0357 26.0437 59.0357 25.824 59.2555C25.6042 59.805 25.1646 60.4644 25.0547 60.904L31.8682 67.4977C32.8573 68.3769 34.176 68.9263 35.6047 68.9263C37.0333 68.9263 38.352 68.3769 39.3411 67.4977L68.5733 39.4743C69.0129 39.0348 69.4525 38.4853 69.6723 37.8259C69.8921 37.1665 70.0019 36.6171 70.0019 35.9577C70.0019 35.2983 69.7822 34.6389 69.5624 34.0895C69.2327 33.4301 68.7931 32.8806 68.3535 32.441Z"
            fill="#3A94D1"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46776">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const ZOHODeskIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.0524 70C8.66606 70 8.25557 69.8793 7.91752 69.6619C7.24143 69.2273 6.90338 68.4305 7.02411 67.6337L12.8917 31.5833C13.2056 29.6516 14.1955 27.9131 15.6685 26.6575C17.1414 25.4019 19.0489 24.7016 20.9806 24.7016H45.1511L46.5032 16.4195H44.2335C43.2194 16.4195 42.2776 15.9848 41.6257 15.2121C40.9738 14.4395 40.684 13.4495 40.853 12.4595L42.3984 2.8734C42.664 1.20731 44.0886 0 45.7789 0H54.7854C57.2 0 59.4698 1.06244 61.0393 2.89755C62.6088 4.73267 63.2849 7.14729 62.8986 9.53777L59.2766 31.8489C59.1076 32.8148 58.5522 33.684 57.7071 34.2152L37.4725 46.6989C36.2411 47.4474 34.6716 47.375 33.5367 46.4574L24.1197 38.9479C23.2262 38.2477 23.0814 36.9438 23.8058 36.0745C24.506 35.1811 25.8099 35.0362 26.6792 35.7606L35.734 42.9803L55.2925 30.8589L58.8661 8.86168C59.0593 7.67851 58.7212 6.4712 57.9486 5.55364C57.1759 4.63608 56.041 4.10486 54.8337 4.10486H46.4067L45.0786 12.3146H47.3242C48.3384 12.3146 49.2801 12.7492 49.932 13.5219C50.584 14.2946 50.8737 15.2846 50.7047 16.2746L49.1352 25.9089C48.8696 27.575 47.4449 28.7823 45.7547 28.7823H20.9806C18.9524 28.7823 17.2621 30.2311 16.9241 32.2353L11.7809 63.8427L19.0007 59.3756C19.5319 59.0376 20.1597 58.8686 20.8116 58.8686H47.2518C49.2801 58.8686 50.9703 57.4198 51.3083 55.4157L52.9503 45.2984C53.1435 44.1876 54.1818 43.415 55.2925 43.6081C56.4032 43.8013 57.1759 44.8396 56.9827 45.9503L55.3408 56.0676C55.0269 57.9993 54.0369 59.7378 52.564 60.9934C51.091 62.2491 49.1835 62.9493 47.2518 62.9493H20.9806L10.1148 69.6861C9.80093 69.9034 9.41459 70 9.0524 70Z"
          fill="#089949"
        />
      </svg>
    </>
  );
};
export const MicrosoftOutlookIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M69.9998 36.1861C70.0036 35.6387 69.7208 35.1293 69.2542 34.8431H69.2461L69.2167 34.8268L44.9609 20.4687C44.8562 20.3979 44.7475 20.3332 44.6353 20.275C43.6988 19.7918 42.5863 19.7918 41.6498 20.275C41.5376 20.3333 41.4289 20.3979 41.3242 20.4687L17.0684 34.8268L17.0392 34.8431C16.2978 35.3041 16.0705 36.2788 16.5315 37.0201C16.6674 37.2386 16.8545 37.4205 17.0766 37.5503L41.3324 51.9084C41.4375 51.9786 41.5462 52.0433 41.658 52.1022C42.5945 52.5853 43.707 52.5853 44.6436 52.1022C44.7554 52.0433 44.864 51.9786 44.9692 51.9084L69.225 37.5503C69.7095 37.2678 70.0053 36.747 69.9998 36.1861Z"
          fill="#0A2767"
        />
        <path
          d="M19.8973 26.5993H35.815V41.1902H19.8973V26.5993ZM66.7452 11.7674V5.09301C66.7835 3.42425 65.4626 2.03999 63.7939 2H22.4874C20.8186 2.03999 19.4977 3.42425 19.536 5.09301V11.7674L43.9545 18.279L66.7452 11.7674Z"
          fill="#0364B8"
        />
        <path
          d="M19.5352 11.7676H35.8142V26.4187H19.5352V11.7676Z"
          fill="#0078D4"
        />
        <path
          d="M52.0916 11.7676H35.8125V26.4187L52.0916 41.0699H66.7427V26.4187L52.0916 11.7676Z"
          fill="#28A8EA"
        />
        <path
          d="M35.8125 26.4185H52.0915V41.0696H35.8125V26.4185Z"
          fill="#0078D4"
        />
        <path
          d="M35.8125 41.0698H52.0915V55.721H35.8125V41.0698Z"
          fill="#0364B8"
        />
        <path
          d="M19.8945 41.1904H35.8122V54.4546H19.8945V41.1904Z"
          fill="#14447D"
        />
        <path
          d="M52.0938 41.0698H66.7449V55.721H52.0938V41.0698Z"
          fill="#0078D4"
        />
        <path
          d="M69.2527 37.4607L69.2217 37.477L44.9659 51.1188C44.8601 51.1839 44.7527 51.2458 44.6403 51.3011C44.2283 51.4973 43.7809 51.6081 43.325 51.6267L41.9999 50.8518C41.8879 50.7956 41.7792 50.7331 41.6743 50.6646L17.0929 36.6353H17.0815L16.2773 36.186V63.8018C16.2899 65.6443 17.7932 67.128 19.6357 67.1163H66.6919C66.7196 67.1163 66.744 67.1032 66.7733 67.1032C67.1625 67.0783 67.5462 66.9983 67.9128 66.8656C68.0713 66.7984 68.2243 66.719 68.3703 66.6279C68.4794 66.566 68.6666 66.4309 68.6666 66.4309C69.5005 65.8138 69.9941 64.8393 69.9982 63.8019V36.186C69.9977 36.7142 69.7128 37.2013 69.2527 37.4607Z"
          fill="url(#paint0_linear_1225_46797)"
        />
        <path
          opacity="0.5"
          d="M68.6988 36.0769V37.77L43.3361 55.2325L17.0779 36.6467C17.0779 36.6377 17.0706 36.6304 17.0616 36.6304L14.6523 35.1816V33.9606L15.6454 33.9443L17.7454 35.149L17.7942 35.1653L17.9732 35.2792C17.9732 35.2792 42.6523 49.3606 42.7174 49.3932L43.6616 49.9466C43.743 49.9141 43.8244 49.8815 43.922 49.849C43.9709 49.8164 68.422 36.0606 68.422 36.0606L68.6988 36.0769Z"
          fill="#0A2767"
        />
        <path
          d="M69.2526 37.4607L69.2217 37.4786L44.9659 51.1204C44.8601 51.1855 44.7526 51.2474 44.6403 51.3027C43.6983 51.7629 42.5967 51.7629 41.6547 51.3027C41.5431 51.2475 41.4345 51.1866 41.3291 51.1204L17.0734 37.4786L17.0441 37.4607C16.5758 37.2068 16.2822 36.7187 16.2773 36.186V63.8018C16.289 65.644 17.7918 67.1279 19.6339 67.1163C19.6339 67.1163 19.634 67.1163 19.6341 67.1163H66.6415C68.4836 67.128 69.9865 65.6441 69.9982 63.802C69.9982 63.802 69.9982 63.8019 69.9982 63.8018V36.186C69.9976 36.7142 69.7127 37.2013 69.2526 37.4607Z"
          fill="#1490DF"
        />
        <path
          opacity="0.1"
          d="M45.3197 50.9185L44.9567 51.1219C44.8515 51.1889 44.7428 51.2504 44.6311 51.3059C44.2311 51.5022 43.7962 51.6173 43.3516 51.6445L52.5802 62.558L68.6785 66.4373C69.1197 66.1041 69.4705 65.6659 69.6992 65.1626L45.3197 50.9185Z"
          fill="black"
        />
        <path
          opacity="0.05"
          d="M46.9639 49.9941L44.9567 51.1223C44.8515 51.1892 44.7428 51.2507 44.6311 51.3062C44.2311 51.5025 43.7962 51.6176 43.3516 51.6448L47.6753 63.566L68.6834 66.4327C69.511 65.8113 69.9982 64.8369 69.9987 63.802V63.4455L46.9639 49.9941Z"
          fill="black"
        />
        <path
          d="M19.6797 67.1162H66.6366C67.3591 67.1199 68.0639 66.8917 68.647 66.4651L41.9982 50.8551C41.8863 50.7989 41.7775 50.7364 41.6726 50.6679L17.0913 36.6386H17.0799L16.2773 36.186V63.7074C16.2755 65.5883 17.7988 67.1144 19.6797 67.1162Z"
          fill="#28A8EA"
        />
        <path
          opacity="0.1"
          d="M39.068 18.0074V52.7306C39.0651 53.9481 38.3249 55.0423 37.1959 55.4981C36.8462 55.6483 36.4696 55.7259 36.0889 55.726H16.2773V16.6513H19.5332V15.0234H36.089C37.7335 15.0297 39.0645 16.3628 39.068 18.0074Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M37.4401 19.635V54.3582C37.4442 54.7514 37.3609 55.1407 37.1959 55.4977C36.7438 56.612 35.6636 57.3431 34.4611 57.3486H16.2773V16.651H34.4611C34.9334 16.6463 35.3989 16.7641 35.8122 16.9929C36.8101 17.4956 37.4398 18.5176 37.4401 19.635Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M37.4401 19.635V51.1024C37.4322 52.7462 36.1049 54.0786 34.4611 54.0928H16.2773V16.651H34.4611C34.9334 16.6463 35.3989 16.7641 35.8122 16.9929C36.8101 17.4956 37.4398 18.5176 37.4401 19.635Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M35.8122 19.6353V51.1027C35.8105 52.7491 34.4795 54.0851 32.8332 54.0932H16.2773V16.6514H32.8331C34.4793 16.6522 35.8131 17.9875 35.8122 19.6337C35.8122 19.6342 35.8122 19.6348 35.8122 19.6353Z"
          fill="black"
        />
        <path
          d="M2.98394 16.6514H32.83C34.478 16.6514 35.8139 17.9873 35.8139 19.6353V49.4813C35.8139 51.1293 34.478 52.4653 32.83 52.4653H2.98394C1.33594 52.4653 0 51.1293 0 49.4813V19.6353C0 17.9873 1.33598 16.6514 2.98394 16.6514Z"
          fill="url(#paint1_linear_1225_46797)"
        />
        <path
          d="M9.32734 29.1663C10.0628 27.5994 11.2499 26.2881 12.7362 25.401C14.3822 24.4586 16.2563 23.9888 18.1522 24.0433C19.9094 24.0052 21.6433 24.4506 23.1646 25.331C24.5949 26.1839 25.7468 27.4337 26.4806 28.9286C27.2797 30.5759 27.678 32.3888 27.6429 34.2193C27.6817 36.1324 27.2719 38.028 26.4464 39.7542C25.6952 41.3026 24.5067 42.5969 23.0278 43.4772C21.4479 44.3845 19.6497 44.8417 17.8283 44.7991C16.0336 44.8424 14.2614 44.3919 12.7053 43.4968C11.2626 42.6427 10.0962 41.3915 9.34527 39.8926C8.5414 38.2691 8.13839 36.4766 8.16993 34.6654C8.13644 32.7686 8.53211 30.8887 9.32734 29.1663ZM12.9608 38.0058C13.3529 38.9964 14.0179 39.8555 14.8785 40.4835C15.7551 41.0962 16.8047 41.4123 17.8738 41.3854C19.0124 41.4304 20.1347 41.1036 21.071 40.4542C21.9208 39.8282 22.5682 38.9668 22.9334 37.9765C23.3415 36.8707 23.543 35.6992 23.5275 34.5205C23.5402 33.3306 23.3508 32.1471 22.9675 31.0205C22.629 30.0034 22.0024 29.1064 21.1638 28.4387C20.2509 27.7586 19.1317 27.4136 17.9943 27.4619C16.902 27.4336 15.8289 27.7522 14.929 28.3719C14.0538 29.0025 13.3762 29.8693 12.9755 30.8707C12.0865 33.1663 12.0818 35.7103 12.9624 38.0091L12.9608 38.0058Z"
          fill="white"
        />
        <path
          d="M52.0938 11.7676H66.7449V26.4187H52.0938V11.7676Z"
          fill="#50D9FF"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1225_46797"
            x1="43.1378"
            y1="36.186"
            x2="43.1378"
            y2="67.1163"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#35B8F1" />
            <stop offset="1" stop-color="#28A8EA" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1225_46797"
            x1="6.2216"
            y1="14.3198"
            x2="29.5923"
            y2="54.7969"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1784D9" />
            <stop offset="0.5" stop-color="#107AD5" />
            <stop offset="1" stop-color="#0A63C9" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
export const FreshDeskIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46831)">
          <path
            d="M34.8658 0.000328059H61.1461C62.308 -0.00973285 63.4604 0.211711 64.5358 0.651742C65.6113 1.09177 66.5884 1.74158 67.4101 2.56325C68.2317 3.38491 68.8815 4.36199 69.3216 5.43746C69.7616 6.51294 69.983 7.66527 69.973 8.82724V35.1075C69.9707 44.3544 66.2964 53.2218 59.7579 59.7604C53.2194 66.2989 44.3519 69.9732 35.105 69.9755H34.9067C30.3248 69.9806 25.7867 69.0828 21.5518 67.3333C17.317 65.5839 13.4684 63.0172 10.2259 59.7798C6.9836 56.542 4.41156 52.6967 2.6569 48.4639C0.902237 44.2311 -0.00061517 39.6939 3.14475e-07 35.1118C3.14475e-07 15.7896 15.5845 0.205102 34.8679 0.00679317L34.8658 0.000328059Z"
            fill="#25C16F"
          />
          <path
            d="M34.8658 15.585C30.6165 15.585 26.5412 17.273 23.5365 20.2777C20.5318 23.2824 18.8438 27.3577 18.8438 31.6071V42.5011C18.8756 43.9043 19.4472 45.2412 20.4396 46.2337C21.4321 47.2262 22.769 47.7978 24.1722 47.8296H28.7053V35.3275H22.5836V31.8291C22.9565 25.2396 28.4079 20.0879 35.0081 20.0879C41.6084 20.0879 47.0791 25.2612 47.4326 31.8291V35.3275H41.2311V47.8296H45.3267V48.0279C45.3061 49.3289 44.7801 50.5709 43.86 51.491C42.94 52.4111 41.698 52.9371 40.3969 52.9576H35.5039C35.1073 52.9576 34.6697 53.1559 34.6697 53.5547C34.6912 53.9858 35.0512 54.3695 35.5039 54.3889H40.4336C42.1173 54.3782 43.729 53.7045 44.9196 52.5139C46.1102 51.3234 46.7838 49.7116 46.7946 48.0279V47.6313C47.9636 47.3644 49.0065 46.7067 49.7512 45.7669C50.4958 44.8271 50.8976 43.6614 50.8901 42.4623V31.8075C51.1121 22.7801 43.9557 15.585 34.8658 15.585Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46831">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};  
export const OneDriveIcon = (props) => {
  return (
    <>
      <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_1225_46842"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="13"
          width="70"
          height="44"
        >
          <path
            d="M17.1277 56.875C7.66826 56.875 0 49.3664 0 40.1041C0 31.0452 7.33517 23.6642 16.5072 23.3441C20.2898 17.2193 27.1565 13.125 35 13.125C45.1299 13.125 53.6307 19.954 55.9626 29.167C63.7254 29.2257 70 35.4058 70 43.0209C70 50.4278 63.4375 56.875 56.5957 56.8562L17.1277 56.875Z"
            fill="#C4C4C4"
          />
        </mask>
        <g mask="url(#mask0_1225_46842)">
          <path
            d="M17.1278 56.8752C11.7642 56.8752 6.97644 54.4613 3.83594 50.6824L39.4681 35.7295L67.175 51.329C64.7331 54.5149 61.0449 56.8752 56.8751 56.8564C50.5861 56.8752 26.3869 56.8752 17.1278 56.8752Z"
            fill="url(#paint0_linear_1225_46842)"
          />
          <path
            d="M55.9527 29.1265L39.4688 35.7294L67.1756 51.3292C68.9495 49.0143 70.0006 46.138 70.0006 43.0215C70.0006 35.4063 63.7262 29.2262 55.9632 29.1676C55.9597 29.1538 55.9562 29.1402 55.9527 29.1265Z"
            fill="url(#paint1_linear_1225_46842)"
          />
          <path
            d="M15.4531 23.4124L39.4672 35.7291L55.9513 29.1261C53.6045 19.9338 45.114 13.125 34.999 13.125C27.1555 13.125 20.2889 17.2193 16.5062 23.3441C16.1524 23.3566 15.8012 23.3793 15.4531 23.4124Z"
            fill="url(#paint2_linear_1225_46842)"
          />
          <path
            d="M3.83578 50.6817L39.468 35.7288L15.4541 23.4121C6.78009 24.2359 0 31.3945 0 40.1038C0 44.1144 1.43762 47.796 3.83578 50.6817Z"
            fill="url(#paint3_linear_1225_46842)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1225_46842"
            x1="9.68094"
            y1="53.9586"
            x2="59.5669"
            y2="50.9171"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2086B8" />
            <stop offset="1" stopColor="#46D3F6" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1225_46842"
            x1="52.1283"
            y1="43.0212"
            x2="66.0858"
            y2="33.2681"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#1694DB" />
            <stop offset="1" stopColor="#62C3FE" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1225_46842"
            x1="18.6161"
            y1="16.0417"
            x2="51.0417"
            y2="34.8574"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0D3D78" />
            <stop offset="1" stopColor="#063B83" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1225_46842"
            x1="-0.744689"
            y1="43.7497"
            x2="31.8574"
            y2="31.6421"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#16589B" />
            <stop offset="1" stopColor="#1464B7" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
export const SeamlessAIIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M27.7643 22.8744C28.4569 25.6388 30.069 28.1706 32.8278 28.1706C35.5923 28.1706 37.2044 25.6388 37.8913 22.6416C38.8109 22.1818 39.2707 21.2622 39.0436 20.1099C39.0436 19.6501 38.8109 19.1903 38.3511 18.9575C38.5838 15.7332 36.0464 12.9688 32.8221 12.7417C29.5978 13.2015 27.2932 15.966 27.2932 19.1903C26.8334 19.1903 26.3736 19.6501 26.3736 20.3426C26.1522 21.2622 26.8447 22.4089 27.7643 22.8744Z"
          fill="#3361AB"
        />
        <path
          d="M43.4266 31.6221C41.3546 30.7025 39.2827 29.7772 36.978 29.0903H36.7453C36.7453 30.4697 34.6733 38.5304 34.6733 38.5304L33.521 32.0819L34.2135 30.4697L33.0612 29.5501H32.3687L31.4491 30.7025L32.1416 32.3146L30.9893 38.7632C30.9893 38.7632 29.1444 30.4754 28.9173 29.3231H28.6846C26.3799 30.0156 24.308 30.7025 22.236 31.8548C20.8566 33.2342 20.1641 35.0791 20.1641 36.9183C21.3164 38.2977 22.9285 39.6828 24.5407 40.6024V38.9902C24.5407 38.2977 24.7734 37.6108 25.2332 36.9183V41.0622C27.765 42.4416 30.2967 43.1341 33.0612 43.1341C35.5929 43.1341 37.8976 42.6743 40.2023 41.522V37.1454C40.6621 37.8379 40.6621 38.2977 40.6621 39.2173V41.522C42.2743 40.6024 43.8864 39.45 45.2658 38.065V37.8322C45.4985 35.3062 44.806 33.2342 43.4266 31.6221Z"
          fill="#3361AB"
        />
        <path
          d="M61.8438 63.3991L50.099 44.9787C60.6914 35.5386 61.611 19.1901 51.9438 8.59199C42.2767 -2.00614 26.1552 -2.92007 15.5571 6.52004C4.95897 15.9602 4.04505 32.3086 13.7122 42.9068C21.0804 51.1945 32.5925 53.732 42.7251 49.5824L54.4699 68.0028C55.8493 70.0748 58.3867 70.5346 60.4587 69.3822C62.5363 68.0085 63.2232 65.244 61.8438 63.3991ZM42.7308 41.2946C34.2103 46.8236 22.6982 44.2862 17.402 35.5386C12.1058 26.791 14.4104 15.506 23.158 10.2098C31.9113 4.91358 43.1906 7.21826 48.4868 15.9658C51.0186 20.1097 51.9438 25.1789 51.0186 29.7826C49.6392 34.3863 46.8747 38.5301 42.7308 41.2946Z"
          fill="#3361AB"
        />
      </svg>
    </>
  );
};
export const OneDriveNewIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_1225_46842"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="13"
          width="70"
          height="44"
        >
          <path
            d="M17.1277 56.875C7.66826 56.875 0 49.3664 0 40.1041C0 31.0452 7.33517 23.6642 16.5072 23.3441C20.2898 17.2193 27.1565 13.125 35 13.125C45.1299 13.125 53.6307 19.954 55.9626 29.167C63.7254 29.2257 70 35.4058 70 43.0209C70 50.4278 63.4375 56.875 56.5957 56.8562L17.1277 56.875Z"
            fill="#C4C4C4"
          />
        </mask>
        <g mask="url(#mask0_1225_46842)">
          <path
            d="M17.1278 56.8752C11.7642 56.8752 6.97644 54.4613 3.83594 50.6824L39.4681 35.7295L67.175 51.329C64.7331 54.5149 61.0449 56.8752 56.8751 56.8564C50.5861 56.8752 26.3869 56.8752 17.1278 56.8752Z"
            fill="url(#paint0_linear_1225_46842)"
          />
          <path
            d="M55.9527 29.1265L39.4688 35.7294L67.1756 51.3292C68.9495 49.0143 70.0006 46.138 70.0006 43.0215C70.0006 35.4063 63.7262 29.2262 55.9632 29.1676C55.9597 29.1538 55.9562 29.1402 55.9527 29.1265Z"
            fill="url(#paint1_linear_1225_46842)"
          />
          <path
            d="M15.4531 23.4124L39.4672 35.7291L55.9513 29.1261C53.6045 19.9338 45.114 13.125 34.999 13.125C27.1555 13.125 20.2889 17.2193 16.5062 23.3441C16.1524 23.3566 15.8012 23.3793 15.4531 23.4124Z"
            fill="url(#paint2_linear_1225_46842)"
          />
          <path
            d="M3.83578 50.6817L39.468 35.7288L15.4541 23.4121C6.78009 24.2359 0 31.3945 0 40.1038C0 44.1144 1.43762 47.796 3.83578 50.6817Z"
            fill="url(#paint3_linear_1225_46842)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1225_46842"
            x1="9.68094"
            y1="53.9586"
            x2="59.5669"
            y2="50.9171"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#2086B8" />
            <stop offset="1" stop-color="#46D3F6" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1225_46842"
            x1="52.1283"
            y1="43.0212"
            x2="66.0858"
            y2="33.2681"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#1694DB" />
            <stop offset="1" stop-color="#62C3FE" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1225_46842"
            x1="18.6161"
            y1="16.0417"
            x2="51.0417"
            y2="34.8574"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#0D3D78" />
            <stop offset="1" stop-color="#063B83" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1225_46842"
            x1="-0.744689"
            y1="43.7497"
            x2="31.8574"
            y2="31.6421"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#16589B" />
            <stop offset="1" stop-color="#1464B7" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
export const PipDriveIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46872)">
          <path
            d="M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z"
            fill="#017737"
          />
          <path
            d="M30.0005 30.1027C30.0005 33.8901 31.9218 37.9758 36.1499 37.9758C39.2854 37.9758 42.4557 35.5279 42.4557 30.0472C42.4557 25.242 39.9635 22.0162 36.2542 22.0162C33.2317 22.0162 30.0005 24.1394 30.0005 30.1027ZM37.7437 15C45.3247 15 50.4221 21.0042 50.4221 29.9419C50.4221 38.7391 45.0523 44.8808 37.3757 44.8808C33.7156 44.8808 31.3712 43.3132 30.1454 42.1785C30.1541 42.4475 30.1599 42.7488 30.1599 43.0705V55H22.3065V23.2153C22.3065 22.7532 22.1587 22.6069 21.7009 22.6069H19V15.6463H25.5899C28.624 15.6463 29.4006 17.1905 29.5484 18.3809C30.78 17.0004 33.3331 15 37.7437 15Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46872">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const DropboxIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46884)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35 40.1527L20.5909 52.275L0 38.7239L14.2384 27.2321L35 40.1527L55.7611 27.2302L69.9996 38.7241L49.4086 52.2753L35 40.1527ZM20.5914 2.1875L0.000445048 15.7386L14.2389 27.2304L35.0004 14.3099L20.5914 2.1875ZM35.0422 42.7608L20.5916 54.8479L14.4075 50.7777V55.3396L35.0422 67.8125L55.6769 55.3396V50.7777L49.4928 54.8479L35.0422 42.7608ZM70 15.7388L49.4091 2.18772L35.0004 14.3099L55.7611 27.2302L70 15.7388Z"
            fill="#0F82E2"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46884">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const FreshsalesIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1225_46895)">
          <path
            d="M34.7449 0H60.8825C65.7632 0 69.6807 3.8532 69.6807 8.79815V34.9358C69.6807 54.1376 54.1394 69.6789 34.9376 69.6789H34.7449C15.5431 69.6789 0.00177211 54.1376 0.00177211 34.9358C-0.190888 15.7339 15.3504 0.192661 34.5522 0H34.7449Z"
            fill="#FFA800"
          />
          <path
            d="M35.1946 17.4038C39.0478 17.4038 42.1303 20.4864 42.1303 24.3396C42.1303 28.1928 39.0478 31.2754 35.1946 31.2754C31.3413 31.2754 28.2588 28.1928 28.2588 24.3396C28.1946 20.4864 31.3413 17.4038 35.1946 17.4038Z"
            fill="white"
          />
          <path
            d="M19.8438 33.5229L31.9171 45.5964V52.3395H37.8254V45.5964L49.8988 33.5229H19.8438Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1225_46895">
            <rect width="70" height="70" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const MicrosoftExcelIcon = (props) => {
  return (
    <>
      <svg
        {...props}
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M43.9518 32.9306L16.2773 28.0469V64.1327C16.2773 65.7807 17.6133 67.1166 19.2613 67.1166H67.0143C68.6623 67.1166 69.9983 65.7807 69.9983 64.1327V50.8376L43.9518 32.9306Z"
          fill="#185C37"
        />
        <path
          d="M43.9518 2H19.2613C17.6133 2 16.2773 3.33595 16.2773 4.98395V18.2791L43.9518 34.5581L58.6029 39.4419L69.9983 34.5581V18.2791L43.9518 2Z"
          fill="#21A366"
        />
        <path
          d="M16.2773 18.2793H43.9518V34.5584H16.2773V18.2793Z"
          fill="#107C41"
        />
        <path
          opacity="0.1"
          d="M36.0841 15.0234H16.2773V55.7211H36.0841C37.7299 55.7158 39.0627 54.3829 39.068 52.7372V18.0074C39.0627 16.3616 37.7299 15.0288 36.0841 15.0234Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M34.4562 16.6514H16.2773V57.349H34.4562C36.1019 57.3437 37.4348 56.0109 37.4401 54.3651V19.6353C37.4348 17.9896 36.1019 16.6567 34.4562 16.6514Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M34.4562 16.6514H16.2773V54.0932H34.4562C36.1019 54.0879 37.4348 52.755 37.4401 51.1093V19.6353C37.4348 17.9896 36.1019 16.6567 34.4562 16.6514Z"
          fill="black"
        />
        <path
          opacity="0.2"
          d="M32.8283 16.6514H16.2773V54.0932H32.8283C34.474 54.0879 35.8069 52.755 35.8122 51.1093V19.6353C35.8069 17.9896 34.474 16.6567 32.8283 16.6514Z"
          fill="black"
        />
        <path
          d="M2.98395 16.6514H32.83C34.478 16.6514 35.8139 17.9873 35.8139 19.6353V49.4813C35.8139 51.1293 34.478 52.4653 32.83 52.4653H2.98395C1.33595 52.4653 0 51.1294 0 49.4814V19.6353C0 17.9873 1.33595 16.6514 2.98395 16.6514Z"
          fill="url(#paint0_linear_1225_46907)"
        />
        <path
          d="M9.24219 44.2572L15.5194 34.5305L9.76801 24.8574H14.3945L17.5331 31.0435C17.8229 31.6311 18.0215 32.0674 18.1289 32.3555H18.1696C18.3758 31.8867 18.5929 31.4314 18.8208 30.9897L22.1759 24.8607H26.4231L20.5252 34.4767L26.5729 44.2572H22.0538L18.4285 37.4672C18.2577 37.1783 18.1128 36.8749 17.9955 36.5605H17.9418C17.8356 36.8685 17.6946 37.1634 17.5217 37.4395L13.789 44.2572H9.24219Z"
          fill="white"
        />
        <path
          d="M67.0157 2H43.9531V18.2791H69.9996V4.98395C69.9996 3.33595 68.6637 2 67.0157 2Z"
          fill="#33C481"
        />
        <path
          d="M43.9531 34.5586H69.9996V50.8377H43.9531V34.5586Z"
          fill="#107C41"
        />
        <defs>
          <linearGradient
            id="paint0_linear_1225_46907"
            x1="6.22161"
            y1="14.3198"
            x2="29.5923"
            y2="54.7969"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#18884F" />
            <stop offset="0.5" stop-color="#117E43" />
            <stop offset="1" stop-color="#0B6631" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
export const DCDIALLogo = (props) => {
  return (
    <>
      <svg
        {...props}
        width="390"
        height="391"
        viewBox="0 0 390 391"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_f_1867_68833)">
          <rect
            x="120"
            y="120.378"
            width="60"
            height="60"
            rx="30"
            fill="url(#paint0_linear_1867_68833)"
          />
        </g>
        <g filter="url(#filter1_f_1867_68833)">
          <rect
            x="210"
            y="210.051"
            width="60"
            height="60"
            rx="30"
            fill="url(#paint1_linear_1867_68833)"
          />
        </g>
        <rect x="132" y="132.378" width="126" height="126" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M195.348 120.051L263.153 125.963L230.543 159.409H160.069L127.543 125.963L195.348 120.051Z"
          fill="#FDD12F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M195.348 270.051L127.543 264.307L160.069 230.861H230.543L263.153 264.307L195.348 270.051Z"
          fill="#39C84F"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M121.199 195.135L127.538 125.963L160.064 159.409V230.862L127.538 264.308L121.199 195.135Z"
          fill="#00A0FC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M269.309 195.135L263.137 125.963L230.527 159.409V230.862L263.137 264.308L269.309 195.135Z"
          fill="#C51F25"
        />
        <defs>
          <filter
            id="filter0_f_1867_68833"
            x="0"
            y="0.37793"
            width="300"
            height="300"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="60"
              result="effect1_foregroundBlur_1867_68833"
            />
          </filter>
          <filter
            id="filter1_f_1867_68833"
            x="90"
            y="90.0508"
            width="300"
            height="300"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="BackgroundImageFix"
              result="shape"
            />
            <feGaussianBlur
              stdDeviation="60"
              result="effect1_foregroundBlur_1867_68833"
            />
          </filter>
          <linearGradient
            id="paint0_linear_1867_68833"
            x1="150"
            y1="120.378"
            x2="150"
            y2="180.378"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#00A0FC" />
            <stop offset="1" stop-color="#39C84F" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1867_68833"
            x1="240"
            y1="210.051"
            x2="240"
            y2="270.051"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#FDD12F" />
            <stop offset="1" stop-color="#C51F25" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
export const DataManagement = (props) => {
  return (
    <>
      <svg
        width="60"
        height="61"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.9509 47.0819C54.9778 47.2092 54.9937 47.338 54.9985 47.468L55 47.5507V50.0507C55 52.8121 49.9632 55.0507 43.75 55.0507C37.5989 55.0507 32.6009 52.8567 32.5015 50.1334L32.5 50.0507V47.5507L32.5015 47.468C32.5062 47.3383 32.5221 47.2098 32.5486 47.0827C33.2377 47.6005 34.0765 48.0781 35.0484 48.487C37.317 49.4413 40.3761 50.0507 43.75 50.0507C47.2577 50.0507 50.4246 49.3911 52.7203 48.3707C53.5784 47.9894 54.3253 47.5525 54.9509 47.0819ZM27.5 4.07568L50 16.5757L50.0001 25.8009C48.1572 25.3278 46.0252 25.0507 43.75 25.0507C40.3236 25.0507 37.2222 25.6806 34.9343 26.6975C31.8015 28.0898 30.2066 30.2192 30.005 32.3741L29.9993 32.4394L30.0136 52.6792L27.5 54.0757L5 41.5757V16.5757L27.5 4.07568ZM54.9509 39.5819C54.9778 39.7092 54.9937 39.838 54.9985 39.968L55 40.0507V42.5507C55 45.3121 49.9632 47.5507 43.75 47.5507C37.5989 47.5507 32.6009 45.3567 32.5015 42.6334L32.5 42.5507V40.0507L32.5015 39.968C32.5062 39.8383 32.5221 39.7098 32.5486 39.5827C33.2377 40.1005 34.0765 40.5781 35.0484 40.987C37.317 41.9413 40.3761 42.5507 43.75 42.5507C47.2577 42.5507 50.4246 41.8911 52.7203 40.8707C53.5784 40.4894 54.3253 40.0525 54.9509 39.5819ZM19.9999 27.4087L20 44.3537L25 47.1316V30.1864L19.9999 27.4087ZM10 21.8533V38.7979L15 41.5758V24.631L10 21.8533ZM43.75 27.5507C49.9011 27.5507 54.8991 29.7447 54.9985 32.468L55 32.5507V35.0507C55 37.8121 49.9632 40.0507 43.75 40.0507C37.5989 40.0507 32.6009 37.8567 32.5015 35.1334L32.5 35.0507V32.5507L32.5166 32.2763C32.8371 29.6425 37.7439 27.5507 43.75 27.5507ZM37.3427 15.0994L22.6264 23.3126L27.5 26.0201L42.25 17.8257L37.3427 15.0994ZM27.5 9.63124L12.75 17.8257L17.6322 20.5381L32.3484 12.3249L27.5 9.63124Z"
          fill="#00A0FC"
        />
      </svg>
    </>
  );
};
export const PersonalizedInsights = (props) => {
  return (
    <>
      <svg
        width="60"
        height="61"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1867_68924)">
          <path
            d="M37.5 24.0508L39.87 18.8908L45 16.5508L39.87 14.2108L37.5 9.05078L35.22 14.2108L30 16.5508L35.22 18.8908L37.5 24.0508Z"
            fill="#00A0FC"
          />
          <path
            d="M12 30.0508L13.2 25.2508L18 24.0508L13.2 22.8508L12 18.0508L10.8 22.8508L6 24.0508L10.8 25.2508L12 30.0508Z"
            fill="#00A0FC"
          />
          <path
            d="M49.5 18.0508C46.29 18.0508 43.98 21.4108 45.45 24.4708L36.42 33.5008C34.86 32.7508 33.45 33.0808 32.55 33.5008L29.52 30.4708C29.82 29.9008 30 29.2408 30 28.5508C30 26.0608 27.99 24.0508 25.5 24.0508C23.01 24.0508 21 26.0608 21 28.5508C21 29.2408 21.18 29.9008 21.45 30.4708L12.42 39.5008C11.85 39.2308 11.19 39.0508 10.5 39.0508C8.01 39.0508 6 41.0608 6 43.5508C6 46.0408 8.01 48.0508 10.5 48.0508C12.99 48.0508 15 46.0408 15 43.5508C15 42.8608 14.82 42.2008 14.55 41.6308L23.58 32.6008C25.14 33.3508 26.55 33.0208 27.45 32.6008L30.48 35.6308C30.18 36.2008 30 36.8608 30 37.5508C30 40.0408 32.01 42.0508 34.5 42.0508C36.99 42.0508 39 40.0408 39 37.5508C39 36.8608 38.82 36.2008 38.55 35.6308L47.58 26.6008C50.67 28.1008 54 25.7308 54 22.5508C54 20.0608 51.99 18.0508 49.5 18.0508Z"
            fill="#00A0FC"
          />
        </g>
        <defs>
          <clipPath id="clip0_1867_68924">
            <rect
              width="60"
              height="60"
              fill="white"
              transform="translate(0 0.0507812)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
export const MeaningfulInteractions = (props) => {
  return (
    <>
      <svg
        width="60"
        height="61"
        viewBox="0 0 60 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M28.7097 2.1838C25.2644 3.09786 23.4363 7.01193 24.9597 10.2463C27.0691 14.7463 33.4207 14.7697 35.53 10.2932C35.9519 9.42599 35.9753 9.23849 35.9753 7.76193C35.9753 6.3088 35.9519 6.09786 35.5535 5.32443C34.3113 2.79318 31.4285 1.45724 28.7097 2.1838Z"
          fill="#00A0FC"
        />
        <path
          d="M28.6172 15.7074C26.9531 16.059 25.2188 17.1605 24.2578 18.4262C23.0156 20.0668 22.5234 21.684 22.5234 24.2387V25.5746H30.2344H37.9453V23.8871C37.9453 21.098 37.3359 19.4574 35.6484 17.8168C34.5234 16.7152 33.6094 16.1996 32.0859 15.8012C30.8203 15.4496 29.8828 15.4496 28.6172 15.7074Z"
          fill="#00A0FC"
        />
        <path
          d="M29.3918 30.0274C29.1574 30.0977 28.8058 30.3086 28.6183 30.4961C27.8918 31.1758 27.8449 31.3633 27.8449 34.9492V38.3008L24.5402 41.6055C22.7121 43.4336 21.0949 45.1211 20.9074 45.4024C20.2277 46.5039 20.6964 48.0274 21.8918 48.5899C23.298 49.2695 23.7433 49.0117 27.2589 45.5195L30.1652 42.6133L33.3058 45.7305C35.0168 47.4414 36.5636 48.918 36.7511 48.9883C36.9152 49.082 37.3605 49.1524 37.7589 49.1524C39.3527 49.1524 40.3839 47.5586 39.798 46.0352C39.7277 45.8242 38.0402 43.9961 36.048 42.0274L32.4621 38.418V35.3477C32.4621 31.9258 32.3683 31.3399 31.6886 30.6367C31.0558 30.0039 30.2589 29.7695 29.3918 30.0274Z"
          fill="#00A0FC"
        />
        <path
          d="M8.25182 34.7619C7.17369 35.1135 6.58775 35.4885 5.76744 36.3557C3.04869 39.2619 3.98619 43.9729 7.64244 45.6838C8.39244 46.0354 8.65025 46.0823 9.98619 46.0823C11.3924 46.0823 11.5799 46.0588 12.4706 45.6135C14.2518 44.7698 15.4471 43.176 15.7987 41.2073C16.2206 38.7229 14.8846 36.2151 12.5409 35.0666C11.3221 34.4807 9.54088 34.3401 8.25182 34.7619Z"
          fill="#00A0FC"
        />
        <path
          d="M48.4238 34.6918C46.9472 35.0902 45.4472 36.3324 44.7675 37.6918C43.3144 40.6684 44.5566 44.184 47.5566 45.6137C48.4472 46.0356 48.6347 46.0824 50.041 46.0824C51.4706 46.0824 51.6347 46.059 52.5019 45.6137C53.6503 45.0277 54.7988 43.8793 55.3144 42.7543C56.8144 39.4965 55.08 35.7231 51.6347 34.7152C50.6972 34.4574 49.3613 34.434 48.4238 34.6918Z"
          fill="#00A0FC"
        />
        <path
          d="M8.48438 48.168C5.92969 48.6837 3.67969 50.629 2.76563 53.1602C2.50781 53.8165 2.4375 54.4024 2.39062 56.043L2.34375 58.1055H10.0781H17.8125L17.7188 56.254C17.6719 55.2227 17.5312 54.0743 17.3906 53.629C16.2422 49.7618 12.3984 47.3946 8.48438 48.168Z"
          fill="#00A0FC"
        />
        <path
          d="M48.1641 48.2387C46.0547 48.8246 44.25 50.2309 43.2891 52.0355C42.6094 53.3246 42.4219 54.1684 42.3047 56.2543L42.2109 58.1059H49.9219H57.6562V56.3246C57.6562 53.6527 57.1406 52.1762 55.6641 50.5824C54.1172 48.9184 52.5234 48.1684 50.2969 48.0746C49.3828 48.0512 48.7031 48.098 48.1641 48.2387Z"
          fill="#00A0FC"
        />
      </svg>
    </>
  );
};
